
export default [
    {
        "id": 121,
        "shikenId": 3,
        "no": 1,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "ファイナンシャル・プランナーが顧客と投資顧問契約を締結し、当該契約に基づき金融商品取引法で定める投資助言・代理業を行うためには、内閣総理大臣の登録を受けなければならない。(2022.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 122,
        "shikenId": 3,
        "no": 2,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "公的介護保険の第2号被保険者は、市町村または特別区の区域内に住所を有する65歳以上の者である。(2021.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 123,
        "shikenId": 3,
        "no": 3,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "国民年金基金の掛金の額は、 加入員の選択した給付の型や加入口数によって決まり、加入時の年齢や性別によって異なることはない。(2022.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 124,
        "shikenId": 3,
        "no": 4,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "遺族基礎年金を受給することができる遺族は、国民年金の被保険者等の死亡の当時、その者によって生計を維持され、かつ、所定の要件を満たす「子のある配偶者」または「子」である。(2019.01)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 125,
        "shikenId": 3,
        "no": 5,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "日本学生支援機構の奨学金（貸与型）のうち、第一種奨学金は利子が付かない。(2021.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 126,
        "shikenId": 3,
        "no": 6,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "保険業法上の保険募集において、保険募集人が保険契約の締結の媒介を行う場合、保険募集人が保険契約の申込みに対して承諾した時点で当該保険契約は有効に成立する。(2021.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 127,
        "shikenId": 3,
        "no": 7,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "個人年金保険（終身年金）の保険料は、性別以外の契約条件が同一であれば、被保険者が女性のほうが男性よりも高くなる。(2024.01)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 128,
        "shikenId": 3,
        "no": 8,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "自動車保険の人身傷害保険では、被保険者が被保険自動車を運転中、自動車事故により負傷した場合、損害額から自己の過失割合に相当する部分を差し引いた金額が補償の対象となる。(2023.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 129,
        "shikenId": 3,
        "no": 9,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "国内旅行傷害保険では、一般に、国内旅行中にかかった細菌性食中毒は補償の対象とならない。(2022.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 130,
        "shikenId": 3,
        "no": 10,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "リビング・ニーズ特約は、被保険者の余命が6カ月以内と判断された場合に、所定の範囲内で死亡保険金の一部または全部を生前に受け取ることができる特約である。(2021.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 131,
        "shikenId": 3,
        "no": 11,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "全国企業短期経済観測調査（日銀短観）は、企業間で取引される財に関する価格の変動を測定した統計である。(2023.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 132,
        "shikenId": 3,
        "no": 12,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "一般に、日本の金利が一定のときに米国の金利が低下すると、米ドルを円に換える動きが強まり、円安ドル高が進行する要因となる。(2020.01)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 133,
        "shikenId": 3,
        "no": 13,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "インデックスファンドは、日経平均株価や東証株価指数（TOPIX）などの特定の指標に連動することを目指して運用されるファンドである。(2022.01)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 134,
        "shikenId": 3,
        "no": 14,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "上場株式の売買において、普通取引は約定日の翌営業日に決済が行われる。(2021.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 135,
        "shikenId": 3,
        "no": 15,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "2024年以降のNISA制度のつみたて投資枠において、上場株式は投資対象商品とされていない。(2022.09改題)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 136,
        "shikenId": 3,
        "no": 16,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税や住民税は国税であり、固定資産税や登録免許税は地方税である。(2024.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 137,
        "shikenId": 3,
        "no": 17,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "個人が国内において支払を受ける預貯金の利子は、原則として、20.315％の税率により所得税および復興特別所得税と住民税が源泉徴収等され、課税関係が終了する。(2022.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 138,
        "shikenId": 3,
        "no": 18,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "不動産所得の金額の計算上生じた損失の金額のうち、不動産所得を生ずべき業務の用に供する土地を取得するために要した負債の利子の額に相当する部分の金額は、損益通算の対象とならない。(2022.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 139,
        "shikenId": 3,
        "no": 19,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "所得税において、生計を一にする配偶者の合計所得金額が58万円を超える場合、配偶者控除の適用を受けることはできない。(2023.05改題)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 140,
        "shikenId": 3,
        "no": 20,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "給与所得者は、年末調整により、所得税の医療費控除の適用を受けることができる。(2022.01)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 141,
        "shikenId": 3,
        "no": 21,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "土地の登記記録の表題部には、所有権に関する事項が記録される。(2021.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 142,
        "shikenId": 3,
        "no": 22,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "不動産の売買契約において、買主が売主に解約手付を交付した場合、売主は、買主が契約の履行に着手するまでは、受領した解約手付を買主に返還することで、契約の解除をすることができる。(2022.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 143,
        "shikenId": 3,
        "no": 23,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "都市計画区域内にある建築物の敷地は、原則として、建築基準法に規定する道路に2ｍ以上接していなければならない。(2023.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 144,
        "shikenId": 3,
        "no": 24,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "贈与により不動産を取得した場合、不動産取得税は課されない。(2021.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 145,
        "shikenId": 3,
        "no": 25,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "「居住用財産を譲渡した場合の3,000万円の特別控除」は、自己が居住していた家屋を配偶者や子に譲渡した場合には、適用を受けることができない。(2022.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 146,
        "shikenId": 3,
        "no": 26,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "個人間において著しく低い価額の対価で財産の譲渡が行われた場合、原則として、その譲渡があった時の譲受財産の時価と支払った対価との差額に相当する金額について、贈与税の課税対象となる。(2022.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 147,
        "shikenId": 3,
        "no": 27,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "共同相続人は、被相続人が遺言により相続分や遺産分割方法の指定をしていない場合、法定相続分どおりに相続財産を分割しなければならない。(2023.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 148,
        "shikenId": 3,
        "no": 28,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "自筆証書遺言書保管制度を利用して、法務局（遺言書保管所）に保管されている自筆証書遺言については、家庭裁判所による検認の手続を要しない。(2023.05)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 149,
        "shikenId": 3,
        "no": 29,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "法定相続人である被相続人の兄が相続により財産を取得した場合、その者は相続税額の2割加算の対象となる。(2021.09)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 150,
        "shikenId": 3,
        "no": 30,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "相続税額の計算上、死亡保険金の非課税金額の規定による非課税限度額は、「600万円×法定相続人の数」の算式により算出される。(2022.01)",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 151,
        "shikenId": 3,
        "no": 31,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "一定の利率で複利運用しながら一定期間経過後に目標とする額を得るために必要な毎年の積立額を試算する際、目標とする額に乗じる係数は、（  ）である。（2022.09）",
        "choice1": "減債基金係数",
        "choice2": "年金現価係数",
        "choice3": "資本回収係数",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 152,
        "shikenId": 3,
        "no": 32,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "公的介護保険の第2号被保険者は、市町村または特別区の区域内に住所を有する（ ① ）以上（ ② ）未満の医療保険加入者である。（2020.01）",
        "choice1": "① 35歳　　② 65歳",
        "choice2": "① 40歳　　② 60歳",
        "choice3": "① 40歳　　② 65歳",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 153,
        "shikenId": 3,
        "no": 33,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "子のいない障害等級1級に該当する者に支給される障害基礎年金の額は、子のいない障害等級2級に該当する者に支給される障害基礎年金の額の（  ）に相当する額である。（2022.05）",
        "choice1": "0.75倍",
        "choice2": "1.25倍",
        "choice3": "1.75倍",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 154,
        "shikenId": 3,
        "no": 34,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "確定拠出年金の個人型年金の加入者が国民年金の第1号被保険者である場合、原則として、掛金の拠出限度額は年額（  ）である。（2023.01）",
        "choice1": "276,000円",
        "choice2": "816,000円",
        "choice3": "840,000円",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 155,
        "shikenId": 3,
        "no": 35,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "住宅金融支援機構と民間金融機関が提携した住宅ローンであるフラット35（買取型）の融資額は、土地取得費を含めた住宅建設費用または住宅購入価額以内で、最高（①）であり、融資金利は（②）である。（2023.09）",
        "choice1": "① 8,000万円　　② 固定金利",
        "choice2": "① 1億円　　② 固定金利",
        "choice3": "① 1億円　　② 変動金利",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 156,
        "shikenId": 3,
        "no": 36,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "生命保険会社が（   ）を引き下げた場合、通常、その後の終身保険の新規契約の保険料は高くなる。（2022.05）",
        "choice1": "予定利率",
        "choice2": "予定死亡率",
        "choice3": "予定事業費率",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 157,
        "shikenId": 3,
        "no": 37,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "契約転換制度により、現在加入している生命保険契約を新たな契約に転換する場合、転換後契約の保険料は、（ ① ）の年齢に応じた保険料率により算出され、転換時において告知等をする必要が（ ② ）。（2022.05）",
        "choice1": "① 転換前契約の加入時　　② ない",
        "choice2": "① 転換時　　② ない",
        "choice3": "① 転換時　　② ある",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 158,
        "shikenId": 3,
        "no": 38,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "自動車損害賠償責任保険（自賠責保険）において、被害者1人当たりの保険金の支払限度額は、加害車両が1台の場合、死亡による損害については（①）、傷害による損害については（②）である。(2023.09)",
        "choice1": "① 3,000万円　　② 120万円",
        "choice2": "① 3,000万円　　② 150万円",
        "choice3": "① 4,000万円　　② 150万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 159,
        "shikenId": 3,
        "no": 39,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "飲食店において、店舗の床が清掃時の水で濡れていたことにより、来店客が足を滑らせて転倒して骨折し、入院をした。このような場合の損害賠償責任に備える損害保険としては、（   ）が適している。（2020.01）",
        "choice1": "生産物賠償責任保険",
        "choice2": "施設所有（管理）者賠償責任保険",
        "choice3": "受託者賠償責任保険",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 160,
        "shikenId": 3,
        "no": 40,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "医療保険等に付加される先進医療特約では、（   ）時点において厚生労働大臣により定められている先進医療が給付の対象となる。（2021.09）",
        "choice1": "申込日",
        "choice2": "責任開始日",
        "choice3": "療養を受けた日",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 161,
        "shikenId": 3,
        "no": 41,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "わが国の経済指標において、一定期間内に国内で生産された財やサービスの付加価値の合計額を（ ① ）といい、その統計は（ ② ）が作成し、公表している。（2022.05）",
        "choice1": "① マネーストック　　② 日本銀行",
        "choice2": "① 国内総生産（GDP）　　② 日本銀行",
        "choice3": "① 国内総生産（GDP）　　② 内閣府",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 162,
        "shikenId": 3,
        "no": 42,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "表面利率（クーポンレート）3％、残存期間2年の固定利付債券を額面100円当たり105円で購入した場合の最終利回り（年率・単利）は、（   ）である。なお、税金等は考慮しないものとし、計算結果は表示単位の小数点以下第3位を四捨五入している。（2023.09）",
        "choice1": "0.48％",
        "choice2": "0.50％",
        "choice3": "0.53％",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 163,
        "shikenId": 3,
        "no": 43,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "株式の投資指標のうち、ROEは、当期純利益を（   ）で除して求められる。（2022.09）",
        "choice1": "売上高",
        "choice2": "総資産",
        "choice3": "自己資本",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 164,
        "shikenId": 3,
        "no": 44,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "異なる2資産からなるポートフォリオにおいて、2資産間の相関係数が（  ）である場合、分散投資によるリスクの低減効果は最大となる。（2024.01）",
        "choice1": "＋１",
        "choice2": "０",
        "choice3": "ー１",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 165,
        "shikenId": 3,
        "no": 45,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "追加型株式投資信託を基準価額1万3,000円（1万口当たり）で1万口購入した後、最初の決算時に1万口当たり400円の収益分配金が支払われ、分配落ち後の基準価額が1万2,700円（1万口当たり）となった場合、その収益分配金のうち、普通分配金は（①）であり、元本払戻金（特別分配金）は（②）である。（2023.05）",
        "choice1": "① 0円　　② 400円",
        "choice2": "① 100円　　② 300円",
        "choice3": "① 300円　　② 100円",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 166,
        "shikenId": 3,
        "no": 46,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "所得税において、為替予約を締結していない外貨定期預金の満期による為替差益は、（   ）として総合課税の対象となる。（2021.09）",
        "choice1": "利子所得",
        "choice2": "一時所得",
        "choice3": "雑所得",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 167,
        "shikenId": 3,
        "no": 47,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "給与所得者が35年間勤務した会社を定年退職し、退職金3,000万円の支給を受けた場合、退職所得の金額の計算上、退職所得控除額は（  ）となる。(2023.01)",
        "choice1": "{800万円＋70万円×(35年－20年)}×1／2 ＝925万円",
        "choice2": "800万円＋40万円×(35年－20年)＝1,400万円",
        "choice3": "800万円＋70万円×(35年－20年)＝1,850万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 168,
        "shikenId": 3,
        "no": 48,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "所得税において、控除対象扶養親族のうち、その年の12月31日時点の年齢が（ ① ）以上（ ② ）未満である者は、特定扶養親族に該当する。（2023.09）",
        "choice1": "① 16歳　　② 19歳",
        "choice2": "① 18歳　　② 22歳",
        "choice3": "① 19歳　　② 23歳",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 169,
        "shikenId": 3,
        "no": 49,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "青色申告者の所得税の計算において、損益通算してもなお控除しきれない損失の金額（純損失の金額）が生じた場合、所定の要件を満たすことで、その損失の金額を翌年以後（　　）にわたって繰り越して、各年分の所得金額から控除することができる。（2020.01）",
        "choice1": "2年間",
        "choice2": "3年間",
        "choice3": "4年間",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 170,
        "shikenId": 3,
        "no": 50,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "所得税において、上場株式の配当について配当控除の適用を受けるためには、その配当所得について（   ）を選択する必要がある。（2023.01）",
        "choice1": "総合課税",
        "choice2": "申告分離課税",
        "choice3": "確定申告不要制度",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 171,
        "shikenId": 3,
        "no": 51,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "借地借家法によれば、定期建物賃貸借契約（定期借家契約）の賃貸借期間が1年以上である場合、賃貸人は、原則として、期間満了の1年前から（   ）前までの間に、賃借人に対して期間満了により契約が終了する旨の通知をしなければ、その終了を賃借人に対抗することができない。（2023.05）",
        "choice1": "1カ月",
        "choice2": "3カ月",
        "choice3": "6カ月",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 172,
        "shikenId": 3,
        "no": 52,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "建築基準法によれば、第一種低層住居専用地域内の建築物の高さは、原則として（   ）のうち当該地域に関する都市計画において定められた建築物の高さの限度を超えてはならないとされている。（2023.05）",
        "choice1": "10ｍまたは12ｍ",
        "choice2": "10ｍまたは20ｍ",
        "choice3": "12ｍまたは15ｍ",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 173,
        "shikenId": 3,
        "no": 53,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "個人が土地を譲渡したことによる譲渡所得の金額の計算において、譲渡した土地の取得費が不明である場合、譲渡収入金額の（）相当額を取得費とすることができる。(2021.05)",
        "choice1": "5％",
        "choice2": "10％",
        "choice3": "15％",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 174,
        "shikenId": 3,
        "no": 54,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "固定資産税における小規模住宅用地（住宅用地で住宅1戸につき200㎡以下の部分）の課税標準については、当該住宅用地に係る固定資産税の課税標準となるべき価格の（  ）の額とする特例がある。(2022.09)",
        "choice1": "２分の１",
        "choice2": "４分の１",
        "choice3": "６分の１",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 175,
        "shikenId": 3,
        "no": 55,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "投資総額5,000万円で購入した賃貸用不動産の年間収入の合計額が270万円、年間費用の合計額が110万円である場合、この投資の純利回り（NOI利回り）は、（   ）である。（2023.09）",
        "choice1": "2.2％",
        "choice2": "3.2％",
        "choice3": "5.4％",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 176,
        "shikenId": 3,
        "no": 56,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "贈与税の配偶者控除は、婚姻期間が（ ① ）以上である配偶者から居住用不動産の贈与または居住用不動産を取得するための金銭の贈与を受け、所定の要件を満たす場合、贈与税の課税価格から基礎控除額のほかに最高（ ② ）を控除することができる特例である。（2023.01）",
        "choice1": "① 10年　　② 2,500万円",
        "choice2": "① 20年　　② 2,500万円",
        "choice3": "① 20年　　② 2,000万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 177,
        "shikenId": 3,
        "no": 57,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "相続人が相続の放棄をするには、原則として、自己のために相続の開始があったことを知った時から（ ① ）以内に、（ ② ）にその旨を申述しなければならない。（2022.05）",
        "choice1": "① 3カ月　　② 家庭裁判所",
        "choice2": "① 3カ月　　② 所轄税務署長",
        "choice3": "① 6カ月　　② 所轄税務署長",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 178,
        "shikenId": 3,
        "no": 58,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "下記の＜親族関係図＞において、Aさんの相続における父Cさんの法定相続分は、（   ）である。（2022.05）<br><img src='/img/3_1.jpg' style='width: 450px;'/>",
        "choice1": "2分の1",
        "choice2": "3分の1",
        "choice3": "4分の1",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 179,
        "shikenId": 3,
        "no": 59,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "貸家建付地の相続税評価額は、（   ）の算式により算出される。（2023.09）",
        "choice1": "自用地としての価額×(1－借地権割合)",
        "choice2": "自用地としての価額×(1－借家権割合×賃貸割合)",
        "choice3": "自用地としての価額×(1－借地権割合×借家権割合×賃貸割合)",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 180,
        "shikenId": 3,
        "no": 60,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "相続人が相続により取得した宅地が「小規模宅地等についての相続税の課税価格の計算の特例」における特定事業用宅地等に該当する場合、その宅地のうち（ ① ）までを限度面積として、評価額の（ ② ）相当額を減額した金額を、相続税の課税価格に算入すべき価額とすることができる。（2023.05）",
        "choice1": "① 200㎡　　② 50％",
        "choice2": "① 330㎡　　② 80％",
        "choice3": "① 400㎡　　② 80％",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 181,
        "shikenId": 5,
        "no": 1,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/181_1.png'/>",
        "question2": "はじめに、Ｍさんは、Ａさんが老齢基礎年金の受給を65歳から開始した場合の年金額を試算した。Ｍさんが試算した老齢基礎年金の年金額の計算式として、次のうち最も適切なものはどれか。なお、老齢基礎年金の年金額は、2025年度価額に基づいて計算するものとする。 ",
        "choice1": "<img src='/img/181_2.png' style=' height: 45px;margin-top: -10px;'/>",
        "choice2": "<img src='/img/181_3.png' style=' height: 41px;margin-top: -10px;margin-left:2px'/>",
        "choice3": "<img src='/img/181_4.png' style=' height: 42px;margin-top: -11px;'/>",
        "choice4": "",
        "choice5": "2023.05改",
        "categoryName": "ライフ",
        "rontenName": "老齢基礎年金の年金額",
        "important": ""
    },
    {
        "id": 182,
        "shikenId": 5,
        "no": 2,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/181_1.png'/>",
        "question2": "次に、Ｍさんは、老齢厚生年金について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「Ａさんおよび妻Ｂさんには、特別支給の老齢厚生年金は支給されません。原則として、65歳から老齢厚生年金を受給することになります」",
        "choice2": "「妻Ｂさんは厚生年金保険の被保険者期間が10年以上ありますので、Ａさんが65歳から受給する老齢厚生年金の額には、配偶者の加給年金額は加算されません」",
        "choice3": "「Ａさんが70歳０カ月で老齢厚生年金の繰下げ支給の申出をする場合、当該年金額の増額率は42％になります」",
        "choice4": "",
        "choice5": "2023.05改",
        "categoryName": "ライフ",
        "rontenName": "老齢厚生年金",
        "important": ""
    },
    {
        "id": 183,
        "shikenId": 5,
        "no": 3,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/181_1.png'/>",
        "question2": "Ｍさんは、確定拠出年金の個人型年金について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「Ａさんが確定拠出年金の個人型年金に加入し、通算加入者等期間が10年以上となる場合、60歳から老齢給付金を受給することができます」",
        "choice2": "「国民年金の第３号被保険者である妻Ｂさんは、確定拠出年金の個人型年金に加入することができます」",
        "choice3": "「Ａさんが支払った確定拠出年金の個人型年金の掛金は、所得税における所得控除の対象となり、その支払った掛金の２分の１相当額を総所得金額等から控除することができます」",
        "choice4": "",
        "choice5": "2024.05",
        "categoryName": "ライフ",
        "rontenName": "個人型確定拠出年金",
        "important": ""
    },
    {
        "id": 184,
        "shikenId": 5,
        "no": 4,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/184_1.png'/>",
        "question2": "はじめに、Ｍさんは、Ｘ社株式の投資指標について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。 ",
        "choice1": "「株価の相対的な割高・割安を判断する指標として、ＰＥＲがあります。＜Ｘ社に関する資料＞から算出されるＸ社株式のＰＥＲは、12.5倍です」 ",
        "choice2": "「株主への利益還元の度合いを測る指標として、配当性向があります。＜Ｘ社に関する資料＞から算出されるＸ社の配当性向は、3.0％です」 ",
        "choice3": "「＜Ｘ社に関する資料＞から算出されるＰＥＲやＰＢＲ等の投資指標の数値は、同業他社の数値やＸ社の過去の傾向などと比較して、投資判断材料の１つとすることをお勧めします」 ",
        "choice4": "",
        "choice5": "2022.01改",
        "categoryName": "金融",
        "rontenName": "投資指標",
        "important": "必要保障額の計算"
    },
    {
        "id": 185,
        "shikenId": 5,
        "no": 5,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/184_1.png'/>",
        "question2": "次に、Ｍさんは、Ｘ社株式を購入する場合の留意点等について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。 ",
        "choice1": "「Ａさんが特定口座（源泉徴収あり）でＸ社株式を株価2,000円で100株購入し、同年中に株価2,400円で全株売却した場合、その他の取引や手数料等を考慮しなければ、売買益４万円に対して20.315％相当額が源泉徴収等されます」 ",
        "choice2": "「X社株式を購入する場合、配当金や売買益等が非課税となるNISAの成長投資枠を利用することが考えられます。本年中に成長投資枠に新規で受け入れることができる限度額（非課税投資枠）は240万円です」",
        "choice3": "「NISA成長投資枠に、本年中に新規で受け入れることができる限度額（非課税投資枠）のうち、未使用分については、翌年以降に繰り越して使用することができます」",
        "choice4": "",
        "choice5": "2022.01改",
        "categoryName": "金融",
        "rontenName": "株式購入、NISA",
        "important": ""
    },
    {
        "id": 186,
        "shikenId": 5,
        "no": 6,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/184_1.png'/>",
        "question2": "最後に、Ｍさんは、上場不動産投資信託（J-REIT）について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。 ",
        "choice1": "「上場不動産投資信託（J-REIT）は、投資家から集めた資金を不動産等に投資し、その賃貸収入や売買益を投資家に分配する投資信託です」 ",
        "choice2": "「上場不動産投資信託（J-REIT）は、NISAの成長投資枠を利用して購入することができないため、一般口座や特定口座で購入する必要があります」 ",
        "choice3": "「上場不動産投資信託（J-REIT）の分配金は、不動産所得として課税の対象となります」 ",
        "choice4": "",
        "choice5": "2022.01改",
        "categoryName": "金融",
        "rontenName": "J-REIT",
        "important": ""
    },
    {
        "id": 187,
        "shikenId": 5,
        "no": 7,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/187_1.png'/>",
        "question2": "Ａさんの本年分の所得税の確定申告に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「所得税の確定申告書は、原則として、翌年２月16日から３月31日までの間に、Ａさんの住所地を所轄する税務署長に提出してください」",
        "choice2": "「Ａさんは、不動産所得の金額が20万円を超えていますので、所得税の確定申告をしなければなりません」",
        "choice3": "「Ａさんは、所得税の確定申告をすることにより、外貨定期預金の為替差損の金額を、不動産所得の金額と損益通算することができます」",
        "choice4": "",
        "choice5": "2023.01改",
        "categoryName": "タックス",
        "rontenName": "所得税の確定申告",
        "important": ""
    },
    {
        "id": 188,
        "shikenId": 5,
        "no": 8,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/187_1.png'/>",
        "question2": "Ａさんの本年分の所得税における総所得金額は、次のうちどれか。<br><img src='/img/187_2.png' style='width:400px'/>",
        "choice1": "653万円",
        "choice2": "658万円",
        "choice3": "663万円",
        "choice4": "",
        "choice5": "2023.01改",
        "categoryName": "タックス",
        "rontenName": "総所得金額の計算",
        "important": ""
    },
    {
        "id": 189,
        "shikenId": 5,
        "no": 9,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/187_1.png'/>",
        "question2": "Ａさんの本年分の所得税における所得控除に関する以下の文章の空欄①～③に入る数値の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/187_3.png' style='width:100%'/>",
        "choice1": "①38　　②48　　③38",
        "choice2": "①58　　②48　　③76",
        "choice3": "①58　　②38　　③101",
        "choice4": "",
        "choice5": "2023.01改",
        "categoryName": "タックス",
        "rontenName": "所得控除",
        "important": ""
    },
    {
        "id": 190,
        "shikenId": 5,
        "no": 10,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 4,
        "question1": "<img src='/img/190_1.png'/>",
        "question2": "甲土地に耐火建築物を建築する場合の①建蔽率の上限となる建築面積と②容積率の上限となる延べ面積の組合せとして、次のうち最も適切なものはどれか。",
        "choice1": "①210㎡　　②720㎡",
        "choice2": "①210㎡　　②900㎡",
        "choice3": "①240㎡　　②720㎡",
        "choice4": "",
        "choice5": "2024.01",
        "categoryName": "不動産",
        "rontenName": "建蔽率と容積率の計算",
        "important": ""
    },
    {
        "id": 191,
        "shikenId": 5,
        "no": 11,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/190_1.png'/>",
        "question2": "自宅（建物およびその敷地である甲土地）の譲渡に関する以下の文章の空欄①～③に入る語句の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/190_2.png' style='width:100%'/>",
        "choice1": "①３年　　②10年　　③できます",
        "choice2": "①５年　　②10年　　③できません",
        "choice3": "①５年　　②20年　　③できます",
        "choice4": "",
        "choice5": "2024.01",
        "categoryName": "不動産",
        "rontenName": "土地建物の譲渡に係る課税の特例",
        "important": ""
    },
    {
        "id": 192,
        "shikenId": 5,
        "no": 12,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/190_1.png'/>",
        "question2": "甲土地の有効活用に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「Ａさんが甲土地に賃貸マンションを建築した場合、相続税の課税価格の計算上、甲土地は貸宅地として評価されます」",
        "choice2": "「Ａさんが甲土地に賃貸マンションを建築した場合、甲土地に係る固定資産税の課税標準を、住宅１戸につき200㎡までの部分（小規模住宅用地）について課税標準となるべき価格の６分の１の額とする特例の適用を受けることができます」",
        "choice3": "「Ａさんが金融機関から融資を受けて、甲土地に賃貸マンションを建築した場合、Ａさんの相続における相続税額の計算上、当該借入金の残高は、原則として、債務控除の対象となります」",
        "choice4": "",
        "choice5": "2024.01",
        "categoryName": "不動産",
        "rontenName": "土地の有効活用",
        "important": ""
    },
    {
        "id": 193,
        "shikenId": 5,
        "no": 13,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/193_1.png'/>",
        "question2": "遺言に関する次の記述のうち、最も適切なものはどれか。 ",
        "choice1": "「公正証書遺言は、証人２人以上の立会いのもと、遺言者が遺言の趣旨を公証人に口授し、公証人がこれを筆記して作成するものです」",
        "choice2": "「自筆証書遺言は、所定の手続により法務局（遺言書保管所）に保管することができますが、法務局に保管された自筆証書遺言は、相続開始時に家庭裁判所による検認手続が必要となります」",
        "choice3": "「Ａさんの遺言による相続分の指定や遺贈によって相続人の遺留分が侵害された場合、その遺言は無効となります」",
        "choice4": "",
        "choice5": "2023.09改",
        "categoryName": "相続",
        "rontenName": "遺言",
        "important": ""
    },
    {
        "id": 194,
        "shikenId": 5,
        "no": 14,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/193_1.png'/>",
        "question2": "仮に、Ａさんの相続が現時点（本年９月10日）で開始し、Ａさんの相続に係る課税遺産総額（課税価格の合計額－遺産に係る基礎控除額）が２億1,000万円であった場合の相続税の総額は、次のうちどれか。<br><img src='/img/193_2.png' style='width:400px'/>",
        "choice1": "3,500万円",
        "choice2": "4,250万円",
        "choice3": "6,750万円",
        "choice4": "",
        "choice5": "2023.09改",
        "categoryName": "相続",
        "rontenName": "相続税額の計算",
        "important": ""
    },
    {
        "id": 195,
        "shikenId": 5,
        "no": 15,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/193_1.png'/>",
        "question2": "現時点（本年９月10日）において、Ａさんの相続が開始した場合に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「Ａさんの相続における相続税額の計算上、遺産に係る基礎控除額は、4,500万円となります」",
        "choice2": "「自宅の敷地と賃貸マンションの敷地について、『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けようとする場合、適用対象面積は所定の算式により調整され、完全併用はできません」",
        "choice3": "「孫Ｅさんが遺贈により財産を取得した場合、相続税額の２割加算の対象となります」",
        "choice4": "",
        "choice5": "2023.09改",
        "categoryName": "相続",
        "rontenName": "相続に関する記述",
        "important": ""
    },
    {
        "id": 196,
        "shikenId": 6,
        "no": 1,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/196_1.png'/>",
        "question2": "はじめに、Ｍさんは、《設例》の＜Ａさんとその家族に関する資料＞に基づき、Ａさんが老齢基礎年金の受給を65歳から開始した場合の年金額（2025年度価額）を試算した。Ｍさんが試算した老齢基礎年金の年金額の計算式として、次のうち最も適切なものはどれか。",
        "choice1": "<img src='/img/196_2.png' style=' height: 41px;margin-top: -11px;'/>",
        "choice2": "<img src='/img/196_3.png' style=' height: 41px;margin-top: -12px;'/>",
        "choice3": "<img src='/img/196_4.png' style=' height: 39px;margin-top: -10px;'/>",
        "choice4": "",
        "choice5": "2023.09改",
        "categoryName": "ライフ",
        "rontenName": "老齢基礎年金の年金額",
        "important": ""
    },
    {
        "id": 197,
        "shikenId": 6,
        "no": 2,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/196_1.png'/>",
        "question2": "次に、Ｍさんは、老齢基礎年金の繰上げ支給および繰下げ支給について説明した。Ｍさんが、Ａさんに対して説明した以下の文章の空欄①～③に入る語句の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/196_5.png' style='width:100%'/> ",
        "choice1": "①生涯　　②24％　　③75歳",
        "choice2": "①80歳まで　　②30％　　③75歳",
        "choice3": "①生涯　　②30％　　③70歳",
        "choice4": "",
        "choice5": "2023.09改",
        "categoryName": "ライフ",
        "rontenName": "繰上げ受給と繰下げ受給",
        "important": ""
    },
    {
        "id": 198,
        "shikenId": 6,
        "no": 3,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/196_1.png'/>",
        "question2": "最後に、Ｍさんは、公的年金制度からの老齢給付について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「Ａさんは原則として、65歳から老齢厚生年金を受給することになりますが、妻Ｂさんには特別支給の老齢厚生年金が支給されます」",
        "choice2": "「Ａさんが老齢基礎年金の繰上げ支給の請求をする場合、その請求と同時に老齢厚生年金の繰上げ支給の請求をしなければなりません」",
        "choice3": "「Ａさんが65歳から受給することができる老齢厚生年金の額には、配偶者の加給年金額が加算されます」",
        "choice4": "",
        "choice5": "2023.09改",
        "categoryName": "ライフ",
        "rontenName": "老齢給付",
        "important": ""
    },
    {
        "id": 199,
        "shikenId": 6,
        "no": 4,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/199_1.png'/>",
        "question2": "Ｍさんは、生命保険の見直しを検討するにあたって、現時点の必要保障額を試算すること<br>にした。下記の〈算式〉および〈条件〉に基づき、Ａさんが現時点で死亡した場合の必要保<br>障額として、次のうち最も適切なものはどれか。<br>〈算式〉<br>必要保障額＝遺族に必要な生活資金等の支出の総額－遺族の収入見込金額<br><br>〈条件〉<br>１．現在の毎月の生活費は40万円であり、Ａさん死亡後の妻Ｂさんの生活費は、現在の生活費の50％とする。<br>２．現在の妻Ｂさんの平均余命は、30年とする。<br>３．Ａさんの死亡整理資金（葬儀費用等）・緊急予備資金は、500万円とする。<br>４．住宅ローン（団体信用生命保険に加入）の残高は、300万円とする。<br>５．死亡退職金見込額とその他金融資産の合計額は、2,400万円とする。<br>６．Ａさん死亡後に妻Ｂさんが受け取る公的年金等の総額は、4,300万円とする。<br>７．現在加入している生命保険の死亡保険金額は考慮しないものとする。",
        "choice1": "700万円",
        "choice2": "1,000万円",
        "choice3": "1,300万円",
        "choice4": "",
        "choice5": "2024.05",
        "categoryName": "リスク（個人）",
        "rontenName": "必要保障額の試算",
        "important": "必要保障額の計算"
    },
    {
        "id": 200,
        "shikenId": 6,
        "no": 5,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/199_1.png'/>",
        "question2": "Ｍさんは、生命保険の見直しについてアドバイスした。ＭさんのＡさんに対するアドバイスとして、次のうち最も適切なものはどれか。",
        "choice1": "「終身保険や定期保険特約の保険金額を減額することで、保険料負担を軽減することができます。死亡保障は少なくなりますが、軽減した保険料分で医療保障や介護保障を目的とした保険に新規加入することも検討に値します」",
        "choice2": "「契約転換制度を活用して定期保険特約付終身保険を転換し、医療保障や介護保障を準備する方法が考えられます。転換後契約の保険料は転換前契約の加入時の年齢により算出されますので、新規に加入するよりも保険料負担を抑えることができます」",
        "choice3": "「定期保険特約付終身保険を払済終身保険に変更した場合、定期保険特約などの死亡保障を目的とした特約は消滅しますが、入院特約などの医療保障を目的とした特約は継続します」",
        "choice4": "",
        "choice5": "2024.05",
        "categoryName": "リスク（個人）",
        "rontenName": "生命保険の見直し",
        "important": ""
    },
    {
        "id": 201,
        "shikenId": 6,
        "no": 6,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 4,
        "question1": "<img src='/img/199_1.png'/>",
        "question2": "Ｍさんは、Ａさんが60歳でＸ社を退職した場合の健康保険について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「Ａさんは、退職日の翌日から65歳になるまでの間、全国健康保険協会管掌健康保険に任意継続被保険者として加入することができます」",
        "choice2": "「Ａさんが国民健康保険に加入する場合、妻Ｂさんを国民健康保険の被扶養者とすれば、これまでどおり妻Ｂさんの保険料負担はありません」",
        "choice3": "「Ａさんが全国健康保険協会管掌健康保険の任意継続被保険者となるためには、原則として、退職日の翌日から20日以内に任意継続被保険者の資格取得の申出をする必要があります」",
        "choice4": "",
        "choice5": "2024.05",
        "categoryName": "リスク（個人）",
        "rontenName": "退職した場合の健康保険",
        "important": ""
    },
    {
        "id": 202,
        "shikenId": 6,
        "no": 7,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/202_1.png'/>",
        "question2": "仮に、将来Ｘ社がＡさんに役員退職金5,000万円を支給した場合、Ａさんが受け取る役員退職金に係る退職所得の金額として、次のうち最も適切なものはどれか。なお、Ａさんの役員在任期間（勤続年数）を40年とし、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。",
        "choice1": "1,400万円",
        "choice2": "2,200万円",
        "choice3": "2,800万円",
        "choice4": "",
        "choice5": "2021.05",
        "categoryName": "リスク（法人）",
        "rontenName": "退職所得の計算",
        "important": ""
    },
    {
        "id": 203,
        "shikenId": 6,
        "no": 8,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/202_1.png'/>",
        "question2": "《設例》の終身保険の第１回保険料払込時の経理処理（仕訳）として、次のうち最も適切なものはどれか。",
        "choice1": "【仕訳】<br>（借方）保険料積立金　200万円／（貸方） 現金・預金　200万円",
        "choice2": "【仕訳】<br>（借方）定期保険料　100万円／（貸方） 現金・預金　200万円<br>　　　　前払保険料　100万円",
        "choice3": "【仕訳】<br>（借方）定期保険料　200万円／（貸方） 現金・預金　200万円",
        "choice4": "",
        "choice5": "2021.05",
        "categoryName": "リスク（法人）",
        "rontenName": "終身保険の経理処理",
        "important": ""
    },
    {
        "id": 204,
        "shikenId": 6,
        "no": 9,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/202_1.png'/>",
        "question2": "Ｍさんは《設例》の終身保険について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「Ａさんが所定の高度障害状態になった場合、高度障害保険金5,000万円がＸ社に支払われます。さらに、その後Ａさんが死亡した場合には、死亡保険金5,000万円がＸ社に支払われます」",
        "choice2": "「急な資金需要の発生により、Ｘ社が契約者貸付制度を利用した場合、当該終身保険契約は継続しているため、経理処理は必要ありません」",
        "choice3": "「Ａさんの勇退時に、役員退職金の一部として当該終身保険の契約者をＡさん、死亡保険金受取人をＡさんの相続人に名義変更し、当該終身保険をＡさんの個人の保険として継続することが可能です」",
        "choice4": "",
        "choice5": "2021.05",
        "categoryName": "リスク（法人）",
        "rontenName": "終身保険の説明",
        "important": ""
    },
    {
        "id": 205,
        "shikenId": 6,
        "no": 10,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/205_1.png'/>",
        "question2": "Ａさんの本年分の所得税における所得控除に関する以下の文章の空欄①～③に入る数値の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/205_2.png' style='width:100%'/> ",
        "choice1": "①26　　②63　　③48",
        "choice2": "①38　　②63　　③58",
        "choice3": "①38　　②58　　③48",
        "choice4": "",
        "choice5": "2022.01改",
        "categoryName": "タックス",
        "rontenName": "所得控除",
        "important": ""
    },
    {
        "id": 206,
        "shikenId": 6,
        "no": 11,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/205_1.png'/>",
        "question2": "Ａさんの本年分の所得税の課税に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「Ａさんが受け取った一時払変額個人年金保険の解約返戻金は、源泉分離課税の対象となります」",
        "choice2": "「本年中に解約した一時払変額個人年金保険の保険差益が20万円を超えるため、Ａさんは所得税の確定申告をしなければなりません」",
        "choice3": "「Ａさんが支払っている長女Ｃさんの国民年金の保険料は、その全額が社会保険料控除の対象となります」",
        "choice4": "",
        "choice5": "2022.01改",
        "categoryName": "タックス",
        "rontenName": "所得税の課税に関する記述",
        "important": ""
    },
    {
        "id": 207,
        "shikenId": 6,
        "no": 12,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/205_1.png'/>",
        "question2": "Ａさんの本年分の所得税における総所得金額は、次のうちどれか。<br><img src='/img/205_3.png' style='width:100%'/> ",
        "choice1": "565万円",
        "choice2": "590万円",
        "choice3": "615万円",
        "choice4": "",
        "choice5": "2022.01改",
        "categoryName": "タックス",
        "rontenName": "総所得金額の計算",
        "important": ""
    },
    {
        "id": 208,
        "shikenId": 6,
        "no": 13,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/208_1.png'/>",
        "question2": "Ａさんの相続に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「Ａさんが本年分の所得税について確定申告書を提出しなければならない者に該当する場合、相続人は、原則として、相続の開始があったことを知った日の翌日から３カ月以内に準確定申告書を提出しなければなりません」",
        "choice2": "「Ａさんの自宅から自筆証書遺言を発見した相続人は、相続の開始を知った後、遅滞なく、その遺言書を家庭裁判所に提出し、その検認を請求しなければなりません」",
        "choice3": "「相続税の申告書は、原則として、相続の開始があったことを知った日の翌日から10カ月以内に、被相続人であるＡさんの死亡時の住所地を所轄する税務署長に提出しなければなりません」",
        "choice4": "",
        "choice5": "2023.01改",
        "categoryName": "相続",
        "rontenName": "相続に関する基礎知識",
        "important": ""
    },
    {
        "id": 209,
        "shikenId": 6,
        "no": 14,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/208_1.png'/>",
        "question2": "Ａさんの相続に関する以下の文章の空欄①～③に入る数値の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/208_2.png' style='width:100%'/> ",
        "choice1": "①4,800　　②4,000　　③400",
        "choice2": "①4,200　　②4,000　　③330",
        "choice3": "①4,800　　②3,500　　③330",
        "choice4": "",
        "choice5": "2023.01改",
        "categoryName": "相続",
        "rontenName": "相続に関する数値",
        "important": ""
    },
    {
        "id": 210,
        "shikenId": 6,
        "no": 15,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/208_1.png'/>",
        "question2": "Ａさんの相続に係る課税遺産総額（課税価格の合計額－遺産に係る基礎控除額）が２億2,000万円であった場合の相続税の総額は、次のうちどれか。<br><img src='/img/208_3.png' style='width:100%'/> ",
        "choice1": "4,600万円",
        "choice2": "5,400万円",
        "choice3": "7,200万円",
        "choice4": "",
        "choice5": "2023.01改",
        "categoryName": "相続",
        "rontenName": "相続税額の計算",
        "important": ""
    },
    {
        "id": 211,
        "shikenId": 4,
        "no": 1,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "ファイナンシャル・プランニング業務を行うに当たっては、関連業法を順守することが重要である。ファイナンシャル・プランナー（以下「ＦＰ」という）の行為に関する次の記述のうち、最も適切なものはどれか。",
        "question2": "",
        "choice1": "投資助言・代理業の登録をしていないＦＰが、顧客と投資顧問契約を締結し、当該契約に基づいて特定の上場株式の投資判断について助言をした。",
        "choice2": "税理士資格を有していないＦＰが、参加費無料の相談会において、相談者の持参した資料に基づき、相談者が納付すべき相続税の具体的な税額計算を行った。",
        "choice3": "生命保険募集人・保険仲立人の登録を受けていないＦＰが、変額年金保険の一般的な商品内容について説明を行った。",
        "choice4": "",
        "choice5": "2021.05",
        "categoryName": "ライフ",
        "rontenName": "FPと関連業法",
        "important": ""
    },
    {
        "id": 212,
        "shikenId": 4,
        "no": 2,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "下記は、平尾家のキャッシュフロー表（一部抜粋）である。このキャッシュフロー表の空欄（ア）、（イ）にあてはまる数値の組み合わせとして、正しいものはどれか。なお、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><img src='/img/212.png'/><br>※年齢および金融資産残高は各年１２月３１日現在のものとし、２０X２年を基準年とする。<br>※給与収入は可処分所得で記載している。<br>※記載されている数値は正しいものとする。<br>※問題作成の都合上、一部を空欄にしてある。",
        "question2": "",
        "choice1": "（ア）５３１　　（イ）７８８",
        "choice2": "（ア）５３２　　（イ）７９６",
        "choice3": "（ア）５３２　　（イ）７９５",
        "choice4": "",
        "choice5": "2023.01改",
        "categoryName": "ライフ",
        "rontenName": "キャッシュフロー表",
        "important": ""
    },
    {
        "id": 213,
        "shikenId": 4,
        "no": 3,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "投資信託の運用スタイルに関する下表の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><img src='/img/213_2.png' style='width:700px'/>",
        "question2": "",
        "choice1": "（ア）パッシブ運用 （イ）アクティブ運用",
        "choice2": "（ア）バリュー運用 （イ）グロース運用",
        "choice3": "（ア）バランス運用 （イ）グロース運用",
        "choice4": "",
        "choice5": "2024.05",
        "categoryName": "金融",
        "rontenName": "投資信託の運用スタイル",
        "important": ""
    },
    {
        "id": 214,
        "shikenId": 4,
        "no": 4,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "広尾さんは、預金保険制度の対象となるＨＡ銀行の国内支店に下記＜資料＞の金融資産を預け入れている。仮に、ＨＡ銀行が破綻した場合、預金保険制度によって保護される金額として、正しいものはどれか。<br><img src='/img/214.png' style='width:550px'/>",
        "question2": "",
        "choice1": "５８０万円",
        "choice2": "７００万円",
        "choice3": "８６０万円",
        "choice4": "",
        "choice5": "2022.09",
        "categoryName": "金融",
        "rontenName": "預金保険制度",
        "important": "必要保障額の計算"
    },
    {
        "id": 215,
        "shikenId": 4,
        "no": 5,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "下記＜資料＞に基づくＲＶ株式会社の投資指標に関する次の記述のうち、最も適切なものはどれか。なお、購入時の手数料および税金は考慮しないこととし、計算結果については表示単位の小数点以下第３位を四捨五入すること。<br><img src='/img/215.png' style='width:450px'/>",
        "question2": "",
        "choice1": "株価純資産倍率（ＰＢＲ）は、１.１倍である。",
        "choice2": "配当利回りは、１.３６％である。",
        "choice3": "配当性向は、１０％である。",
        "choice4": "",
        "choice5": "2021.09",
        "categoryName": "金融",
        "rontenName": "投資指標",
        "important": ""
    },
    {
        "id": 216,
        "shikenId": 4,
        "no": 6,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "下記＜資料＞の甲土地の建築面積の最高限度を算出する基礎となる敷地面積として、正しいものはどれか。なお、この土地の存する区域は、特定行政庁が指定する区域に該当しないものとし、その他記載のない条件については一切考慮しないこととする。<br><img src='/img/216.png'/>",
        "question2": "",
        "choice1": "２６０㎡",
        "choice2": "２８０㎡",
        "choice3": "２９０㎡",
        "choice4": "",
        "choice5": "2023.05",
        "categoryName": "不動産",
        "rontenName": "敷地面積（セットバック）",
        "important": ""
    },
    {
        "id": 217,
        "shikenId": 4,
        "no": 7,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "借地借家法に基づく普通借家権に関する以下の記述の空欄（ア）～（ウ）に入る語句の組み合わせとして、最も適切なものはどれか。<br><img src='/img/217.png' style='width:600px'/>",
        "question2": "",
        "choice1": "（ア）１年 （イ）３ヵ月 （ウ）１ヵ月",
        "choice2": "（ア）１年 （イ）６ヵ月 （ウ）３ヵ月",
        "choice3": "（ア）２年 （イ）６ヵ月 （ウ）３ヵ月",
        "choice4": "",
        "choice5": "2023.01",
        "categoryName": "不動産",
        "rontenName": "普通借家権",
        "important": ""
    },
    {
        "id": 218,
        "shikenId": 4,
        "no": 8,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "明石誠二さんが加入しているがん保険（下記＜資料＞参照）の保障内容に関する次の記述の空欄（ア）にあてはまる金額として、正しいものはどれか。なお、保険契約は有効に継続しているものとし、誠二さんはこれまでに＜資料＞の保険から保険金および給付金を一度も受け取っていないものとする。<br><img src='/img/218.png'/>",
        "question2": "",
        "choice1": "１,６２０,０００円",
        "choice2": "２,７２０,０００円",
        "choice3": "３,６２０,０００円",
        "choice4": "",
        "choice5": "2023.05改",
        "categoryName": "リスク",
        "rontenName": "生命保険証券の見方",
        "important": ""
    },
    {
        "id": 219,
        "shikenId": 4,
        "no": 9,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "会社員で共働きの大場さん夫妻が加入している生命保険は下表のとおりである。下表の契約Ａ～Ｃについて、保険金が支払われた場合の課税関係に関する次の記述のうち、最も適切なものはどれか。<br><img src='/img/219.png'/>",
        "question2": "",
        "choice1": "契約Ａについて、子が受け取った死亡保険金は贈与税の課税対象となる。",
        "choice2": "契約Ｂについて、妻が受け取った死亡保険金は相続税の課税対象となる。",
        "choice3": "契約Ｃについて、妻が受け取った死亡保険金は所得税・住民税の課税対象となる。",
        "choice4": "",
        "choice5": "2022.01",
        "categoryName": "リスク",
        "rontenName": "生命保険金の課税関係",
        "important": ""
    },
    {
        "id": 220,
        "shikenId": 4,
        "no": 10,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "伊丹さんは地震保険の加入を検討しており、ＦＰの筒井さんに質問をした。地震保険に関する筒井さんの次の説明のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "「地震保険の保険料は、保険会社による違いはありません。」",
        "choice2": "「地震保険の損害認定の区分は、『全損』『半損』『一部損』の３区分に分けられています。」",
        "choice3": "「地震保険の保険金額は、火災保険の保険金額の３０％～５０％の範囲内で設定されますが、居住用建物については５,０００万円が上限となります。」",
        "choice4": "",
        "choice5": "2024.01",
        "categoryName": "リスク",
        "rontenName": "地震保険",
        "important": ""
    },
    {
        "id": 221,
        "shikenId": 4,
        "no": 11,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "下記＜資料＞に基づき、目黒昭雄さんの本年分の所得税を計算する際の所得控除に関する次の記述のうち、最も適切なものはどれか。<br><img src='/img/221.png' style='width: 550px'/>",
        "question2": "",
        "choice1": "妻の聡美さんは控除対象配偶者となり、昭雄さんは３８万円を控除することができる。",
        "choice2": "長男の幸一さんは特定扶養親族となり、昭雄さんは６３万円を控除することができる。",
        "choice3": "二男の浩二さんは一般の扶養親族となり、昭雄さんは３８万円を控除することができる。",
        "choice4": "",
        "choice5": "2023.05改",
        "categoryName": "タックス",
        "rontenName": "所得控除",
        "important": ""
    },
    {
        "id": 222,
        "shikenId": 4,
        "no": 12,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "会社員の飯田さんは、本年中に勤務先を定年退職した。飯田さんの退職に係るデータが下記＜資料＞のとおりである場合、飯田さんの所得税に係る退職所得の金額として、正しいものはどれか。<br><img src='/img/222.png'/>",
        "question2": "",
        "choice1": "３６０万円",
        "choice2": "３９５万円",
        "choice3": "７２０万円",
        "choice4": "",
        "choice5": "2022.05改",
        "categoryName": "タックス",
        "rontenName": "退職所得の計算",
        "important": ""
    },
    {
        "id": 223,
        "shikenId": 4,
        "no": 13,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "本年１月５日に相続が開始された牧村誠一さん（被相続人）の＜親族関係図＞が下記のとおりである場合、民法上の相続人および法定相続分の組み合わせとして、正しいものはどれか。なお、記載のない条件については一切考慮しないこととする。<br><img src='/img/223.png'/>",
        "question2": "",
        "choice1": "智子   １／２　　歩美    １／２",
        "choice2": "智子   １／２　　歩美    １／４　　大雅   １／４",
        "choice3": "智子   １／２　　歩美    １／６　　大雅   １／６　　莉名   １／６",
        "choice4": "",
        "choice5": "2022.01改",
        "categoryName": "相続",
        "rontenName": "法定相続分",
        "important": ""
    },
    {
        "id": 224,
        "shikenId": 4,
        "no": 14,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "村瀬高志さん（３０歳）が本年中に贈与を受けた財産の価額と贈与者は以下のとおりである。高志さんの本年分の贈与税額として、正しいものはどれか。なお、本年中において、高志さんはこれ以外の財産の贈与を受けておらず、相続時精算課税制度は選択していないものとする。<br><img src='/img/224.png'/>",
        "question2": "",
        "choice1": "６８万円",
        "choice2": "８２万円",
        "choice3": "９０万円",
        "choice4": "",
        "choice5": "2021.09改",
        "categoryName": "相続",
        "rontenName": "贈与税額の計算",
        "important": ""
    },
    {
        "id": 225,
        "shikenId": 4,
        "no": 15,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "今年８０歳になる安西さんは、将来発生するであろう自身の相続について、遺産分割等でのトラブルを防ぐために遺言書の作成を検討しており、ＦＰの高梨さんに相談をした。遺言書に関する高梨さんの次の説明のうち、最も適切なものはどれか。",
        "question2": "",
        "choice1": "「公正証書遺言を作成した後に、自筆証書遺言によって、先に作成した公正証書遺言を撤回することができます。」",
        "choice2": "「自筆証書遺言を作成した場合、原則として、遺言書の保管者または遺言書を発見した相続人は、遅滞なく遺言書を公証役場に提出して、その検認を請求する必要があります。」",
        "choice3": "「自筆証書遺言を作成する場合、遺言者と２人以上の証人が、各自これに署名し、押印をすることが必要です。」",
        "choice4": "",
        "choice5": "2022.05",
        "categoryName": "相続",
        "rontenName": "遺言書",
        "important": ""
    },
    {
        "id": 226,
        "shikenId": 4,
        "no": 16,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "ＦＰの青山さんは、川野家のバランスシートを作成した。下表の空欄（ア）にあてはまる金額として、正しいものはどれか。なお、＜資料＞に記載のあるデータに基づいて解答することとする。<br><img src='/img/226_2.png'>",
        "question2": "",
        "choice1": "３７０（万円）",
        "choice2": "４７０（万円）",
        "choice3": "４８５（万円）",
        "choice4": "",
        "choice5": "2023.05改",
        "categoryName": "総合",
        "rontenName": "バランスシート",
        "important": ""
    },
    {
        "id": 227,
        "shikenId": 4,
        "no": 17,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "恭平さんと亜美さんは、今後１０年間で毎年２４万円ずつ積立貯蓄をして、潤さんの教育資金を準備したいと考えている。積立期間中に年利１.０％で複利運用できるものとした場合、１０年後の積立金額として、正しいものはどれか。なお、下記＜資料＞の３つの係数の中から最も適切な係数を選択して計算し、解答に当たっては万円未満を切り捨てること。また、税金や記載のない事項については一切考慮しないこととする。<br><img src='/img/227.png' style='width:550px'>",
        "question2": "",
        "choice1": "２６５万円",
        "choice2": "２５１万円",
        "choice3": "２２７万円",
        "choice4": "",
        "choice5": "2023.05",
        "categoryName": "総合",
        "rontenName": "係数の計算",
        "important": ""
    },
    {
        "id": 228,
        "shikenId": 4,
        "no": 18,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "智洋さんは、下記＜資料＞の外貨定期預金キャンペーンに関心を持っている。預入条件が＜資料＞のとおりであるとき、ＦＰの近藤さんの次の説明のうち、最も不適切なものはどれか。<br><img src='/img/228_2.png' style='width:400px'>",
        "question2": "",
        "choice1": "「外貨預金は預金保険制度の対象外となっています。」",
        "choice2": "「元金１万ドルを預けた場合、満期時には税引前・米ドルベースで８００ドルの利息を受け取ることができます。」",
        "choice3": "「円貨から外貨定期預金を始める際は、ＴＴＳレート（対顧客電信売相場）が適用されます。",
        "choice4": "",
        "choice5": "2023.01",
        "categoryName": "総合",
        "rontenName": "外貨定期預金",
        "important": ""
    },
    {
        "id": 229,
        "shikenId": 4,
        "no": 19,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "亜美さんは、間もなく第二子を出産予定で、出産後は子が１歳になるまで育児休業を取得しようと思っている。育児休業期間中の健康保険および厚生年金保険の保険料の免除に関する次の記述のうち、最も適切なものはどれか。なお、亜美さんは全国健康保険協会管掌健康保険（協会けんぽ）の被保険者であり、かつ厚生年金保険の被保険者である。",
        "question2": "",
        "choice1": "事業主の申出により、被保険者負担分のみ免除される。",
        "choice2": "事業主の申出により、事業主負担分のみ免除される。",
        "choice3": "事業主の申出により、被保険者および事業主負担分が免除される。",
        "choice4": "",
        "choice5": "2023.05",
        "categoryName": "総合",
        "rontenName": "育休中の保険料",
        "important": ""
    },
    {
        "id": 230,
        "shikenId": 4,
        "no": 20,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "恭平さんが保有する投資信託は、投資信託①と投資信託②であり、５年前にそれぞれ１５万円ずつ合計３０万円を購入したものである。恭平さんは「リバランス」に興味をもち、ＦＰの青山さんに質問をした。下記の空欄（ア）～（ウ）にあてはまる語句に関する次の記述のうち、最も不適切なものはどれか。なお、手数料は考慮しないものとする。<br><img src='/img/230.png'>",
        "question2": "",
        "choice1": "（ア）にあてはまる語句は、「配分比率」である。",
        "choice2": "（イ）にあてはまる語句は、「１５万円分売却」である。",
        "choice3": "（ウ）にあてはまる語句は、「１０万円分購入」である。",
        "choice4": "",
        "choice5": "2023.05",
        "categoryName": "総合",
        "rontenName": "投資信託リバランス",
        "important": ""
    },
    {
        "id": 231,
        "shikenId": 7,
        "no": 1,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "ファイナンシャル・プランナーが顧客と投資顧問契約を締結し、当該契約に基づき金融商品取引法で定める投資助言・代理業を行うためには、内閣総理大臣の登録を受けなければならない。 ［2023年9月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 232,
        "shikenId": 7,
        "no": 2,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "全国健康保険協会管掌健康保険の被保険者である会社員が、退職後に任意継続被保険者となるためには、資格喪失日から14日以内に任意継続被保険者となるための申出をしなければならない。［2020年9月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 233,
        "shikenId": 7,
        "no": 3,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "老齢厚生年金の繰下げ支給の申出は、老齢基礎年金の繰下げ支給の申出と同時に行う必要はない。［2022年5月改題］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 234,
        "shikenId": 7,
        "no": 4,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "国民年金基金の掛金の額は、加入員の選択した給付の型や加入口数によって決まり、加入時の年齢や性別によって異なることはない。 ［2022年9月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 235,
        "shikenId": 7,
        "no": 5,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "日本政策金融公庫の教育一般貸付（国の教育ローン）の使途は、入学金や授業料などの学校納付金に限られ、受験費用や在学のために必要となる住居費用などに利用することはできない。［2023年5月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 236,
        "shikenId": 7,
        "no": 6,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "延長保険とは、一般に、現在加入している生命保険の保険料の払込みを中止し、その時点での解約返戻金を基に、元契約の保険金額を変えずに一時払いの定期保険に変更する制度である。［2022年5月改題］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 237,
        "shikenId": 7,
        "no": 7,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "個人年金保険（終身年金）の保険料は、性別以外の契約条件が同一であれば、被保険者が女性のほうが男性よりも高くなる。［2024年1月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 238,
        "shikenId": 7,
        "no": 8,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "自動車損害賠償責任保険（自賠責保険）では、被保険者自身が単独事故でケガをした場合、その損害は補償の対象とならない。［2022年9月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 239,
        "shikenId": 7,
        "no": 9,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "家族傷害保険の被保険者の範囲には、被保険者本人と生計を共にする別居の未婚の子も含まれる。［2020年1月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 240,
        "shikenId": 7,
        "no": 10,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税において、個人が支払う地震保険の保険料は、５万円を限度として年間支払保険料の２分の１相当額が地震保険料控除の対象となる。［2021年1月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 241,
        "shikenId": 7,
        "no": 11,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "米国の市場金利が上昇し、日本と米国の金利差が拡大することは、一般に、米ドルと円の為替相場において米ドル安、円高の要因となる。［2023年1月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 242,
        "shikenId": 7,
        "no": 12,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "インデックス型投資信託は、日経平均株価や東証株価指数（TOPIX）などの特定の指標に連動するよう運用される投資信託である。［2021年1月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 243,
        "shikenId": 7,
        "no": 13,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "元金2,500,000円を、年利４％（１年複利）で３年間運用した場合の元利合計額は、税金や手数料等を考慮しない場合、2,812,160円である。［2024年1月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 244,
        "shikenId": 7,
        "no": 14,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "配当性向とは、当期純利益に占める配当金総額の割合を示す指標である。［2022年5月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 245,
        "shikenId": 7,
        "no": 15,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "日経平均株価は、東京証券取引所プライム市場に上場する代表的な225銘柄を対象として算出される株価指標である。［2020年1月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 246,
        "shikenId": 7,
        "no": 16,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "所得税において、医療保険の被保険者が病気で入院したことにより受け取った入院給付金は、非課税である。［2022年1月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 247,
        "shikenId": 7,
        "no": 17,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税において、事業的規模で行われている賃貸マンションの貸付による所得は、事業所得となる。［2021年5月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 248,
        "shikenId": 7,
        "no": 18,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "所得税において、国民年金基金の掛金は、社会保険料控除の対象となる。［2023年5月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 249,
        "shikenId": 7,
        "no": 19,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "住宅ローンを利用して住宅を新築した個人が、所得税の住宅借入金等特別控除の適用を受けるためには、当該住宅を新築した日から１カ月以内に自己の居住の用に供さなければならない。［2023年1月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 250,
        "shikenId": 7,
        "no": 20,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税、住民税は直接税、相続税、贈与税は間接税である。［2024年５月公表改題］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 251,
        "shikenId": 7,
        "no": 21,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "不動産登記には公信力が認められていないため、登記記録上の権利者が真実の権利者と異なっている場合に、登記記録を信じて不動産を購入した者は、原則として、その不動産に対する権利の取得について法的に保護されない。［2023年5月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 252,
        "shikenId": 7,
        "no": 22,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "借地借家法において、事業用定期借地権等の設定を目的とする契約は、公正証書によってしなければならない。［2023年1月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 253,
        "shikenId": 7,
        "no": 23,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "都市計画法において、市街化区域内で行う開発行為は、その規模にかかわらず、都道府県知事等の許可を受けなければならない。［2020年1月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 254,
        "shikenId": 7,
        "no": 24,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "不動産取得税は、相続人が不動産を相続により取得した場合には課されない。［2024年1月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 255,
        "shikenId": 7,
        "no": 25,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "「居住用財産を譲渡した場合の3,000万円の特別控除」は、自己が居住していた家屋を配偶者や子に譲渡した場合には、適用を受けることができない。［2022年9月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 256,
        "shikenId": 7,
        "no": 26,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "取引相場のない株式の相続税評価において、類似業種比準方式における比準要素には、「１株当たりの配当金額」「１株当たりの利益金額」「１株当たりの純資産価額」がある。 ［2018年5月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 257,
        "shikenId": 7,
        "no": 27,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "子が父親からの贈与により取得した財産について相続時精算課税の適用を受けた場合、その適用を受けた年以後、子は父親からの贈与により取得した財産について暦年課税を選択することはできない。［2021年9月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 258,
        "shikenId": 7,
        "no": 28,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "協議分割は、共同相続人全員の協議により遺産を分割する方法であり、その分割割合については、必ずしも法定相続分に従う必要はない。［2022年9月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 259,
        "shikenId": 7,
        "no": 29,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "相続人が負担した被相続人の葬式の際の香典返戻費用は、相続税の課税価格の計算上、葬式費用として控除することができる。［2021年5月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 260,
        "shikenId": 7,
        "no": 30,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "相続税額の計算において、「配偶者に対する相続税額の軽減」の適用を受けるためには、その適用を受けることにより納付すべき相続税額が算出されない場合であっても、相続税の申告書を提出しなければならない。［2022年9月］",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 261,
        "shikenId": 7,
        "no": 31,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "900万円を準備するために、15年間、毎年均等に積み立て、利率（年率）１％で複利運用する場合、必要となる毎年の積立金額は、下記の＜資料＞の係数を使用して算出すると（　　）である。［2020 年9 月］<br><br>＜資料＞利率（年率）１％・期間15年の各種係数<br><table class='btt'><tr><td>現価係数</td><td>資本回収係数</td><td>減債基金係数</td></tr><tr><td>0.8613</td><td>0.0721</td><td>0.0621</td></tr></table>",
        "choice1": "516,780円",
        "choice2": "558,900円",
        "choice3": "600,000円",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 262,
        "shikenId": 7,
        "no": 32,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "雇用保険の基本手当を受給するためには、倒産、解雇および雇止めなどの場合を除き、原則として、離職の日以前（①）に被保険者期間が通算して（②）以上あることなどの要件を満たす必要がある。［2022 年9 月］",
        "choice1": "①　１年間　　②　６カ月",
        "choice2": "①　２年間　　②　６カ月",
        "choice3": "①　２年間　　②　12カ月",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 263,
        "shikenId": 7,
        "no": 33,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "国民年金の被保険者が学生納付特例制度の適用を受けた期間は、その期間に係る保険料を追納しない場合、老齢基礎年金の受給資格期間（①）、老齢基礎年金の年金額（②）。［2021 年5 月］",
        "choice1": "①に算入され　　②にも反映される",
        "choice2": "①に算入されず　　②にも反映されない",
        "choice3": "①には算入されるが　　②には反映されない",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 264,
        "shikenId": 7,
        "no": 34,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "遺族厚生年金の額（中高齢寡婦加算額および経過的寡婦加算額を除く）は、原則として、死亡した者の厚生年金保険の被保険者記録を基礎として計算した老齢厚生年金の報酬比例部分の額の（　　）に相当する額である。［2022 年1 月］",
        "choice1": "２分の１",
        "choice2": "３分の２",
        "choice3": "４分の３",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 265,
        "shikenId": 7,
        "no": 35,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "住宅金融支援機構と民間金融機関が提携した住宅ローンであるフラット35（買取型）の融資金利は（ ① ）であり、借入れをする際には、保証人が（ ② ）である。 ［2022年5月］",
        "choice1": "① 固定金利　　② 不要",
        "choice2": "① 固定金利　　② 必要",
        "choice3": "① 変動金利　　② 必要",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 266,
        "shikenId": 7,
        "no": 36,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "生命保険会社が（　　）を引き上げた場合、通常、その後の終身保険の新規契約の保険料は安くなる。［2023 年5 月］",
        "choice1": "予定利率",
        "choice2": "予定死亡率",
        "choice3": "予定事業費率",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 267,
        "shikenId": 7,
        "no": 37,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "団体を契約者（＝保険料負担者）とし、その所属員を被保険者とする１年更新の定期保険であり、福利厚生規程等による保障の支払財源の確保を目的とした保険は、（　　）である。［2020 年1 月］",
        "choice1": "総合福祉団体定期保険",
        "choice2": "団体定期保険（Ｂグループ保険）",
        "choice3": "団体信用生命保険",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 268,
        "shikenId": 7,
        "no": 38,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "地震保険の保険金額は、火災保険の保険金額の30％から50％の範囲内で設定されるが、居住用建物については（①）、生活用動産（家財）については（②）が上限となる。［2022 年1 月］",
        "choice1": "①　1,500万円　　②300万円",
        "choice2": "①　3,000万円　　②500万円",
        "choice3": "①　5,000万円　　②1,000万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 269,
        "shikenId": 7,
        "no": 39,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "歩行中に交通事故でケガをし、加害車両の運転者が加入していた自動車保険の対人賠償保険から受け取った保険金は、所得税において、（　　）とされる。［2022 年9 月］",
        "choice1": "一時所得",
        "choice2": "雑所得",
        "choice3": "非課税所得",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 270,
        "shikenId": 7,
        "no": 40,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "リビング・ニーズ特約は、（①）、被保険者の余命が（②）以内と判断された場合に、所定の範囲内で死亡保険金の一部または全部を生前に受け取ることができる特約である。［2023 年1 月］",
        "choice1": "①　病気やケガの種類にかかわらず　　②　６カ月",
        "choice2": "①　病気やケガの種類にかかわらず　　②　１年",
        "choice3": "①　特定疾病に罹患したことが原因で　　②　１年",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 271,
        "shikenId": 7,
        "no": 41,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "景気動向指数において、（　　）は、一致系列に採用されている。 ［2021 年5 月］",
        "choice1": "完全失業率",
        "choice2": "新規求人数（除学卒）",
        "choice3": "有効求人倍率（除学卒）",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 272,
        "shikenId": 7,
        "no": 42,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "表面利率（クーポンレート）１％、残存期間２年の固定利付債券を額面100円当たり99円で購入した場合の最終利回り（年率・単利）は、（　　）である。なお、税金等は考慮しないものとし、計算結果は表示単位の小数点以下第３位を四捨五入している。［2022 年5 月］",
        "choice1": "1.50％",
        "choice2": "1.52％",
        "choice3": "2.02％",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 273,
        "shikenId": 7,
        "no": 43,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "追加型株式投資信託を基準価額１万4,000円で１万口購入した後、最初の決算時に１万口当たり300円の収益分配金が支払われ、分配落ち後の基準価額が１万3,800円となった場合、その収益分配金のうち、普通分配金は（①）であり、元本払戻金（特別分配金）は（②）である。［2021 年1 月］",
        "choice1": "①　０円　　②　300円",
        "choice2": "①　100円　　②　200円",
        "choice3": "①　200円　　②　100円",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 274,
        "shikenId": 7,
        "no": 44,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "異なる２資産からなるポートフォリオにおいて、２資産間の相関係数が（ ）である場合、分散投資によるリスクの低減効果は最大となる。［2024 年1 月］",
        "choice1": "＋１",
        "choice2": "０",
        "choice3": "－１",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 275,
        "shikenId": 7,
        "no": 45,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "外貨預金の預入時において、預入金融機関が提示する（　　）は、預金者が円貨を外貨に換える際に適用される為替レートである。 ［2023 年9 月］",
        "choice1": "ＴＴＢ",
        "choice2": "ＴＴＭ",
        "choice3": "ＴＴＳ",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 276,
        "shikenId": 7,
        "no": 46,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "給与所得者が25年間勤務した会社を定年退職し、退職金2,000万円の支給を受けた場合、所得税における退職所得の金額の計算上、退職所得控除額は、（　　）となる。［2021 年5 月］",
        "choice1": "{800万円＋70万円×（25年－20年）}×１/２＝575万円",
        "choice2": "800万円＋40万円×（25年－20年）＝1,000万円",
        "choice3": "800万円＋70万円×（25年－20年）＝1,150万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 277,
        "shikenId": 7,
        "no": 47,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "日本国内において支払を受ける預貯金の利子は、原則として、所得税および復興特別所得税と住民税の合計で（ ① ）の税率による（ ② ）分離課税の対象となる。［2024 年1 月］",
        "choice1": "①　10.21％ 　　②　申告",
        "choice2": "①　20.315％　　②　申告",
        "choice3": "①　20.315％　　②　源泉",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 278,
        "shikenId": 7,
        "no": 48,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "A さんの本年分の各種所得の金額が下記の＜資料＞のとおりであった場合、損益通算後の総所得金額は（　　）となる。なお、各種所得の金額に付されている「▲」は、その所得に損失が生じていることを表すものとする。［2019 年9 月改題］<br><br>＜資料＞Aさんの各種所得の金額<br><table class='btt2'><tr><td>不動産所得の金額</td><td>750万円</td></tr><tr><td>雑所得の金額</td><td>▲50万円</td></tr><tr><td>事業所得の金額（株式等に係るものを除く）</td><td>▲150万円</td></tr></table>",
        "choice1": "550万円",
        "choice2": "600万円",
        "choice3": "700万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 279,
        "shikenId": 7,
        "no": 49,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "所得税において、控除対象扶養親族のうち、その年の12月31日時点の年齢が19歳以上23歳未満である特定扶養親族に係る扶養控除の額は、１人につき（　　）である。［2022 年5 月］",
        "choice1": "38万円",
        "choice2": "48万円",
        "choice3": "63万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 280,
        "shikenId": 7,
        "no": 50,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "年末調整の対象となる給与所得者は、年末調整により、（　　）の適用を受けることができる。［2020 年9 月改題］",
        "choice1": "生命保険料控除",
        "choice2": "雑損控除",
        "choice3": "医療費控除",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 281,
        "shikenId": 7,
        "no": 51,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "相続税路線価は、相続税や（①）を算定する際の土地等の評価額の基準となる価格であり、地価公示法による公示価格の（②）を価格水準の目安として設定される。［2022 年5 月］",
        "choice1": "①　不動産取得税　　②　70％",
        "choice2": "①　贈与税　　②　70％",
        "choice3": "①　贈与税　　②　80％",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 282,
        "shikenId": 7,
        "no": 52,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "不動産の売買契約において、買主が売主に解約手付を交付した場合、売主は、（①）が契約の履行に着手するまでは、受領した手付（②）を買主に提供することで、契約の解除をすることができる。［2022 年1 月］",
        "choice1": "①　買主　　②　と同額",
        "choice2": "①　買主　　②　の倍額",
        "choice3": "①　売主　　②　と同額",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 283,
        "shikenId": 7,
        "no": 53,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "個人が土地を譲渡したことによる譲渡所得の金額の計算において、譲渡した土地の取得費が不明である場合、当該収入金額の（ ）相当額を取得費とすることができる。 ［2022年1月］",
        "choice1": "５％",
        "choice2": "10％",
        "choice3": "15％",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 284,
        "shikenId": 7,
        "no": 54,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "市街化区域内において、所有する農地を自宅の建築を目的として宅地に転用する場合、あらかじめ（　　）に届出をすれば都道府県知事等の許可は不要である。 ［2023 年5 月］",
        "choice1": "農業委員会",
        "choice2": "市町村長",
        "choice3": "国土交通大臣",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 285,
        "shikenId": 7,
        "no": 55,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "土地の有効活用方式のうち、一般に、土地所有者が土地の全部または一部を拠出し、デベロッパーが建設費等を拠出して、それぞれの出資比率に応じて土地・建物に係る権利を取得する方式を、（　　）という。［2020 年9 月］",
        "choice1": "等価交換方式",
        "choice2": "事業受託方式",
        "choice3": "建設協力金方式",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 286,
        "shikenId": 7,
        "no": 56,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "贈与税の申告書は、原則として、贈与を受けた年の翌年の（①）から３月15日までの間に、（②）の住所地を所轄する税務署長に提出しなければならない。［2022 年1 月］",
        "choice1": "①　２月１日　　②　受贈者",
        "choice2": "①　２月16日　　②　贈与者",
        "choice3": "①　２月16日　　②　受贈者",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 287,
        "shikenId": 7,
        "no": 57,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "個人が法人からの贈与により取得する財産は、（ 　　）の課税対象となる。［2023 年5 月］",
        "choice1": "法人税",
        "choice2": "贈与税",
        "choice3": "所得税",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 288,
        "shikenId": 7,
        "no": 58,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "公正証書遺言は、証人２人以上の立会いのもと、遺言者が遺言の趣旨を公証人に口授し、公証人がそれを筆記して作成される遺言であり、相続開始後に（①）における検認手続が（②）である。［2022 年5 月］",
        "choice1": "①家庭裁判所　　②不要",
        "choice2": "①家庭裁判所　　②必要",
        "choice3": "①公証役場　　②必要",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 289,
        "shikenId": 7,
        "no": 59,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "下記の＜親族関係図＞において、Aさんの相続における妻Bさんの法定相続分は、（　　）である。［2021 年9 月］<br><br>＜親族関係図＞<br><img src=\"/img/59.png\" style='width:470px'/>",
        "choice1": "２分の１",
        "choice2": "３分の２",
        "choice3": "４分の３",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 290,
        "shikenId": 7,
        "no": 60,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "自用地としての価額が5,000万円、借地権割合が70％、借家権割合が30％、賃貸割合が100％の貸家建付地の相続税評価額は、（　　）である。 ［2021 年1 月］",
        "choice1": "1,500万円",
        "choice2": "3,500万円",
        "choice3": "3,950万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 291,
        "shikenId": 8,
        "no": 1,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "公表された他人の著作物を自分の著作物に引用する場合の注意事項に関する次の記述のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "自らが作成する部分が「主」で、引用する部分が「従」となる内容にした。",
        "choice2": "自らが作成する部分と引用する部分を区別できないようにまとめて表現した。",
        "choice3": "引用する著作物のタイトルと著作者名を明記した。",
        "choice4": "",
        "choice5": "2023.09改",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 292,
        "shikenId": 8,
        "no": 2,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "下記は、小山家のキャッシュフロー表（一部抜粋）である。このキャッシュフロー表の空欄（ア）～（ウ）にあてはまる数値として、誤っているものはどれか。なお、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><img src='/img/8_1.png' style='max-width:680px'/><br>※年齢および金融資産残高は各年１２月３１日現在のものとし、２０×０年を基準年とする。<br>※給与収入は可処分所得で記載している。<br>※記載されている数値は正しいものとする。<br>※問題作成の都合上、一部を空欄にしてある。",
        "question2": "",
        "choice1": "（ア）３１０",
        "choice2": "（イ）２０３",
        "choice3": "（ウ）８４１",
        "choice4": "",
        "choice5": "2023.09改",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 293,
        "shikenId": 8,
        "no": 3,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "ＦＰの福岡さんは、以下の資金計画どおりにマンションを購入した後の荒木家のバランスシートを作成した。下表の空欄（ア）にあてはまる金額として、正しいものはどれか。なお、＜資料＞に記載のあるデータに基づいて解答することとする。<br><img src='/img/8_2.png' style='max-width:680px'/>",
        "question2": "",
        "choice1": "１６０（万円）",
        "choice2": "６６０（万円）",
        "choice3": "１，０６０（万円）",
        "choice4": "",
        "choice5": "2020.01改",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 294,
        "shikenId": 8,
        "no": 4,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "荒木さんは、今後１０年間で毎年３６万円ずつ積立貯蓄をして、長女の教育資金を準備したいと考えている。積立期間中に年利２．０％で複利運用できるものとした場合、１０年後の合計金額として、正しいものはどれか。なお、下記＜資料＞の３つの係数の中から最も適切な係数を選択して計算し、解答に当たっては、千円未満を四捨五入すること。また、税金や記載のない事項については一切考慮しないこととする。<br><img src='/img/8_3.png' style='width:500px'/>",
        "question2": "",
        "choice1": "３，２３４，０００円",
        "choice2": "３，９４２，０００円",
        "choice3": "４，３８８，０００円",
        "choice4": "",
        "choice5": "2020.01改",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 295,
        "shikenId": 8,
        "no": 5,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "安藤さんは、現在、専業主婦であり国民年金の第３号被保険者であるが、パートタイマーとして、株式会社ＳＸにて２０ＸＸ年１０月１日より「週２５時間、月給１２万円、雇用期間の定めなし」という労働条件で働く予定である。この条件で働き始めた場合の安藤さんの国民年金の被保険者種別に関する次の記述のうち、最も適切なものはどれか。なお、株式会社ＳＸは特定適用事業所である。",
        "question2": "",
        "choice1": "国民年金の第１号被保険者である。",
        "choice2": "国民年金の第２号被保険者である。",
        "choice3": "国民年金の第３号被保険者である。",
        "choice4": "",
        "choice5": "2023年９月",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 296,
        "shikenId": 8,
        "no": 6,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "下記＜資料＞に基づくＱＸ株式会社の投資指標に関する次の記述のうち、最も適切なものはどれか。なお、購入時の手数料および税金は考慮しないこととする。<br><img src='/img/8_5.png' style='max-width:680px'/>",
        "question2": "",
        "choice1": "株価収益率（ＰＥＲ）で比較した場合、ＱＸ株式会社の株価は日経平均採用銘柄の平均（予想ベース）より割安である。",
        "choice2": "株価純資産倍率（ＰＢＲ）で比較した場合、ＱＸ株式会社の株価は東証プライム全銘柄の平均より割安である。",
        "choice3": "配当利回りで比較した場合、ＱＸ株式会社の配当利回りは東証グロース全銘柄の平均（予想ベース）より低い。",
        "choice4": "",
        "choice5": "2022.01",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 297,
        "shikenId": 8,
        "no": 7,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "関根さんは上場株式への投資に興味をもち、ＦＰの榎田さんに質問をした。下記の空欄（ア）～（ウ）にあてはまる語句に関する次の記述のうち、最も不適切なものはどれか。<br><img src='/img/8_6.png' style='max-width:680px'/>",
        "question2": "",
        "choice1": "空欄（ア）にあてはまる語句は、「 減少」である。",
        "choice2": "空欄（イ）にあてはまる語句は、「 高く」である。",
        "choice3": "空欄（ウ）にあてはまる語句は、「 株主優待制度」である。",
        "choice4": "",
        "choice5": "2022.01",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 298,
        "shikenId": 8,
        "no": 8,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "福岡さんはＱＳ投資信託を新規募集時に１，０００万口購入し、特定口座（源泉徴収口座）で保有して収益分配金を受け取っている。下記＜資料＞に基づき、福岡さんが保有するＱＳ投資信託に関する次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、正しいものはどれか。<br><img src='/img/8_7.png' style='max-width:680px'/>",
        "question2": "",
        "choice1": "（ア）２４０，０００円　　（イ）普通分配金",
        "choice2": "（ア）１６０，０００円　　（イ）元本払戻金（特別分配金）",
        "choice3": "（ア）１６０，０００円　　（イ）普通分配金",
        "choice4": "",
        "choice5": "2022.01",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 299,
        "shikenId": 8,
        "no": 9,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "建築基準法に従い、下記＜資料＞の土地に建築物を建築する場合、その土地に対する建築物の建築面積の最高限度として、正しいものはどれか。なお、記載のない条件については一切考慮しないこととする。<br><img src='/img/8_8.png' style='max-width:680px'/>",
        "question2": "",
        "choice1": "３６０㎡",
        "choice2": "１，８００㎡",
        "choice3": "２，８８０㎡",
        "choice4": "",
        "choice5": "2020.09",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 300,
        "shikenId": 8,
        "no": 10,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "借地借家法に基づく定期借地権に関する下表の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><img src='/img/8_9_2.png' style='max-width:680px'/>",
        "question2": "",
        "choice1": "（ア）30年 （イ）制限なし （ウ）公正証書等の書面",
        "choice2": "（ア）50年 （イ）制限なし （ウ）公正証書",
        "choice3": "（ア）50年 （イ）公正証書等の書面 （ウ）公正証書",
        "choice4": "",
        "choice5": "2024年５月公表",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 301,
        "shikenId": 8,
        "no": 11,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "都市計画法に基づく都市計画区域に関する下表の空欄（ア）～（ウ）にあてはまる数値または語句の組み合わせとして、最も適切なものはどれか。<br><img src='/img/8_10.png' style='max-width:680px'/>",
        "question2": "",
        "choice1": "（ア）  ５   （イ）抑制 （ウ）用途地域",
        "choice2": "（ア） １０  （イ）抑制 （ウ）区域区分",
        "choice3": "（ア） １０  （イ）調整 （ウ）区域区分",
        "choice4": "",
        "choice5": "2024.01",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 302,
        "shikenId": 8,
        "no": 12,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "露木忠則さんが加入している生命保険（下記＜資料＞参照）の保障内容に関する次の記述の空欄（ア）にあてはまる金額として、正しいものはどれか。なお、保険契約は有効に継続しているものとし、特約は自動更新されているものとする。また、忠則さんはこれまでに＜資料＞の保険から保険金および給付金を一度も受け取っていないものとする。<br><img src='/img/8_11.png' style='max-width:680px'/>",
        "question2": "",
        "choice1": "５１５万円",
        "choice2": " ５２０万円",
        "choice3": "５２４万円",
        "choice4": "",
        "choice5": "2021.05改",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 303,
        "shikenId": 8,
        "no": 13,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "浅田和久さんが本年中に支払った生命保険の保険料は下記＜資料＞のとおりである。この場合の和久さんの本年分の所得税の計算における生命保険料控除の金額として、正しいものはどれか。なお、下記＜資料＞の保険について、これまでに契約内容の変更はないものとする。また、本年分の生命保険料控除額が最も多くなるように計算すること。<br><img src='/img/8_12.png' style='max-width:680px'/>",
        "question2": "",
        "choice1": " ３４，５８０円",
        "choice2": "４０，０００円",
        "choice3": "６０，１８０円",
        "choice4": "",
        "choice5": "2021.05改",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 304,
        "shikenId": 8,
        "no": 14,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "横川昭二さんが契約している普通傷害保険（個人賠償責任特約付帯）の内容は下記＜資料（一部抜粋）＞のとおりである。次の記述のうち、保険金の支払い対象となるものはどれか。なお、いずれも保険期間中に発生したものであり、＜資料＞に記載のない事項については一切考慮しないこととする。<br><img src='/img/8_13.png' style='max-width:680px'/>",
        "question2": "",
        "choice1": "昭二さんが徒歩で通勤する途中に他人の運転する車にはねられて死亡した場合。",
        "choice2": "昭二さんが自動車を運転中に、誤って歩行者に接触し、ケガをさせたことにより法律上の損害賠償責任を負った場合。",
        "choice3": " 昭二さんが地震により倒れてきた家財で肩を打撲し、通院した場合。",
        "choice4": "",
        "choice5": "2021.05改",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 305,
        "shikenId": 8,
        "no": 15,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "会社員の室井さんは、本年中に勤務先を定年退職した。室井さんの退職に係るデータが下記＜資料＞のとおりである場合、室井さんの所得税に係る退職所得の金額として、正しいものはどれか。なお、室井さんは役員であったことはなく、退職は障害者になったことに基因するものではない。また、前年以前に受け取った退職金はないものとする。<br><img src='/img/8_14.png' style='max-width:680px'/>",
        "question2": "",
        "choice1": "２，４４０万円",
        "choice2": "２，０６０万円",
        "choice3": "１，２２０万円",
        "choice4": "",
        "choice5": "2021.01改",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 306,
        "shikenId": 8,
        "no": 16,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "佐野さんは、個人でアパートの賃貸をしている青色申告者である。佐野さんの本年分の所得および所得控除が下記＜資料＞のとおりである場合、佐野さんの本年分の所得税額として、正しいものはどれか。なお、佐野さんに＜資料＞以外の所得はなく、復興特別所得税や税額控除、源泉徴収税額、予定納税等については一切考慮しないこととする。<br><img src='/img/8_15.png' style='max-width:680px'>",
        "question2": "",
        "choice1": "９１２，５００円",
        "choice2": "１，１５８，０００円",
        "choice3": "１，３４０，０００円",
        "choice4": "",
        "choice5": "2021.01改",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 307,
        "shikenId": 8,
        "no": 17,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "所得税の青色申告特別控除に関する次の記述の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><img src='/img/8_16.png' style='max-width:680px'>",
        "question2": "",
        "choice1": "（ア）損益計算書　　（イ）１０万円　　（ウ）５５万円",
        "choice2": "（ア）損益計算書　　（イ）５５万円　　（ウ）６５万円",
        "choice3": "（ア）収支内訳書　　（イ）５５万円　　（ウ）６５万円",
        "choice4": "",
        "choice5": "2024.01",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 308,
        "shikenId": 8,
        "no": 18,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "本年９月１日に相続が開始された宇野沙織さん（被相続人）の＜親族関係図＞が下記のとおりである場合、民法上の相続人および法定相続分の組み合わせとして、正しいものはどれか。なお、記載のない条件については一切考慮しないこととする。<br><img src='/img/8_17.png' style='max-width:680px'>",
        "question2": "",
        "choice1": "康史　１／２　　昭雄　１／４　　小百合　１／４",
        "choice2": "康史　２／３　　昭雄　１／６　　小百合　１／６",
        "choice3": "康史　２／３　　明人　１／３",
        "choice4": "",
        "choice5": "2022.09改",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 309,
        "shikenId": 8,
        "no": 19,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "妹尾勇二さん（７８歳）は、将来発生するであろう自身の相続について、遺産分割等でのトラブルを防ぐために公正証書遺言の作成を検討しており、ＦＰの塩谷さんに相談をした。公正証書遺言に関する塩谷さんの次の説明のうち、最も適切なものはどれか。",
        "question2": "",
        "choice1": "「すでに作成した公正証書遺言を撤回したい場合、自筆証書遺言では撤回することはできません。」",
        "choice2": "「公正証書遺言を作成する場合、証人の立会いは必要ありません。」",
        "choice3": "「公正証書遺言を作成した場合、相続発生後、家庭裁判所に対してその検認を請求する必要はありません。」",
        "choice4": "",
        "choice5": "2022.09改",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 310,
        "shikenId": 8,
        "no": 20,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "細川亜実さん（３２歳）が本年中に贈与を受けた財産の価額と贈与者は以下のとおりである。亜実さんの本年分の贈与税額として、正しいものはどれか。なお、本年中において、亜実さんはこれ以外の財産の贈与を受けておらず、相続時精算課税制度は選択していないものとする。<br><img src='/img/8_20.png' style='max-width:680px'>",
        "question2": "",
        "choice1": "４２５，０００円",
        "choice2": " ６２０，０００円",
        "choice3": " ７３０，０００円",
        "choice4": "",
        "choice5": "2022.09改",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 311,
        "shikenId": 9,
        "no": 1,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/311_1.png'/>",
        "question2": "はじめに、 Mさんは、 Aさんが老齢基礎年金の受給を65歳から開始した場合の年金額を試算した。Mさんが試算した老齢基礎年金の年金額の計算式として、次のうち最も適切なものはどれか。なお、老齢基礎年金の年金額は、2025年度価額に基づいて計算するものとする。",
        "choice1": "<img src='/img/311_2.png' style=' height: 45px;margin-top: -10px;'/>",
        "choice2": "<img src='/img/311_3.png' style=' height: 45px;margin-top: -10px;margin-left:2px'/>",
        "choice3": "<img src='/img/311_4.png' style=' height: 47px;margin-top: -13px;margin-left:2px'/>",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "老齢基礎年金",
        "important": ""
    },
    {
        "id": 312,
        "shikenId": 9,
        "no": 2,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/311_1.png'/>",
        "question2": "次に、Mさんは、小規模企業共済制度について説明した。Mさんが、Aさんに対して説明した以下の文章の空欄①～③に入る語句の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/312_1.png'/>",
        "choice1": "① 70,000 円　　② ２分の１相当額　　③ 一時所得",
        "choice2": "① 68,000 円　　② ２分の１相当額　　③ 退職所得",
        "choice3": "① 70,000 円　　② 全額　　　　　　　③ 退職所得",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "小規模企業共済",
        "important": ""
    },
    {
        "id": 313,
        "shikenId": 9,
        "no": 3,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/311_1.png'/>",
        "question2": "最後に、Mさんは、老後の年金収入を増やすことができる各種制度について説明した。MさんのAさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「国民年金の付加保険料を納付することで、将来の年金収入を増やすことができます。仮に、Aさんが付加保険料を120月納付し、65歳から老齢基礎年金を受給する場合は、年額48,000円の付加年金を受給することができます」",
        "choice2": "「国民年金基金は、国民年金の第１号被保険者の老齢基礎年金に上乗せする年金を支給する任意加入の年金制度です。加入は口数制となっており、１口目は２種類の終身年金（A型・B型）のいずれかを選択します」",
        "choice3": "「Aさんが確定拠出年金の個人型年金に加入する場合、国民年金の付加保険料の納付および国民年金基金への加入はできません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "付加年金と確定拠出年金",
        "important": ""
    },
    {
        "id": 314,
        "shikenId": 9,
        "no": 4,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/314_1.png'/>",
        "question2": "Ｍさんは、《設例》の米ドル建定期預金について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「米ドル建定期預金の満期時の為替レートが、預入時の為替レートに比べて円高・米ドル安となった場合、円換算の運用利回りは向上します」",
        "choice2": "「Ｘ銀行に預け入れた米ドル建定期預金は、金額の多寡にかかわらず、預金保険制度の保護の対象となりません」",
        "choice3": "「Ｘ銀行の米ドル建定期預金に10,000米ドルを預け入れた場合、Ａさんが満期時に受け取ることができる利息額は400米ドル（税引前）になります」",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "外貨預金の性質",
        "important": ""
    },
    {
        "id": 315,
        "shikenId": 9,
        "no": 5,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/314_1.png'/>",
        "question2": "Ａさんが、《設例》および下記の＜資料＞の条件で、10,000米ドルを預け入れ、満期時に円貨で受け取った場合における元利金の合計額として、次のうち最も適切なものはどれか。なお、計算にあたっては税金等を考慮せず、預入期間６カ月は0.5年として計算すること。<br><img src='/img/315_1.png'/>",
        "choice1": "1,326,000 円",
        "choice2": "1,331,100 円",
        "choice3": "1,336,200 円",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "外貨預金の計算",
        "important": ""
    },
    {
        "id": 316,
        "shikenId": 9,
        "no": 6,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/314_1.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、《設例》の米ドル建定期預金に係る課税関係について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る語句の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/316_1.png'/>",
        "choice1": "①源泉分離課税　　②雑所得　　　③できません",
        "choice2": "①源泉分離課税　　②一時所得　　③できます",
        "choice3": "①申告分離課税　　②雑所得　　　③できます",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "外貨預金の課税関係",
        "important": ""
    },
    {
        "id": 317,
        "shikenId": 9,
        "no": 7,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/317_1.png'/>",
        "question2": "Aさんの本年分の所得税における総所得金額は、次のうちどれか。<br><img src='/img/318_1_2.png'/>",
        "choice1": "595万円",
        "choice2": "605万円",
        "choice3": "615万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "総所得金額の計算",
        "important": ""
    },
    {
        "id": 318,
        "shikenId": 9,
        "no": 8,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/317_1.png'/>",
        "question2": "Aさんの本年分の所得税における所得控除に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「Aさんが適用を受けることができる基礎控除の控除額は、38万円です」",
        "choice2": "「Aさんが適用を受けることができる扶養控除の控除額は、101万円です」",
        "choice3": "「Aさんが適用を受けることができる配偶者控除の控除額は、48万円です」",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得控除",
        "important": ""
    },
    {
        "id": 319,
        "shikenId": 9,
        "no": 9,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/317_1.png'/>",
        "question2": "Aさんの本年分の所得税の課税に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「Aさんが本年中に支払った長男Cさんの国民年金保険料は、その全額を社会保険料控除として総所得金額等から控除することができます」",
        "choice2": "「Aさんが受け取った一時払養老保険の満期保険金に係る差益は、源泉分離課税の対象となります」",
        "choice3": "「Aさんは、不動産所得の金額が20万円を超えるため、所得税の確定申告をしなければなりません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税の課税関係",
        "important": ""
    },
    {
        "id": 320,
        "shikenId": 9,
        "no": 10,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/320_1.png'/>",
        "question2": "甲土地に賃貸マンション（耐火建築物）を建築する場合の①建蔽率の上限となる建築面積と②容積率の上限となる延べ面積の組合せとして、次のうち最も適切なものはどれか。",
        "choice1": "① 630㎡　　　② 2,700㎡",
        "choice2": "① 720㎡　　　② 2,160㎡",
        "choice3": "① 720㎡　　　② 2,700㎡",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "建蔽率と容積率の計算",
        "important": ""
    },
    {
        "id": 321,
        "shikenId": 9,
        "no": 11,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/320_1.png'/>",
        "question2": "甲土地の有効活用に関する以下の文章の空欄①～③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/321_1.png'/>",
        "choice1": "①借地権割合×賃貸割合　　②70　　③400",
        "choice2": "①（１－借地権割合×賃貸割合）　　②70　　③200",
        "choice3": "①（１－借地権割合×借家権割合×賃貸割合）　　②60　　③200",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "宅地の評価",
        "important": ""
    },
    {
        "id": 322,
        "shikenId": 9,
        "no": 12,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/320_1.png'/>",
        "question2": "甲土地の有効活用に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「等価交換方式により、マンションを建築する手法が考えられます。Aさんとしては、自己資金を使わず、マンション住戸を取得することができます」",
        "choice2": "「事業用定期借地権方式により、甲土地を一定期間賃貸する手法が考えられます。甲土地を手放さず、安定した地代収入を得ることができます」",
        "choice3": "「建設協力金方式により、甲土地上に建築した店舗をテナントに貸し出す手法が考えられます。契約期間満了後、借主であるテナントが建物を撤去し、甲土地は更地で返還されます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "土地の有効活用",
        "important": ""
    },
    {
        "id": 323,
        "shikenId": 9,
        "no": 13,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/323_1.png'/>",
        "question2": "Aさんの相続に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「相続人が自宅に保管されていたAさんの自筆証書遺言を発見した場合、相続人は、遅滞なく、自筆証書遺言を法務局に提出して、その検認を請求しなければなりません」",
        "choice2": "「Aさんが本年分の所得税および復興特別所得税について確定申告書を提出しなければならない場合に該当するとき、相続人は、原則として、相続の開始があったことを知った日の翌日から４カ月以内に準確定申告書を提出しなければなりません」",
        "choice3": "「相続税の申告書は、原則として、相続の開始があったことを知った日の翌日から10カ月以内に被相続人であるAさんの死亡時の住所地を所轄する税務署長に提出しなければなりません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続の基礎知識",
        "important": ""
    },
    {
        "id": 324,
        "shikenId": 9,
        "no": 14,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/323_1.png'/>",
        "question2": "Aさんの相続に関する以下の文章の空欄①～③に入る数値の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/324_1.png'/>",
        "choice1": "① 4,200　　② 4,500　　③ 4,000",
        "choice2": "① 4,800　　② 1,500　　③ 4,000",
        "choice3": "① 4,800　　② 4,500　　③ 1,000",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "課税価格の計算におけるルール",
        "important": ""
    },
    {
        "id": 325,
        "shikenId": 9,
        "no": 15,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/323_1.png'/>",
        "question2": "Aさんの相続に係る課税遺産総額（「 課税価格の合計額  遺産に係る基礎控除額」） が２億9 , 000 万円であった場合の相続税の総額は、次のうちどれか。<br><img src='/img/325_1.png'/>",
        "choice1": "7,050 万円",
        "choice2": "9,050 万円",
        "choice3": "１億350 万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税額の計算",
        "important": ""
    },
    {
        "id": 326,
        "shikenId": 10,
        "no": 1,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/326_1.png'/>",
        "question2": "はじめに、 Mさんは、《設例》の＜Aさん夫妻に関する資料＞に基づき、 Aさんおよび妻Bさんが老齢基礎年金の受給を65歳から開始した場合の年金額（2025年度価額）を試算した。Mさんが試算した老齢基礎年金の年金額の計算式の組合せとして、次のうち最も適切なものはどれか。",
        "choice1": "<img src='/img/326_2.png' style=' height: 45px;margin-top: -10px;'/>",
        "choice2": "<img src='/img/326_3.png' style=' height: 45px;margin-top: -10px;'/>",
        "choice3": "<img src='/img/326_4.png' style=' height: 45px;margin-top: -11px;'/>",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "老齢基礎年金",
        "important": ""
    },
    {
        "id": 327,
        "shikenId": 10,
        "no": 2,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/326_1.png'/>",
        "question2": "次に、Mさんは、老齢基礎年金の繰上げ支給および繰下げ支給について説明した。Mさんが、Aさんに対して説明した以下の文章の空欄①～③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/327_1.png'/>",
        "choice1": "① 65　　② 30　　③ しなければなりません",
        "choice2": "① 66　　② 30　　③ するかどうか選択することができます",
        "choice3": "① 66　　② 42　　③ しなければなりません",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "繰上げ支給と繰下げ支給",
        "important": ""
    },
    {
        "id": 328,
        "shikenId": 10,
        "no": 3,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/326_1.png'/>",
        "question2": "最後に、Mさんは、Aさんおよび妻Bさんが受給することができる公的年金制度からの老齢給付について説明した。MさんのAさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「Aさんには国民年金の未加入期間がありますが、60歳から65歳になるまでの間、その未加入期間に相当する月数について、国民年金に任意加入して保険料を納付した場合、老齢基礎年金の年金額を増額することができます」",
        "choice2": "「Aさんが65歳から受給することができる老齢厚生年金の額には、配偶者の加給年金額が加算されます」",
        "choice3": "「妻Bさんは、原則として64歳から報酬比例部分のみの特別支給の老齢厚生年金を受給することができます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "老齢給付",
        "important": ""
    },
    {
        "id": 329,
        "shikenId": 10,
        "no": 4,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/329_1.png'/>",
        "question2": "はじめに、Mさんは、現時点の必要保障額を試算することにした。下記の＜算式＞および＜条件＞に基づき、Aさんが現時点で死亡した場合の必要保障額は、次のうちどれか。<br><img src='/img/329_2.png'/>",
        "choice1": "4,004 万円",
        "choice2": "6,004 万円",
        "choice3": "１億3,504 万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク（個人）",
        "rontenName": "必要保障額の計算",
        "important": ""
    },
    {
        "id": 330,
        "shikenId": 10,
        "no": 5,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/329_1.png'/>",
        "question2": "次に、Mさんは、生命保険の加入について説明した。MさんのAさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「Aさんが提案を受けた生命保険の死亡保障の金額は、現時点での必要保障額をカバーしていません。どの程度の死亡保障を準備するか、支出可能な保険料を把握したうえでご検討ください」",
        "choice2": "「生命保険は、一度加入したら終わりではありません。必要保障額は、通常、お子さまの成長とともに逓増していきますので、ライフイベントに合わせて、保障内容を定期的に見直すことが大切です」",
        "choice3": "「保障金額や保障内容を準備するうえでは、目的に応じた加入をされることをお勧めします。例えば、Aさんの葬儀費用やお子さまの教育資金は終身保険や定期保険特約等の一時金タイプで準備し、残されたご家族の生活費は収入保障特約等の年金タイプで準備することなどが考えられます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク（個人）",
        "rontenName": "生命保険の見直し",
        "important": ""
    },
    {
        "id": 331,
        "shikenId": 10,
        "no": 6,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/329_1.png'/>",
        "question2": "最後に、Mさんは、Aさんが提案を受けた生命保険の保障内容について説明した。MさんのAさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「Aさんが、がんに罹患した場合、三大疾病一時金特約から200万円を受け取ることができます。ただし、通常、がんの保障については契約日から４カ月間の免責期間があります」",
        "choice2": "「Aさんが提案を受けた生命保険には、総合医療特約が付加されていますが、がん保障に特化したものや、入院１日目（日帰り入院）から相応の一時金が支払われるものなど、Aさんのニーズに合わせて医療保障を充実させることも検討事項の１つになります」",
        "choice3": "「Aさんが、厚生労働大臣が定めた先進医療による療養を受けた場合、先進医療特約から先進医療給付金を受け取ることができます。また、所定の先進医療については、一部の医療機関において、保険会社から医療機関へ直接技術料を支払う制度もありますので、特約に関する内容をご確認ください」",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク（個人）",
        "rontenName": "第三分野の保険",
        "important": ""
    },
    {
        "id": 332,
        "shikenId": 10,
        "no": 7,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/332_1.png'/>",
        "question2": "仮に、将来X社がAさんに役員退職金5,000万円を支給した場合、 Aさんが受け取る役員退職金に係る退職所得の金額として、次のうち最も適切なものはどれか。なお、 Aさんの役員在任期間（勤続年数）を40年とし、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。",
        "choice1": "1,400万円",
        "choice2": "1,700万円",
        "choice3": "2,800万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク（法人）",
        "rontenName": "退職所得の計算",
        "important": ""
    },
    {
        "id": 333,
        "shikenId": 10,
        "no": 8,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/332_1.png'/>",
        "question2": "Mさんは、 Aさんに提案した養老保険（福利厚生プラン）について説明した。MさんのAさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「福利厚生プランは、原則として、役員・従業員全員を被保険者とすることになりますので、制度導入後に入社した従業員について加入漏れがないようにご注金財 保険顧客資産相談業務意ください」",
        "choice2": "「当該養老保険の支払保険料は、その全額を福利厚生費として損金の額に算入することができます」",
        "choice3": "「当該養老保険の保険期間中に被保険者である従業員が中途（生存）退職したときは、退職した従業員本人に保険会社から解約返戻金が退職金として直接支払われます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク（法人）",
        "rontenName": "法人の生命保険商品",
        "important": ""
    },
    {
        "id": 334,
        "shikenId": 10,
        "no": 9,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/332_1.png'/>",
        "question2": "Mさんは、中小企業退職金共済制度（以下、「中退共」という）について説明した。Mさんが、 Aさんに対して説明した以下の文章の空欄①～③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/332_1_2.png'/>",
        "choice1": "① 20,000　　② ４分の１　　③ １",
        "choice2": "① 30,000　　② ２分の１　　③ １",
        "choice3": "① 80,000　　② ２分の１　　③ ２",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク（法人）",
        "rontenName": "中退共",
        "important": ""
    },
    {
        "id": 335,
        "shikenId": 10,
        "no": 10,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/335_1.png'/>",
        "question2": "Aさんの本年分の所得税における総所得金額は、次のうちどれか。<br><img src='/img/335_2.png'/>",
        "choice1": "592 万円",
        "choice2": "642 万円",
        "choice3": "780 万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "総所得金額の計算",
        "important": ""
    },
    {
        "id": 336,
        "shikenId": 10,
        "no": 11,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/335_1.png'/>",
        "question2": "Aさんの本年分の所得税の課税に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「  Ａ  さんが受け取った一時払変額個人年金保険の解約返戻金は、源泉分離課税の対象となります」",
        "choice2": " 「  Ａ  さんが適用を受けることができる配偶者控除の額は、38 万円です」",
        "choice3": " 「  Ａ  さんが適用を受けることができる扶養控除の額は、63 万円です」",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税の課税",
        "important": ""
    },
    {
        "id": 337,
        "shikenId": 10,
        "no": 12,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/335_1.png'/>",
        "question2": "住宅借入金等特別控除に関する以下の文章の空欄①～③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/337_1.png'/>",
        "choice1": "①　0.7　　　②　13　　　③　住所地",
        "choice2": "①　1.0　　　②　10　　　③　住所地",
        "choice3": "①　0.7　　　②　10　　　③　勤務地",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "住宅借入金等特別控除",
        "important": ""
    },
    {
        "id": 338,
        "shikenId": 10,
        "no": 13,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/338_1.png'/>",
        "question2": "生前贈与に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「Aさんが長女Cさんに現金を贈与し、長女Cさんが暦年課税を選択した場合、その年にAさんから長女Cさんへ贈与した財産の価額が贈与税の基礎控除額を超えるときは、贈与したAさんが贈与税の申告書を提出しなければなりません」",
        "choice2": "「Aさんが長女Cさんに現金を贈与し、長女Cさんが相続時精算課税制度を選択した場合、累計で3,000万円までの贈与について贈与税は課されません」",
        "choice3": "「Aさんが長女Cさんに現金を贈与し、長女Cさんが相続時精算課税制度を選択した場合、その選択をした年分以降にAさんから長女Cさんへ贈与する財産について、暦年課税へ変更することはできません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税の基礎知識",
        "important": ""
    },
    {
        "id": 339,
        "shikenId": 10,
        "no": 14,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/338_1.png'/>",
        "question2": "Aさんの相続等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「妻Bさんが自宅の敷地を相続により取得し、『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けた場合、自宅の敷地について相続税の課税価格に算入すべき価額は5,600万円となります」",
        "choice2": "「円滑な遺産分割のための手段として遺言書の作成をお勧めします。自筆証書遺言は、その遺言の全文および財産目録をパソコンで作成し、日付および氏名を自書して押印することで作成することができます」",
        "choice3": "「契約者（＝保険料負担者）および被保険者をAさん、死亡保険金受取人を推定相続人とする終身保険に加入することをお勧めします。死亡保険金受取人が受け取る死亡保険金は、『500万円×法定相続人の数』を限度として、死亡保険金の非課税金額の規定の適用を受けることができます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税の基礎知識",
        "important": ""
    },
    {
        "id": 340,
        "shikenId": 10,
        "no": 15,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/338_1.png'/>",
        "question2": "仮に、Aさんの相続が現時点（本年５月23日）で開始し、Aさんの相続に係る課税遺産総額（課税価格の合計額－遺産に係る基礎控除額）が9,000万円であった場合の相続税の総額は、次のうちどれか。<br><img src='/img/340_1.png' style='width:430px;'/>",
        "choice1": "1,200 万円",
        "choice2": "1,275 万円",
        "choice3": "2,000 万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税額の計算",
        "important": ""
    },
    {
        "id": 1000,
        "shikenId": 11,
        "no": 1,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "税理士資格を有しないファイナンシャル・プランナーが、顧客のために相談業務の延長として確定申告書を作成した場合、その行為が無償であれば税理士法に抵触しない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "関連法規とコンプライアンス",
        "important": ""
    },
    {
        "id": 1001,
        "shikenId": 11,
        "no": 2,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "遺族基礎年金を受給することができる遺族は、国民年金の被保険者等の死亡の当時に、その者によって生計を維持されており、かつ、所定の要件を満たす「子のある妻」または「子」である。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "遺族基礎年金",
        "important": ""
    },
    {
        "id": 1002,
        "shikenId": 11,
        "no": 3,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "労働者災害補償保険（労災保険）の保険料は、事業主と労働者が折半で負担する。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "労災保険の保険料",
        "important": ""
    },
    {
        "id": 1003,
        "shikenId": 11,
        "no": 4,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "確定拠出年金の老齢給付金を60歳から受給するには、60歳到達時の通算加入者等期間が10年以上なければならない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "確定拠出年金",
        "important": ""
    },
    {
        "id": 1004,
        "shikenId": 11,
        "no": 5,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "住宅金融支援機構と民間金融機関が提携した住宅ローンであるフラット35の融資金利は固定金利であるが、その利率は取扱金融機関がそれぞれ独自に決定している。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "フラット35",
        "important": ""
    },
    {
        "id": 1005,
        "shikenId": 11,
        "no": 6,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "民法および失火の責任に関する法律（失火責任法）において、借家人の軽過失による失火で、借家と隣家を焼失させた場合、借家の家主に対して損害賠償責任を負うが、隣家の所有者に対して損害賠償責任を負わない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "失火責任法",
        "important": ""
    },
    {
        "id": 1006,
        "shikenId": 11,
        "no": 7,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "生命保険の保険料のうち、保険会社が保険契約を維持・管理するための費用に当てられる付加保険料は、予定死亡率および予定利率に基づいて計算される。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険料の仕組み",
        "important": ""
    },
    {
        "id": 1007,
        "shikenId": 11,
        "no": 8,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "一般に、収入保障保険の死亡保険金を年金形式で受け取る場合の受取総額は、一時金で受け取る場合の受取額よりも少なくなる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "収入保障保険",
        "important": ""
    },
    {
        "id": 1008,
        "shikenId": 11,
        "no": 9,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "生命保険契約にある入院特約に基づき、被保険者が病気で入院したことで被保険者が受け取った入院給付金は、非課税である。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "給付金と税金",
        "important": ""
    },
    {
        "id": 1009,
        "shikenId": 11,
        "no": 10,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "自動車損害賠償責任保険において、被害者１人当たりの保険金の支払限度額は、死亡の場合で3,000万円、後遺障害の場合で5,000万円である。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "自動車損害賠償責任保険",
        "important": ""
    },
    {
        "id": 1010,
        "shikenId": 11,
        "no": 11,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "米国の市場金利が上昇し、日本の市場金利が低下することは、米ドルと円の為替相場においては、一般に、米ドル安、円高の要因となる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "為替相場の変動要因",
        "important": ""
    },
    {
        "id": 1011,
        "shikenId": 11,
        "no": 12,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "上場投資信託（ＥＴＦ）は、上場株式と同様に、指値注文や成行注文により売買することができる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "上場投資信託（ETF）",
        "important": ""
    },
    {
        "id": 1012,
        "shikenId": 11,
        "no": 13,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "一般に、市場金利が上昇すると債券価格は下落し、債券の利回りは低下する。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "債券と利回りの関係",
        "important": ""
    },
    {
        "id": 1013,
        "shikenId": 11,
        "no": 14,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "Ｘ社の株価が1,200円、１株当たり純利益が24円、１株当たり年間配当金が12円である場合、Ｘ社株式の配当利回りは、１％である。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "株式の投資指標の計算",
        "important": ""
    },
    {
        "id": 1014,
        "shikenId": 11,
        "no": 15,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "預金保険制度の対象金融機関に預け入れた決済用預金は、預入金額にかかわらず、その全額が預金保険制度による保護の対象となる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "預金保険制度",
        "important": ""
    },
    {
        "id": 1015,
        "shikenId": 11,
        "no": 16,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "個人が法人からの贈与により取得した財産は、原則として贈与税の課税対象となり、所得税は課されない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "贈与財産の課税",
        "important": ""
    },
    {
        "id": 1016,
        "shikenId": 11,
        "no": 17,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "電車・バス等の交通機関を利用して通勤している給与所得者が、勤務先から受ける通勤手当の所得税法上の非課税限度額は、月額10万円である。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "非課税所得",
        "important": ""
    },
    {
        "id": 1017,
        "shikenId": 11,
        "no": 18,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "所得税において、事業的規模で行われている賃貸マンションの貸付で得た所得は、不動産所得となる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "不動産所得",
        "important": ""
    },
    {
        "id": 1018,
        "shikenId": 11,
        "no": 19,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "上場不動産投資信託（J-REIT）の分配金は、確定申告により所得税の配当控除の適用を受けられる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "上場不動産投資信託の分配金",
        "important": ""
    },
    {
        "id": 1019,
        "shikenId": 11,
        "no": 20,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "夫が生計を一にする妻の負担すべき国民年金の保険料を支払った場合、その支払った金額は、夫の所得税において、社会保険料控除の対象となる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "社会保険料控除",
        "important": ""
    },
    {
        "id": 1020,
        "shikenId": 11,
        "no": 21,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "アパートやマンションを貸して家賃収入を得ようとする場合、宅地建物取引業の免許が必要となる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "宅地建物取引業法",
        "important": ""
    },
    {
        "id": 1021,
        "shikenId": 11,
        "no": 22,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "不動産取引において、買主が売主に解約手付を交付したときは、相手方が契約の履行に着手するまでは、買主はその手付を放棄することで、売主はその手付を買主に現実に提供することで、契約を解除することができる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "手付金",
        "important": ""
    },
    {
        "id": 1022,
        "shikenId": 11,
        "no": 23,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "都市計画法の規定によれば、市街化区域内で行う開発行為は、その規模にかかわらず、都道府県知事等の許可が必要である。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "開発許可",
        "important": ""
    },
    {
        "id": 1023,
        "shikenId": 11,
        "no": 24,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "不動産取得税は、生前贈与や相続により不動産を取得したときには課されない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産取得税",
        "important": ""
    },
    {
        "id": 1024,
        "shikenId": 11,
        "no": 25,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "土地の譲渡所得のうち、その土地を譲渡した日の属する年の１月１日における所有期間が10年以下のものは、短期譲渡所得に区分される。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の譲渡と所有期間",
        "important": ""
    },
    {
        "id": 1025,
        "shikenId": 11,
        "no": 26,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "相続人が相続の放棄をする場合は、自己のために相続の開始があったことを知った時から、原則として10カ月以内に、家庭裁判所にその旨を申述しなければならない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続の放棄",
        "important": ""
    },
    {
        "id": 1026,
        "shikenId": 11,
        "no": 27,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "被相続人が遺言により相続分や遺産分割方法の指定をしていない場合、共同相続人は全員の協議により遺産を分割することができ、必ずしも法定相続分に従う必要はない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "遺産分割協議",
        "important": ""
    },
    {
        "id": 1027,
        "shikenId": 11,
        "no": 28,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": " 「直系尊属から住宅取得等資金の贈与を受けた場合の贈与税の非課税」による非課税限度額は、受贈者ごとに、取得等した家屋が省エネ等住宅である場合は 1, 000 万円、それ以外の住宅である場合は 500 万円である。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税非課税（住宅資金等）",
        "important": ""
    },
    {
        "id": 1028,
        "shikenId": 11,
        "no": 29,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "相続税の申告書の提出先は、原則として、各相続人の住所地の所轄税務署長である。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税の申告",
        "important": ""
    },
    {
        "id": 1029,
        "shikenId": 11,
        "no": 30,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "相続財産の評価において、相続開始時に保険事故が発生していない生命保険契約に関する権利の価額は、原則として、既払込保険料相当額により評価する。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "生命保険契約に関する権利",
        "important": ""
    },
    {
        "id": 1030,
        "shikenId": 11,
        "no": 31,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "借入金額2,000万円、利率（年率・複利）1％、返済期間15年、元利均等返済でローンを組む場合、毎年の返済額は、下記の＜資料＞の係数を使用して算出すると、（　　）である。<br>＜資料＞利率（年率）１％・期間15年の各種係数<br><table><tr><td style='border:solid 1px #333; text-align:center'>現価係数</td><td style='border:solid 1px #333; text-align:center'>資本回収係数</td><td style='border:solid 1px #333; text-align:center'>減債基金係数</td></tr><tr><td style='border:solid 1px #333; text-align:center'>0.8613</td><td style='border:solid 1px #333; text-align:center'>0.0721</td><td style='border:solid 1px #333; text-align:center'>0.0621</td></tr></table>",
        "choice1": "1,242,000円",
        "choice2": "1,442,000円",
        "choice3": "1,935,059円",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "係数計算",
        "important": ""
    },
    {
        "id": 1031,
        "shikenId": 11,
        "no": 32,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "全国健康保険協会管掌健康保険の被保険者に支給される傷病手当金の額は、１日につき、原則として、傷病手当金の支給を始める日の属する月以前の直近の継続した（ ① ）の各月の標準報酬月額の平均額を30で除した額に、（ ② ）を乗じた額である。",
        "choice1": "①　12カ月間　　②　２分の１",
        "choice2": "①　12カ月間　　②　３分の２",
        "choice3": "①　６カ月間　　②　４分の３",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "傷病手当金",
        "important": ""
    },
    {
        "id": 1032,
        "shikenId": 11,
        "no": 33,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "雇用保険の基本手当を受給するためには、倒産、解雇および雇止めなどの場合を除き、原則として、離職の日以前（ ① ）に被保険者期間が通算して（ ② ）以上あることなどの要件を満たす必要がある。",
        "choice1": "①　１年間　　②　６カ月",
        "choice2": "①　１年間　　②　12カ月",
        "choice3": "①　２年間　　②　12カ月",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "雇用保険の基本手当",
        "important": ""
    },
    {
        "id": 1033,
        "shikenId": 11,
        "no": 34,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "厚生年金保険の被保険者期間が原則として（ ① ）以上ある者が、老齢厚生年金の受給権を取得した当時、当該受給権者と生計を同じくしている（ ② ）未満の配偶者が所定の要件を満たしている場合、当該受給権者が受給する老齢厚生年金に加給年金額が加算される。",
        "choice1": "①　10年　　②　60歳",
        "choice2": "①　20年　　②　65歳",
        "choice3": "①　25年　　②　65歳",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "加給年金",
        "important": ""
    },
    {
        "id": 1034,
        "shikenId": 11,
        "no": 35,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "住宅ローンの返済方法で、元利均等返済方式と元金均等返済方式とで利息を含めた総返済金額を比較すると、返済期間や金利などの他の条件が同一である場合、通常、その額は、（　　）。",
        "choice1": "元利均等返済方式のほうが多い",
        "choice2": "元金均等返済方式のほうが多い",
        "choice3": "どちらも同じ額である",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "元利均等と元金均等",
        "important": ""
    },
    {
        "id": 1035,
        "shikenId": 11,
        "no": 36,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "国内で事業を行う生命保険会社が破綻した場合、生命保険契約者保護機構による補償の対象となる保険契約は、高予定利率契約を除き、（ ① ）の（ ② ）まで補償される。",
        "choice1": "①　責任準備金等　　②　90％",
        "choice2": "①　死亡保険金額　　②　100％",
        "choice3": "①　責任準備金等　　②　80％",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "保険契約者保護",
        "important": ""
    },
    {
        "id": 1036,
        "shikenId": 11,
        "no": 37,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "定期保険特約付終身保険では、定期保険特約の保険金額を同額で自動更新すると、通常は、更新後の保険料が、更新前（　　）。",
        "choice1": "よりも安くなる",
        "choice2": "と変わらない",
        "choice3": "よりも高くなる",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "定期保険の更新",
        "important": ""
    },
    {
        "id": 1037,
        "shikenId": 11,
        "no": 38,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "生命保険契約の契約者は、契約者貸付制度を利用することで、契約している生命保険の（　　）の一定の範囲内で保険会社から貸付を受けることができる。",
        "choice1": "解約返戻金額",
        "choice2": "既払込保険料総額",
        "choice3": "死亡保険金額",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "契約者貸付",
        "important": ""
    },
    {
        "id": 1038,
        "shikenId": 11,
        "no": 39,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "所得税において、個人が本年中に締結した生命保険契約に基づく支払保険料のうち、（　　）に係る保険料は、介護医療保険料控除の対象となる。",
        "choice1": "傷害特約",
        "choice2": "定期保険特約",
        "choice3": "先進医療特約",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険料控除",
        "important": ""
    },
    {
        "id": 1039,
        "shikenId": 11,
        "no": 40,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "家族傷害保険に付帯された個人賠償責任補償特約においては、（　　）により損害賠償責任を負った場合は補償の対象とならない。",
        "choice1": "同居する家族に誤ってけがを負わせた事故",
        "choice2": "別居の未婚の子が自転車で走行中に起こした事故",
        "choice3": "飼い犬が他人を噛んでけがを負わせた事故",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "家族傷害保険",
        "important": ""
    },
    {
        "id": 1040,
        "shikenId": 11,
        "no": 41,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "一定期間内に国内で生産された財やサービスの付加価値の合計額を（ ① ）といい、その統計は（ ② ）が作成し、公表する。",
        "choice1": "①　国民総生産（ＧＮＰ）　　②　内閣府",
        "choice2": "①　国内総生産（ＧＤＰ）　　②　日本銀行",
        "choice3": "①　国内総生産（ＧＤＰ）　　②　内閣府",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "国内総生産（GDP）",
        "important": ""
    },
    {
        "id": 1041,
        "shikenId": 11,
        "no": 42,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "追加型株式投資信託を基準価額１万3,000円で１万口購入した後、最初の決算時に１万口当たり400円の収益分配金が支払われ、分配落ち後の基準価額が１万2,800円となった場合、その収益分配金のうち、普通分配金は（ ① ）であり、元本払戻金（特別分配金）は（ ② ）である。",
        "choice1": "①　400円　　②　0円",
        "choice2": "①　100円　　②　300円",
        "choice3": "①　200円　　②　200円",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "投資信託の分配金の計算",
        "important": ""
    },
    {
        "id": 1042,
        "shikenId": 11,
        "no": 43,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "表面利率（クーポンレート）２％、残存期間４年の固定利付債券を、額面100円当たり104円で購入し、２年後に額面100円当たり103円で売却した場合の所有期間利回り（年率・単利）は、（　　）％である。なお、税金や手数料等は考慮しないものとし、答は表示単位の小数点以下第３位を四捨五入している。",
        "choice1": "0.96",
        "choice2": "1.44",
        "choice3": "2.4",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "債券の利回りの計算",
        "important": ""
    },
    {
        "id": 1043,
        "shikenId": 11,
        "no": 44,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "NISA「成長投資枠」を利用して上場株式や投資信託等を購入することができる限度額（年間投資枠）は、年間（　）である。",
        "choice1": "120万円",
        "choice2": "240万円",
        "choice3": "360万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "NISA成長投資枠",
        "important": ""
    },
    {
        "id": 1044,
        "shikenId": 11,
        "no": 45,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "為替予約を締結していない外貨定期預金の場合、満期時の為替レートが預入時の為替レートに比べて（ ① ）になれば、円換算の利回りは（ ② ）なる。",
        "choice1": "①　円安　　②　高く",
        "choice2": "①　円安　　②　低く",
        "choice3": "①　円高　　②　高く",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "外貨預金",
        "important": ""
    },
    {
        "id": 1045,
        "shikenId": 11,
        "no": 46,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "国内において支払を受ける預貯金の利子は、原則として、国税（復興特別所得税を含む）と地方税を合わせて（ ① ）の税率による（ ② ）分離課税の対象となる。",
        "choice1": "①　15.315％　　②　申告",
        "choice2": "①　20.315％　　②　申告",
        "choice3": "①　20.315％　　②　源泉",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "利子所得",
        "important": ""
    },
    {
        "id": 1046,
        "shikenId": 11,
        "no": 47,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "給与所得者が、30年間勤務した会社を定年退職し、退職金3,000万円の支払を受けた。この場合、所得税の退職所得の金額を計算する際の退職所得控除額は、（　　）となる。",
        "choice1": "800万円＋70万円×（30年－20年）×1/2=1,150万円",
        "choice2": "800万円＋40万円×（30年－20年）＝1,200万円",
        "choice3": "800万円＋70万円×（30年－20年）＝1,500万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "退職所得の計算",
        "important": ""
    },
    {
        "id": 1047,
        "shikenId": 11,
        "no": 48,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "Ａさんの本年分の各種所得の金額が下記の＜資料＞のとおりであった場合、損益通算後の総所得金額は（　　）となる。なお、各種所得の金額に付されている「▲」は、その所得に損失が生じていることを表すものとする。<br>＜資料＞Aさんの本年分の各種所得の金額<br><table><tr><td style='border:solid 1px #333;'>不動産所得の金額</td><td style='border:solid 1px #333;text-align:right'>850万円</td></tr><tr><td style='border:solid 1px #333;'>雑所得の金額</td><td style='border:solid 1px #333;text-align:right'>▲50万円</td></tr><tr><td style='border:solid 1px #333;'>事業所得の金額（株式等に係るものを除く）</td><td style='border:solid 1px #333;text-align:right'>▲200万円</td></tr></table>",
        "choice1": "600万円",
        "choice2": "650万円",
        "choice3": "800万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "総所得金額の計算",
        "important": ""
    },
    {
        "id": 1048,
        "shikenId": 11,
        "no": 49,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税の確定申告をしなければならない者は、原則として、所得が生じた年の翌年の（ ① ）から（ ② ）までの間に、納税地の所轄税務署長に対して確定申告書の提出が必要となる。",
        "choice1": "①　２月１日　　②　３月15日",
        "choice2": "①　２月16日　　②　３月15日",
        "choice3": "①　２月１日　　②　３月31日",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税の確定申告の期限",
        "important": ""
    },
    {
        "id": 1049,
        "shikenId": 11,
        "no": 50,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "年末調整の対象となる給与所得者は、年末調整により、（　　）の適用を受けることができる。",
        "choice1": "雑損控除",
        "choice2": "医療費控除",
        "choice3": "生命保険料控除",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "年末調整",
        "important": ""
    },
    {
        "id": 1050,
        "shikenId": 11,
        "no": 51,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "都道府県地価調査の基準地の標準価格は、毎年（ ① ）を価格判定の基準日として調査され、都道府県知事により毎年（ ② ）頃に公表される。",
        "choice1": "①　１月１日　　②　３月",
        "choice2": "①　１月１日　　②　７月",
        "choice3": "①　７月１日　　②　９月",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "土地の価格",
        "important": ""
    },
    {
        "id": 1051,
        "shikenId": 11,
        "no": 52,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "建築基準法上、都市計画区域および準都市計画区域内において、建築物の敷地は、原則として、幅員（ ① ）以上の道路に（ ② ）以上接していなければならない。",
        "choice1": "①　４ｍ　　②　１ｍ",
        "choice2": "①　４ｍ　　②　２ｍ",
        "choice3": "①　６ｍ　　②　３ｍ",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "接道義務",
        "important": ""
    },
    {
        "id": 1052,
        "shikenId": 11,
        "no": 53,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "建築物が防火地域および準防火地域にわたる場合においては、原則として、その全部について（ ① ）内の建築物に関する規定が適用される。また、建築物の敷地が２つの異なる用途地域にまたがる場合、（ ② ）の用途制限が敷地全体に適用される。",
        "choice1": "①　準防火地域　　②　より厳しい地域",
        "choice2": "①　防火地域　　②　過半の属する地域",
        "choice3": "①　過半の属する地域　　②　より緩い地域",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "防火地域、用途地域",
        "important": ""
    },
    {
        "id": 1053,
        "shikenId": 11,
        "no": 54,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "建物の区分所有等に関する法律（区分所有法）において、集会において、区分所有者および議決権の各（　　）以上の多数により、区分所有建物を取り壊し、その敷地上に新たに建物を建築する旨の決議（建替え決議）をすることができる。",
        "choice1": "２分の１",
        "choice2": "４分の３",
        "choice3": "５分の４",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "区分所有法",
        "important": ""
    },
    {
        "id": 1054,
        "shikenId": 11,
        "no": 55,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 2,
        "question1": "",
        "question2": "被相続人の居住用家屋およびその敷地を相続により単独で取得した被相続人の子が、空き家になっていた当該家屋およびその敷地を譲渡し、「被相続人の居住用財産（空き家）に係る譲渡所得の特別控除の特例」の適用を受けた場合、譲渡所得の金額の計算上、最高（ ）を控除することができる。",
        "choice1": "2,000万円",
        "choice2": "3,000万円",
        "choice3": "5,000万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "空き家の譲渡",
        "important": ""
    },
    {
        "id": 1055,
        "shikenId": 11,
        "no": 56,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "宅地が「小規模宅地等についての相続税の課税価格の計算の特例」における特定居住用宅地等に該当する場合、（ ① ）を限度面積として、評価額の（ ② ）が減額される。",
        "choice1": "①　200㎡　　②　50％",
        "choice2": "①　400㎡　　②　80％",
        "choice3": "①　330㎡　　②　80％",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "小規模宅地等の特例",
        "important": ""
    },
    {
        "id": 1056,
        "shikenId": 11,
        "no": 57,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "下記の〈親族関係図〉において、Ａさんが亡くなった場合の相続における、妻Ｂさんの法定相続分は、（　　）である。<br>＜親族関係図＞<br><img src=\"/img/yoso/1_1.png\" style='width:400px'/>",
        "choice1": "２分の１",
        "choice2": "３分の２",
        "choice3": "４分の３",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "法定相続分",
        "important": ""
    },
    {
        "id": 1057,
        "shikenId": 11,
        "no": 58,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "相続税の計算においては、相続人が受け取った死亡保険金の非課税限度額を、「（ ① ）×法定相続人の数」の算式により算出するが、相続人のうち相続の放棄をした者がいる場合、当該法定相続人の数は、相続を放棄した者を（ ② ）人数とされる。",
        "choice1": "①　500万円　　②　含む",
        "choice2": "①　500万円　　②　含まない",
        "choice3": "①　600万円　　②　含まない",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "死亡保険金の非課税限度額",
        "important": ""
    },
    {
        "id": 1058,
        "shikenId": 11,
        "no": 59,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "本年中に相続時精算課税の適用を受けて贈与を受けた場合、暦年課税とは別枠で適用できる基礎控除および特別控除（累計（ ① ））を差し引いた後の金額に対して一律（ ② ）％の税率により計算した贈与税が課税される。",
        "choice1": "①　1,500万円　　②　15",
        "choice2": "①　1,500万円　　②　20",
        "choice3": "①　2,500万円　　②　20",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続時精算課税制度",
        "important": ""
    },
    {
        "id": 1059,
        "shikenId": 11,
        "no": 60,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "自用地としての価額が6,000万円、借地権割合が60％、借家権割合が30％、賃貸割合が100％の貸家建付地の相続税評価額は、（　　）である。",
        "choice1": "2,400万円",
        "choice2": "3,600万円",
        "choice3": "4,920万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "貸家建付地の計算",
        "important": ""
    },
    {
        "id": 1060,
        "shikenId": 15,
        "no": 1,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "ファイナンシャル・プランナーは、顧客からの依頼であっても、公正証書遺言の作成時に証人となることはできない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "関連法規とコンプライアンス",
        "important": ""
    },
    {
        "id": 1061,
        "shikenId": 15,
        "no": 2,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "後期高齢者医療広域連合の区域内に住所を有する70歳以上の者または60歳以上の者で一定の障害認定を受けた者は、後期高齢者医療制度の被保険者となる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "後期高齢者医療制度",
        "important": ""
    },
    {
        "id": 1062,
        "shikenId": 15,
        "no": 3,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "老齢厚生年金の繰下げ支給の申出は、老齢基礎年金の繰下げ支給の申出と同時に行う必要がある。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "老齢厚生年金の繰下げ支給",
        "important": ""
    },
    {
        "id": 1063,
        "shikenId": 15,
        "no": 4,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "確定拠出年金の個人型年金における老齢給付金を一時金で受け取った場合、当該老齢給付金は、一時所得として所得税の課税対象となる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "確定拠出年金",
        "important": ""
    },
    {
        "id": 1064,
        "shikenId": 15,
        "no": 5,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "住宅ローンの一部繰上げ返済には、一般に、返済期間を変更せずに毎月の返済額を減額する返済額軽減型と、毎月の返済額を変更せずに残りの返済期間を短くする期間短縮型がある。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "住宅ローンの繰上げ返済",
        "important": ""
    },
    {
        "id": 1065,
        "shikenId": 15,
        "no": 6,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "国内で事業を行う少額短期保険業者と結んだ保険契約は、生命保険契約者保護機構および損害保険契約者保護機構による補償の対象とならない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "保険契約者保護",
        "important": ""
    },
    {
        "id": 1066,
        "shikenId": 15,
        "no": 7,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "学資（こども）保険は、保険期間中に契約者が死亡した場合、死亡時点における解約返戻金相当額が支払われることで保険契約が消滅する。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "学資（こども）保険",
        "important": ""
    },
    {
        "id": 1067,
        "shikenId": 15,
        "no": 8,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "個人年金保険（終身年金）契約で、性別以外の契約条件が同一であれば、保険料は被保険者が男性のほうが女性よりも高くなる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "個人年金保険の保険料 ",
        "important": ""
    },
    {
        "id": 1068,
        "shikenId": 15,
        "no": 9,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "逓減定期保険や逓増定期保険は、保険期間の経過に伴い保険料が所定の割合で減少または増加するが、死亡保険金額は保険期間を通じて一定である。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "逓減定期保険、逓増定期保険",
        "important": ""
    },
    {
        "id": 1069,
        "shikenId": 15,
        "no": 10,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "自動車保険の車両保険は、一般に、被保険自動車が台風や大雨により水没したことによる損害は、補償の対象となる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "任意の自動車保険（車両保険）",
        "important": ""
    },
    {
        "id": 1070,
        "shikenId": 15,
        "no": 11,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "一般に、景気動向指数のコンポジット・インデックス（ＣＩ）の一致指数が上昇しているときは、景気の拡張局面とされる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "景気動向指数",
        "important": ""
    },
    {
        "id": 1071,
        "shikenId": 15,
        "no": 12,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "債券の信用格付において BBB（トリプル B）格相当以下である場合には、一般に、投機的格付とされる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "債券のリスク",
        "important": ""
    },
    {
        "id": 1072,
        "shikenId": 15,
        "no": 13,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "上場株式の売買において、普通取引では約定日の翌営業日（約定当日を含め２営業日目）に決済が行われる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "株式の売買",
        "important": ""
    },
    {
        "id": 1073,
        "shikenId": 15,
        "no": 14,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "外貨預金の預入時に、預金者が円貨を外貨に換える場合の適用為替レートは、預入金融機関が提示するＴＴＢである。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "外貨預金",
        "important": ""
    },
    {
        "id": 1074,
        "shikenId": 15,
        "no": 15,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "国内銀行に預け入れられた外貨預金は、預金保険制度における保護の対象となる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "預金保険制度",
        "important": ""
    },
    {
        "id": 1075,
        "shikenId": 15,
        "no": 16,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "所得税や登録免許税は国税であり、住民税や固定資産税は地方税である。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "国税と地方税",
        "important": ""
    },
    {
        "id": 1076,
        "shikenId": 15,
        "no": 17,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税において、老齢基礎年金や老齢厚生年金は非課税所得となる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得の分類",
        "important": ""
    },
    {
        "id": 1077,
        "shikenId": 15,
        "no": 18,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "土地は減価償却資産ではない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "減価償却資産",
        "important": ""
    },
    {
        "id": 1078,
        "shikenId": 15,
        "no": 19,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税における医療費控除の控除額は、その年中に支払った医療費の金額（保険金等により補てんされる金額を除く）の合計額から、その年分の総所得金額等の合計額の10％相当額または５万円のいずれか低いほうの金額を控除して算出される。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "医療費控除",
        "important": ""
    },
    {
        "id": 1079,
        "shikenId": 15,
        "no": 20,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "納税者が生計を一にする配偶者に係る確定拠出年金の個人型年金の掛金を支払う場合、その負担した掛金は、納税者本人に係る所得税の小規模企業共済等掛金控除の対象となる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "小規模企業共済等掛金控除",
        "important": ""
    },
    {
        "id": 1080,
        "shikenId": 15,
        "no": 21,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "不動産登記には公信力が認められていないため、登記記録上の権利者が真実の権利者と異なっている場合に登記記録を信頼して取引をしたとしても、原則として法的に保護されない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産登記",
        "important": ""
    },
    {
        "id": 1081,
        "shikenId": 15,
        "no": 22,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "定期建物賃貸借契約（定期借家契約）では、貸主に正当事由がなければ、貸主は、借主からの契約の更新の請求を拒むことができない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "借家契約の更新",
        "important": ""
    },
    {
        "id": 1082,
        "shikenId": 15,
        "no": 23,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "都市計画法において、市街化調整区域とは、おおむね10年以内に計画的に市街化を図るべき区域をいう。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "都市計画区域",
        "important": ""
    },
    {
        "id": 1083,
        "shikenId": 15,
        "no": 24,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "新築の戸建て住宅の取得に対する不動産取得税の課税標準の算定上、「不動産取得税の課税標準の特例」の適用を受けることにより、固定資産税評価額から最高で1,000万円を控除することができる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産取得税",
        "important": ""
    },
    {
        "id": 1084,
        "shikenId": 15,
        "no": 25,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "「居住用財産を譲渡した場合の3,000万円の特別控除」は、自己が居住していた家屋を配偶者や子に譲渡した場合では、適用を受けることができない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "居住用財産の譲渡の特例（3,000万円特別控除）",
        "important": ""
    },
    {
        "id": 1085,
        "shikenId": 15,
        "no": 26,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "特別養子縁組によって養子となった者については、原則として、養子縁組の成立によって、実方の父母との法律上の親族関係が終了する。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "養子縁組",
        "important": ""
    },
    {
        "id": 1086,
        "shikenId": 15,
        "no": 27,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "相続税の課税価格の計算上、相続人が負担した葬式の際の香典返戻費用は、相続財産の価額から債務控除できる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "債務控除",
        "important": ""
    },
    {
        "id": 1087,
        "shikenId": 15,
        "no": 28,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "相続税額の計算において、「配偶者に対する相続税額の軽減」の適用を受けることにより、納付すべき相続税額が全くなかった場合には、相続税の申告書を提出する必要はない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "配偶者の相続税額の軽減",
        "important": ""
    },
    {
        "id": 1088,
        "shikenId": 15,
        "no": 29,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "被相続人の相続開始前に死亡している被相続人の子を代襲して相続人となった被相続人の孫が、相続により財産を取得した場合には、相続税額の計算上、相続税額の２割加算の対象となる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税額の2割加算",
        "important": ""
    },
    {
        "id": 1089,
        "shikenId": 15,
        "no": 30,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "書面によらない贈与契約は、その履行前であれば、各当事者は契約の解除をすることができる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与契約",
        "important": ""
    },
    {
        "id": 1090,
        "shikenId": 15,
        "no": 31,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "500万円を準備するために、５年間、毎年均等に積み立て、利率（年率）３％で複利運用する場合、必要となる毎年の積立金額は、下記の＜資料＞の係数を使用して算出すると（　　）である。<br><img src=\"/img/yoso/11_1.png\" style='width:400px'/>",
        "choice1": "862,589円",
        "choice2": "942,000円",
        "choice3": "1,092,000円",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "係数計算",
        "important": ""
    },
    {
        "id": 1091,
        "shikenId": 15,
        "no": 32,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "健康保険の任意継続被保険者となるためには、健康保険の被保険者資格を喪失した日の前日まで継続して（ ① ）以上被保険者であった者が、原則として、資格喪失の日から（ ② ）以内に任意継続被保険者の資格取得手続を行う必要がある。",
        "choice1": "①　２カ月　　②　14日",
        "choice2": "①　２カ月　　②　20日",
        "choice3": "①　１年　　②　21日",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "任意継続被保険者",
        "important": ""
    },
    {
        "id": 1092,
        "shikenId": 15,
        "no": 33,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "62 歳 0 カ月で老齢基礎年金の繰上げ支給の請求をし、支給開始を 36 カ月繰り上げた場合、老齢基礎年金の減額率は（ ）となる。",
        "choice1": "14.4％",
        "choice2": "25.2％",
        "choice3": "36.0％",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "老齢基礎年金の繰上げ支給",
        "important": ""
    },
    {
        "id": 1093,
        "shikenId": 15,
        "no": 34,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "障害基礎年金の保険料納付要件は、原則として、初診日の前日において、初診日の属する月の前々月までの国民年金の被保険者期間のうち、保険料納付済期間（保険料免除期間を含む）が（　　）以上あることである。",
        "choice1": "２分の１",
        "choice2": "３分の２",
        "choice3": "４分の３",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "障害基礎年金",
        "important": ""
    },
    {
        "id": 1094,
        "shikenId": 15,
        "no": 35,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "日本学生支援機構が扱う貸与型奨学金には、（ ① ）第一種奨学金と（ ② ）第二種奨学金がある。",
        "choice1": "①　利子付（在学中は無利子）の　　②　利子付（在学中も有利子）の",
        "choice2": "①　無利子の　　②　利子付（在学中は無利子）の",
        "choice3": "①　返済義務のない　　②　無利子の",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "日本学生支援機構の奨学金",
        "important": ""
    },
    {
        "id": 1095,
        "shikenId": 15,
        "no": 36,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "保険業法で定められた保険会社の健全性を示す（ ① ）は、保険金等の支払余力をどの程度有するかを示す指標であり、この値が（ ② ）を下回った場合、監督当局による早期是正措置の対象となる。",
        "choice1": "①　自己資本比率　　②　100％",
        "choice2": "①　ソルベンシー・マージン比率　　②　300％",
        "choice3": "①　ソルベンシー・マージン比率　　②　200％",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "ソルベンシー・マージン",
        "important": ""
    },
    {
        "id": 1096,
        "shikenId": 15,
        "no": 37,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "生命保険契約を、現在加入しているものから契約転換制度を利用して新たな契約に転換する場合、転換後の保険料は（ ① ）の保険料率が適用され、一般に、転換する際には（ ② ）である。",
        "choice1": "①　転換時　　②　告知または診査が必要",
        "choice2": "①　転換時　　②　告知および診査は不要",
        "choice3": "①　転換前の契約時　　②　告知および診査は不要",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "契約転換",
        "important": ""
    },
    {
        "id": 1097,
        "shikenId": 15,
        "no": 38,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "医療保険等に付加される先進医療特約で対象となるのは、（　　）時点において厚生労働大臣により定められている先進医療である。",
        "choice1": "申込日",
        "choice2": "責任開始日",
        "choice3": "療養を受けた日",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "先進医療特約",
        "important": ""
    },
    {
        "id": 1098,
        "shikenId": 15,
        "no": 39,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "生命保険契約において、契約者（＝保険料負担者）が夫、被保険者が（ ① ）、死亡保険金受取人が（ ② ）である場合、被保険者の死亡により死亡保険金受取人が受け取る死亡保険金は、相続税の課税対象となる。",
        "choice1": "①　妻　　②　夫",
        "choice2": "①　夫　　②　子",
        "choice3": "①　妻　　②　子",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険金の課税",
        "important": ""
    },
    {
        "id": 1099,
        "shikenId": 15,
        "no": 40,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "建物に係る地震保険の保険金額は、火災保険の保険金額の（ ① ）の範囲内で、（ ② ）が上限となる。",
        "choice1": "①　30％から50％まで　　②　5,000万円",
        "choice2": "①　30％から50％まで　　②　3,000万円",
        "choice3": "①　50％から80％まで　　②　3,000万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "地震保険",
        "important": ""
    },
    {
        "id": 1100,
        "shikenId": 15,
        "no": 41,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "全国の世帯が購入する家計に関する財およびサービスの価格等を総合した物価の変動を時系列的に測定する（　　）は、総務省が公表している。",
        "choice1": "景気動向指数",
        "choice2": "消費者態度指数",
        "choice3": "消費者物価指数",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "消費者物価指数",
        "important": ""
    },
    {
        "id": 1101,
        "shikenId": 15,
        "no": 42,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "投資信託での（　　）運用は、企業の成長性が市場平均よりも高いと見込まれる銘柄に投資する運用手法とされる。",
        "choice1": "グロース",
        "choice2": "パッシブ",
        "choice3": "バリュー",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "投資信託のタイプ",
        "important": ""
    },
    {
        "id": 1102,
        "shikenId": 15,
        "no": 43,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "上場企業Ｘ社の下記の＜資料＞に基づいて計算したＸ社株式の株価収益率（ＰＥＲ）は（ ① ）、株価純資産倍率（ＰＢＲ）は（ ② ）である。<br><img src=\"/img/yoso/11_2.png\" style='width:400px'/>",
        "choice1": "①　15倍　　②　1.5倍",
        "choice2": "①　10倍　　②　1.5倍",
        "choice3": "①　1.5倍　　②　15倍",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "株式の投資指標の計算",
        "important": ""
    },
    {
        "id": 1103,
        "shikenId": 15,
        "no": 44,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税において、ＮＩＳＡ口座内で生じた上場株式の譲渡損失の金額は、特定口座内の上場株式の譲渡益の金額と損益を通算することが（ ① ）。なお、譲渡益が発生している場合に、非課税とするためには、確定申告は（ ② ）。",
        "choice1": "①　できる　　②　必要である",
        "choice2": "①　できない　　②　不要である",
        "choice3": "①　できない　　②　必要である",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "新NISA",
        "important": ""
    },
    {
        "id": 1104,
        "shikenId": 15,
        "no": 45,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "異なる２資産からなるポートフォリオにおいて、２資産間の相関係数が（ ）のとき、分散投資によるリスクの低減効果は最大となる。",
        "choice1": "＋1",
        "choice2": "０",
        "choice3": "－1",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "相関係数",
        "important": ""
    },
    {
        "id": 1105,
        "shikenId": 15,
        "no": 46,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "上場株式等の配当所得につき申告分離課税を選択した場合、その税率は、所得税および復興特別所得税と住民税の合計で（ ① ）であり、上場株式等の譲渡損失の金額と損益通算することができる。この場合、配当控除の適用を受けることが（ ② ）。",
        "choice1": "①　15.315％　　②　できる",
        "choice2": "①　20.315％　　②　できない",
        "choice3": "①　20.42％　　②　できない",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "配当所得",
        "important": ""
    },
    {
        "id": 1106,
        "shikenId": 15,
        "no": 47,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "所得税において、本年中に取得した建物（鉱業用減価償却資産等を除く）における減価償却の方法は、（　　）である。",
        "choice1": "定額法",
        "choice2": "定率法",
        "choice3": "定額法または定率法",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "減価償却方法",
        "important": ""
    },
    {
        "id": 1107,
        "shikenId": 15,
        "no": 48,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "課税総所得金額300万円に対する所得税額（復興特別所得税額を含まない）は、下記の＜資料＞を使用して算出すると、（　　）である。<br><img src=\"/img/yoso/11_3.png\" style='width:400px'/>",
        "choice1": "97,500円",
        "choice2": "202,500円",
        "choice3": "300,000円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税の計算",
        "important": ""
    },
    {
        "id": 1108,
        "shikenId": 15,
        "no": 49,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "確定申告を要する納税者Ａさんが本年９月25日に死亡した。Ａさんの相続人は、同日にＡさんの相続の開始があったことを知ったため、本年分のＡさんの所得について（　　）（休業日の場合は翌営業日）までにＡさんの死亡当時の納税地の所轄税務署長に対して所得税の準確定申告書を提出しなければならない。",
        "choice1": "本年12月25日",
        "choice2": "翌年１月25日",
        "choice3": "翌年３月25日",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "準確定申告",
        "important": ""
    },
    {
        "id": 1109,
        "shikenId": 15,
        "no": 50,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "青色申告者の所得税の計算において、損益通算してもなお控除しきれない損失の金額（純損失の金額）が生じた場合、所定の要件を満たすことで、その損失の金額を翌年以後（　　）にわたって繰り越して、各年分の所得金額から控除することができる。",
        "choice1": "３年間",
        "choice2": "５年間",
        "choice3": "10年間",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "青色申告",
        "important": ""
    },
    {
        "id": 1110,
        "shikenId": 15,
        "no": 51,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "土地・家屋における固定資産税の課税標準となる価格は、原則として、（　　）ごとの基準年度において評価替えが行われる。",
        "choice1": "２年",
        "choice2": "３年",
        "choice3": "５年",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "固定資産税評価額",
        "important": ""
    },
    {
        "id": 1111,
        "shikenId": 15,
        "no": 52,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "都市計画区域内にある幅員 4 ｍ未満の道で、建築基準法第 42 条第２項により道路とみなされるものについては、原則として、その中心線からの水平距離で（ ① ）後退した線がその道路の境界線とみなされ、当該境界線と道路の間の敷地部分は建蔽率や容積率を算定する際の敷地面積に算入（ ② ）。",
        "choice1": "① ２ｍ　　② することができない",
        "choice2": "① ２ｍ　　② することができる",
        "choice3": "① ４ｍ　　② することができる",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "セットバック ",
        "important": ""
    },
    {
        "id": 1112,
        "shikenId": 15,
        "no": 53,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "農地法によれば、所有する農地を自宅の建築を目的として宅地に転用する場合、原則として（ ① ）の許可を受けなければならないが、市街化区域内にある農地において、あらかじめ（ ② ）に届出のある場合は、この限りでない。",
        "choice1": "①　農業委員会　　②　市町村長",
        "choice2": "①　都道府県知事等　　②　市町村長",
        "choice3": "①　都道府県知事等　　②　農業委員会",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "農地法",
        "important": ""
    },
    {
        "id": 1113,
        "shikenId": 15,
        "no": 54,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "個人が土地・建物を譲渡した場合の譲渡所得の金額の計算において、譲渡した土地・建物の取得費が不明である場合、譲渡収入金額の（　　）相当額を取得費とすることができる。",
        "choice1": "５％",
        "choice2": "10％",
        "choice3": "20％",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "概算取得費",
        "important": ""
    },
    {
        "id": 1114,
        "shikenId": 15,
        "no": 55,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "土地の有効活用のうち、一般に、土地所有者が入居予定の事業会社から建設資金を借り受けて、事業会社の要望に沿った店舗等を建設し、その店舗等を事業会社に賃貸する手法を、 （ ）という。",
        "choice1": "等価交換方式",
        "choice2": "事業受託方式",
        "choice3": "建設協力金方式",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "土地の有効活用",
        "important": ""
    },
    {
        "id": 1115,
        "shikenId": 15,
        "no": 56,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "死因贈与によって個人が取得した財産は、課税の対象とならない財産を除き、（　　）の課税対象となる。",
        "choice1": "贈与税",
        "choice2": "相続税",
        "choice3": "所得税",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "死因贈与",
        "important": ""
    },
    {
        "id": 1116,
        "shikenId": 15,
        "no": 57,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "贈与税の申告書は、原則として、贈与を受けた年の翌年の（ ① ）から３月15日までの間に、（ ② ）の住所地の所轄税務署長に提出しなければならない。",
        "choice1": "①　２月１日　　②　受贈者",
        "choice2": "①　２月16日　　②　贈与者",
        "choice3": "①　２月16日　　②　受贈者",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税の申告",
        "important": ""
    },
    {
        "id": 1117,
        "shikenId": 15,
        "no": 58,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "下記の＜親族関係図＞において、Ａさんの相続における弟Ｃさんの法定相続分は、（　　）である。<br><img src=\"/img/yoso/11_4.png\" style='width:400px'/>",
        "choice1": "２分の１",
        "choice2": "３分の１",
        "choice3": "４分の１",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "法定相続分",
        "important": ""
    },
    {
        "id": 1118,
        "shikenId": 15,
        "no": 59,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "「直系尊属から教育資金の一括贈与を受けた場合の贈与税の非課税」の適用を受けた場合、受贈者 1 人につき（ ① ）までは贈与税が非課税となる。ただし、学校等以外の者に対して直接支払われる金銭については、（ ② ）が限度となる。",
        "choice1": "① 1,000万円　　② 300万円",
        "choice2": "① 1,000万円　　② 500万円",
        "choice3": "① 1,500万円　　② 500万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税非課税（教育資金）",
        "important": ""
    },
    {
        "id": 1119,
        "shikenId": 15,
        "no": 60,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "相続税の計算において、宅地が「小規模宅地等についての相続税の課税価格の計算の特例」における貸付事業用宅地等に該当する場合、その宅地のうち（ ① ）までを限度面積として、評価額の（ ② ）相当額を減額した金額を、相続税の課税価格に算入すべき価額とすることができる。",
        "choice1": "①　200㎡　　②　50％",
        "choice2": "①　330㎡　　②　50％",
        "choice3": "①　330㎡　　②　80％",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "小規模宅地等の特例",
        "important": ""
    },
    {
        "id": 1120,
        "shikenId": 19,
        "no": 1,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "ファイナンシャル・プランナーが顧客と投資顧問契約を締結し、当該契約に基づき金融商品取引法で定める投資助言・代理業を行うためには、都道府県知事の登録を受けなければならない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "関連法規とコンプライアンス",
        "important": ""
    },
    {
        "id": 1121,
        "shikenId": 19,
        "no": 2,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "国民年金の保険料免除期間における保険料のうち、追納することができる保険料は、追納に係る厚生労働大臣の承認を受けた日の属する月前10年以内の期間に係るものに限られる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "国民年金保険料の追納",
        "important": ""
    },
    {
        "id": 1122,
        "shikenId": 19,
        "no": 3,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "子のいない障害等級１級に該当する者に支給される障害基礎年金の額は、子のいない障害等級２級に該当する者に支給される障害基礎年金の額の1.25倍である。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "障害基礎年金",
        "important": ""
    },
    {
        "id": 1123,
        "shikenId": 19,
        "no": 4,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "国民年金基金の掛金は、加入員の選択した給付の型や加入口数のほか、加入時の年齢や性別によって異なる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "国民年金基金",
        "important": ""
    },
    {
        "id": 1124,
        "shikenId": 19,
        "no": 5,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "日本政策金融公庫の教育一般貸付（国の教育ローン）の融資限度額は、所定の海外留学資金として利用する場合等を除き、入学・在学する学生・生徒１人につき350万円である。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "国の教育ローン",
        "important": ""
    },
    {
        "id": 1125,
        "shikenId": 19,
        "no": 6,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "自動車保険の人身傷害補償保険では、被保険者が被保険自動車を運転中、自動車事故により負傷した場合、自己の過失割合にかかわらず、保険金額を限度に損害額の全額が補償対象となる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "人身傷害補償保険",
        "important": ""
    },
    {
        "id": 1126,
        "shikenId": 19,
        "no": 7,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "変額個人年金保険は、運用実績により、将来受け取る年金額や解約返戻金額、死亡保険金額が変動するが、一般に年金受取開始前に被保険者が死亡した場合の死亡給付金には最低保証がある。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "変額個人年金保険",
        "important": ""
    },
    {
        "id": 1127,
        "shikenId": 19,
        "no": 8,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "がん保険では、一般に、責任開始日前に120日程度の免責期間が設けられており、その期間中にがんと診断されてもがん診断給付金は支払われない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "がん保険",
        "important": ""
    },
    {
        "id": 1128,
        "shikenId": 19,
        "no": 9,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "定期保険特約付終身保険（更新型）は、定期保険特約を同額の保険金額で更新する場合、更新にあたって被保険者の健康状態についての告知は必要だが、医師の診査は必要ない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生産物賠償責任保険",
        "important": ""
    },
    {
        "id": 1129,
        "shikenId": 19,
        "no": 10,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税において、個人が支払う地震保険の保険料は、５万円を限度として年間支払保険料の２分の１にあたる金額が地震保険料控除の対象となる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "地震保険料控除",
        "important": ""
    },
    {
        "id": 1130,
        "shikenId": 19,
        "no": 11,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "1,000,000円を年利１％（１年複利）で３年間運用した場合の３年後の元利合計額は、税金や手数料等を考慮しない場合、1,030,301円となる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "複利計算",
        "important": ""
    },
    {
        "id": 1131,
        "shikenId": 19,
        "no": 12,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "証券取引所での株式の売買において、１つの銘柄の株式に価格の異なる複数の買い指値注文がある場合は、指値の低い注文から優先して売買が成立する。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "株式の売買",
        "important": ""
    },
    {
        "id": 1132,
        "shikenId": 19,
        "no": 13,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "一般法人、個人、国、地方公共団体などの通貨保有主体が保有する通貨量の残高を集計したものをマネーストックといい、日本銀行が作成・公表している。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "マネーストック",
        "important": ""
    },
    {
        "id": 1133,
        "shikenId": 19,
        "no": 14,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "NISA の「つみたて投資枠」において、上場株式は投資対象商品とされていない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "相関係数",
        "important": ""
    },
    {
        "id": 1134,
        "shikenId": 19,
        "no": 15,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "日経平均株価は、東京証券取引所プライム市場に上場する全銘柄を対象として算出される株価指標である。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "日経平均株価",
        "important": ""
    },
    {
        "id": 1135,
        "shikenId": 19,
        "no": 16,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "所得税において、上場株式の配当について配当控除の適用を受けるには、総合課税を選択して確定申告をする必要がある。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "配当控除",
        "important": ""
    },
    {
        "id": 1136,
        "shikenId": 19,
        "no": 17,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税における一時所得に係る総収入金額が600万円で、その収入を得るために支出した金額が400万円である場合、総所得金額に算入される一時所得の金額は、100万円である。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "一時所得",
        "important": ""
    },
    {
        "id": 1137,
        "shikenId": 19,
        "no": 18,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "セルフメディケーション税制（医療費控除の特例）に係るスイッチＯＴＣ医薬品の購入費（特定一般用医薬品等購入費）を支払った場合、所定の要件を満たせば、通常の医療費控除との選択により、最高10万円の医療費控除の適用を受けることができる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "セルフメディケーション税制",
        "important": ""
    },
    {
        "id": 1138,
        "shikenId": 19,
        "no": 19,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "確定拠出年金の個人型年金において加入者が拠出した掛金は、その２分の１にあたる金額が小規模企業共済等掛金控除として所得控除の対象となる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "小規模企業共済等掛金控除",
        "important": ""
    },
    {
        "id": 1139,
        "shikenId": 19,
        "no": 20,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "個人が賃貸アパートの敷地および建物を売却したことにより生じた所得は、譲渡所得となる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "ふるさと納税（ワンストップ特例制度）",
        "important": ""
    },
    {
        "id": 1140,
        "shikenId": 19,
        "no": 21,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "個人が自宅の土地および建物を譲渡し、「居住用財産を譲渡した場合の長期譲渡所得の課税の特例」（軽減税率の特例）の適用を受ける場合、課税長期譲渡所得金額のうち、１億円以下の部分は、所得税および復興特別所得税10.21％、住民税４％の税率で課税される。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "居住用財産の譲渡の特例（軽減税率）",
        "important": ""
    },
    {
        "id": 1141,
        "shikenId": 19,
        "no": 22,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "借地借家法第23条に規定される「事業用定期借地権等」は、専ら事業の用に供する建物の所有を目的とするもので、居住の用に供する建物の所有を目的として設定することはできない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "定期借地権",
        "important": ""
    },
    {
        "id": 1142,
        "shikenId": 19,
        "no": 23,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "建築基準法の規定によれば、第一種低層住居専用地域内における建築物の高さは、原則として10ｍまたは15ｍのうち当該地域に関する都市計画において定められた建築物の高さの限度を超えてはならない。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "建築物の高さ制限",
        "important": ""
    },
    {
        "id": 1143,
        "shikenId": 19,
        "no": 24,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "固定資産税における小規模住宅用地（住宅用地で住宅１戸当たり200㎡以下の部分）の課税標準については、当該住宅用地に係る固定資産税の課税標準となるべき価格の３分の１の額とする特例がある。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "固定資産税",
        "important": ""
    },
    {
        "id": 1144,
        "shikenId": 19,
        "no": 25,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "土地の有効活用において、一般に、土地所有者が土地の全部または一部を拠出し、デベロッパーが建設資金を負担してマンション等を建設し、それぞれの出資割合に応じて土地・建物に係る権利を取得する方式を、等価交換方式という。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "空き家の譲渡",
        "important": ""
    },
    {
        "id": 1145,
        "shikenId": 19,
        "no": 26,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "贈与税の納付については、納期限までに金銭で納付することを困難とする事由があるなど、所定の要件を満たせば、延納あるいは物納によることが認められている。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税の納付",
        "important": ""
    },
    {
        "id": 1146,
        "shikenId": 19,
        "no": 27,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "自筆証書遺言を作成する場合において、自筆証書に添付する財産目録については、自書によらずにパソコンで作成してもよい。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "自筆証書遺言",
        "important": ""
    },
    {
        "id": 1147,
        "shikenId": 19,
        "no": 28,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "初七日や四十九日などの法要に要した費用は、相続税の課税価格の計算上、債務控除の対象となる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "債務控除",
        "important": ""
    },
    {
        "id": 1148,
        "shikenId": 19,
        "no": 29,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "個人間で時価よりも著しく低い価額で土地の譲渡が行われた場合、原則として、時価と支払った対価との差額が、贈与税の課税対象となる。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "低額譲渡",
        "important": ""
    },
    {
        "id": 1149,
        "shikenId": 19,
        "no": 30,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "取引相場のない株式の相続税評価において、純資産価額方式とは、評価会社の株式の価額を、評価会社と事業内容が類似した上場会社の株価および配当金額、利益金額、純資産価額を基準にして算出する方式である。",
        "choice1": "〇",
        "choice2": "×",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "取引相場のない株式の評価",
        "important": ""
    },
    {
        "id": 1150,
        "shikenId": 19,
        "no": 31,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "Ａさんの本年分の可処分所得の金額は、下記の＜資料＞によれば、（　　）である。<br>＜資料＞本年分のＡさんの収入等<br><img src=\"/img/yoso/15_1.png\" style='width:400px'/>",
        "choice1": "430万円",
        "choice2": "530万円",
        "choice3": "620万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "可処分所得の計算",
        "important": ""
    },
    {
        "id": 1151,
        "shikenId": 19,
        "no": 32,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "公的介護保険の第２号被保険者は、市町村または特別区の区域内に住所を有する（ ① ）以上（ ② ）未満の医療保険加入者である。",
        "choice1": "①　40歳　　②　60歳",
        "choice2": "①　40歳　　②　65歳",
        "choice3": "①　45歳　　②　65歳",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "介護保険",
        "important": ""
    },
    {
        "id": 1152,
        "shikenId": 19,
        "no": 33,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "国民年金の第１号被保険者が、国民年金の定額保険料に加えて月額（ ① ）の付加保険料を納付し、65歳から老齢基礎年金を受け取る場合、（ ② ）に付加保険料納付済期間の月数を乗じて得た額が付加年金として支給される。",
        "choice1": "①　200円　　②　400円",
        "choice2": "①　200円　　②　200円",
        "choice3": "①　400円　　②　200円",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "付加年金",
        "important": ""
    },
    {
        "id": 1153,
        "shikenId": 19,
        "no": 34,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "遺族厚生年金の中高齢寡婦加算の支給に係る妻の年齢要件は、夫の死亡の当時、子のない妻の場合、（　　）である。",
        "choice1": "40歳以上60歳未満",
        "choice2": "40歳以上65歳未満",
        "choice3": "45歳以上60歳未満",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "中高齢寡婦加算",
        "important": ""
    },
    {
        "id": 1154,
        "shikenId": 19,
        "no": 35,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "貸金業法の総量規制により、個人が貸金業者による個人向け貸付を利用する場合の借入合計額は、原則として、年収の（　　）以内でなければならない。",
        "choice1": "３分の１",
        "choice2": "２分の１",
        "choice3": "５分の１",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "貸金業法の総量規制",
        "important": ""
    },
    {
        "id": 1155,
        "shikenId": 19,
        "no": 36,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "生命保険契約を申し込んだ者がその撤回を希望する場合、保険業法上、原則として、契約の申込日または契約の申込みの撤回等に関する事項を記載した書面の交付日のいずれか遅い日を含めて（ ① ）以内であれば、（ ② ）により申込みの撤回ができる。",
        "choice1": "①　８日　　②　書面（電磁的記録を含む）",
        "choice2": "①　14日　　②　書面（電磁的記録を含む）",
        "choice3": "①　８日　　②　書面（電磁的記録を含む）または口頭",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "クーリング・オフ",
        "important": ""
    },
    {
        "id": 1156,
        "shikenId": 19,
        "no": 37,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "生命保険の保険料の払込みが困難になった場合等に契約を有効に継続するための方法のうち、（　　）は、保険料の払込みを中止して、その時点での解約返戻金相当額をもとに、保険金額を変えないで、一時払いの定期保険に切り換えるものをいう。",
        "choice1": "払済保険",
        "choice2": "延長保険",
        "choice3": "継続保険",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "延長保険",
        "important": ""
    },
    {
        "id": 1157,
        "shikenId": 19,
        "no": 38,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "自動車を運転中にハンドル操作を誤ってガードレールに衝突し、被保険者である運転者と同乗者がケガをした場合、（ ）による補償の対象となる。",
        "choice1": "対人賠償保険",
        "choice2": "人身傷害保険",
        "choice3": "自動車損害賠償責任保険",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "普通傷害保険",
        "important": ""
    },
    {
        "id": 1158,
        "shikenId": 19,
        "no": 39,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "スーパーマーケットを経営する企業が、火災により店舗が全焼し、休業した場合の利益損失を補償するためには、（　　）への加入が考えられる。",
        "choice1": "企業費用・利益総合保険",
        "choice2": "施設所有（管理）者賠償責任保険",
        "choice3": "生産物賠償責任保険",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "法人の損害保険",
        "important": ""
    },
    {
        "id": 1159,
        "shikenId": 19,
        "no": 40,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "自動車事故でケガを負い、相手方が加入していた自動車保険の対人賠償保険金を受け取った場合、当該保険金は（　　）とされる。",
        "choice1": "一時所得",
        "choice2": "雑所得",
        "choice3": "非課税",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "損害保険金の課税",
        "important": ""
    },
    {
        "id": 1160,
        "shikenId": 19,
        "no": 41,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "日本銀行が売りオペレーションを行った場合には、市場の資金量が（ ① ）することから、市場金利は（ ② ）する。",
        "choice1": "①　減少　　②　低下",
        "choice2": "①　増加　　②　低下",
        "choice3": "①　減少　　②　上昇",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "金融政策",
        "important": ""
    },
    {
        "id": 1161,
        "shikenId": 19,
        "no": 42,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "個人向け国債は、適用利率の下限が年（ ① ）％とされ、購入単価は最低（ ② ）から（ ② ）単位である。",
        "choice1": "①　0.03　　②　１万円",
        "choice2": "①　0.05　　②　１万円",
        "choice3": "①　0.05　　②　10万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "個人向け国債",
        "important": ""
    },
    {
        "id": 1162,
        "shikenId": 19,
        "no": 43,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "下記の＜Ｘ社のデータ＞に基づいて計算したＸ社株式の配当性向は（ ① ）、ROEは（ ② ）である（純資産＝自己資本とします）。<br>＜Ｘ社のデータ＞<br><img src=\"/img/yoso/15_2.png\" style='width:300px'/>",
        "choice1": "①　60％　　②　12.5％",
        "choice2": "①　3.75％　　②　6.25％",
        "choice3": "①　12.5％　　②　7.5％",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "株式の投資指標の計算",
        "important": ""
    },
    {
        "id": 1163,
        "shikenId": 19,
        "no": 44,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "オプション取引において、特定の商品を将来の一定期日にあらかじめ決められた価格で買う権利のことを（ ① ）・オプションといい、他の条件が同じであれば、一般に、満期までの残存期間が長いほど、プレミアム（オプション料）は（ ② ）なる。",
        "choice1": "①　プット　　②　低く",
        "choice2": "①　コール　　②　低く",
        "choice3": "①　コール　　②　高く",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "オプション取引",
        "important": ""
    },
    {
        "id": 1164,
        "shikenId": 19,
        "no": 45,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "所得税において、為替予約をしていない外貨定期預金の満期時に生じた為替差益は（　　）として総合課税の対象となる。",
        "choice1": "一時所得",
        "choice2": "雑所得",
        "choice3": "利子所得",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "為替差益の税金",
        "important": ""
    },
    {
        "id": 1165,
        "shikenId": 19,
        "no": 46,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "所得税において、国債や地方債等の特定公社債の利子は、（　　）の対象となる。",
        "choice1": "源泉分離課税",
        "choice2": "総合課税",
        "choice3": "申告分離課税",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "利子所得",
        "important": ""
    },
    {
        "id": 1166,
        "shikenId": 19,
        "no": 47,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "下記の＜資料＞において、所得税における不動産所得（国内建物の貸付）の金額の計算上生じた損失の金額のうち、他の所得の金額と損益通算が可能な金額は、（　　）である。<br>＜資料＞不動産所得に関する資料<br><img src=\"/img/yoso/15_3.png\" style='width:400px'/>",
        "choice1": "20万円",
        "choice2": "30万円",
        "choice3": "50万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "総所得金額の計算",
        "important": ""
    },
    {
        "id": 1167,
        "shikenId": 19,
        "no": 48,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "所得税の控除対象扶養親族のうち、その年の 12 月 31 日時点の年齢が（ ① ）以上（ ② ）未満である者は、特定扶養親族に該当する。",
        "choice1": "① 16 歳　　② 22 歳",
        "choice2": "① 18 歳　　② 22 歳",
        "choice3": "① 19 歳　　② 23 歳",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "扶養控除",
        "important": ""
    },
    {
        "id": 1168,
        "shikenId": 19,
        "no": 49,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "本年中に取得・入居する場合、住宅に係る新築・中古の別や床面積にかかわらず、所得税における住宅借入金等特別控除の要件では、適用を受けようとする者の合計所得金額が（　　）を超える年分は、対象外としている。",
        "choice1": "1,000万円",
        "choice2": "2,000万円",
        "choice3": "3,000万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "住宅借入金等特別控除",
        "important": ""
    },
    {
        "id": 1169,
        "shikenId": 19,
        "no": 50,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "給与所得者のうち、（　　）は、所得税の確定申告をする必要がある。",
        "choice1": "医療費控除の適用を受けようとする者",
        "choice2": "給与所得以外の所得の金額の合計額が10万円を超える者",
        "choice3": "給与の年間収入金額が1,500万円を超える者",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "確定申告が必要なケース",
        "important": ""
    },
    {
        "id": 1170,
        "shikenId": 19,
        "no": 51,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "不動産の登記記録において、所有権に関する登記事項は（ ① ）に記録され、抵当権に関する登記事項は（ ② ）に記録される。",
        "choice1": "①　権利部（乙区）　　②　権利部（甲区）",
        "choice2": "①　権利部（甲区）　　②　表題部",
        "choice3": "①　権利部（甲区）　　②　権利部（乙区）",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産登記",
        "important": ""
    },
    {
        "id": 1171,
        "shikenId": 19,
        "no": 52,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "建物の区分所有等に関する法律（区分所有法）によれば、規約の設定、変更、廃止には、区分所有者および議決権の各（　　）の多数による集会の決議が必要となる。",
        "choice1": "過半数",
        "choice2": "４分の３",
        "choice3": "５分の４",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "区分所有法",
        "important": ""
    },
    {
        "id": 1172,
        "shikenId": 19,
        "no": 53,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "宅地建物取引業者と締結する宅地または建物の売買の専任媒介契約および専属専任媒介契約の有効期間は、最長（　　）である。",
        "choice1": "３カ月",
        "choice2": "６カ月",
        "choice3": "１年",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "宅地建物取引業法",
        "important": ""
    },
    {
        "id": 1173,
        "shikenId": 19,
        "no": 54,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "自己が居住していた家屋を譲渡する場合、その家屋に自己が居住しなくなった日から（ ① ）を経過する日の属する年の（ ② ）までの譲渡でなければ、「居住用財産を譲渡した場合の3,000万円の特別控除」の適用を受けることができない。",
        "choice1": "①　１年　　②　３月31日",
        "choice2": "①　２年　　②　12月31日",
        "choice3": "①　３年　　②　12月31日",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "居住用財産の譲渡の特例（3,000万円特別控除）",
        "important": ""
    },
    {
        "id": 1174,
        "shikenId": 19,
        "no": 55,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "賃貸用不動産を投資総額1億円で購入した場合、年間収入の合計額が1,000万円、年間費用の合計額が400万円であれば、この投資の純利回り（NOI利回り）は、（　　）である。",
        "choice1": "4.0%",
        "choice2": "6.0%",
        "choice3": "10.0%",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "土地の有効活用",
        "important": ""
    },
    {
        "id": 1175,
        "shikenId": 19,
        "no": 56,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "遺留分算定の基礎となる財産の価額が１億8,000万円で、相続人が被相続人の妻、長女、二女、三女の合計４人である場合、妻の遺留分の金額は（　　）となる。",
        "choice1": "1,500万円",
        "choice2": "4,500万円",
        "choice3": "9,000万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "遺留分の計算",
        "important": ""
    },
    {
        "id": 1176,
        "shikenId": 19,
        "no": 57,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "贈与税の配偶者控除は、婚姻期間が（ ① ）以上である配偶者から居住用不動産の贈与または居住用不動産を取得するための金銭の贈与を受け、所定の要件を満たす場合、贈与税の課税価格から基礎控除額とは別に（ ② ）を限度として控除することができるものである。",
        "choice1": "①　15年　　②　2,000万円",
        "choice2": "①　20年　　②　2,000万円",
        "choice3": "①　20年　　②　3,000万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税の配偶者控除",
        "important": ""
    },
    {
        "id": 1177,
        "shikenId": 19,
        "no": 58,
        "answerType": 1,
        "groupId": 0,
        "answer": 3,
        "score": 1,
        "question1": "",
        "question2": "下記の＜親族関係図＞において、被相続人Ａさんの相続における相続税額の計算上、遺産に係る基礎控除額は、（　　）である。<br>＜親族関係図＞<br><img src=\"/img/yoso/15_4.png\" style='width:500px'/>",
        "choice1": "1,800万円",
        "choice2": "3,000万円",
        "choice3": "4,800万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "遺産に係る基礎控除の計算",
        "important": ""
    },
    {
        "id": 1178,
        "shikenId": 19,
        "no": 59,
        "answerType": 1,
        "groupId": 0,
        "answer": 2,
        "score": 1,
        "question1": "",
        "question2": "賃貸アパート等の貸家の用に供されている家屋の相続税評価額は、（　　）の算式により算出される。",
        "choice1": "自用家屋としての評価額×（１－借地権割合×賃貸割合）",
        "choice2": "自用家屋としての評価額×（１－借家権割合×賃貸割合）",
        "choice3": "自用家屋としての評価額×（１－借地権割合×借家権割合×賃貸割合）",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "家屋の評価",
        "important": ""
    },
    {
        "id": 1179,
        "shikenId": 19,
        "no": 60,
        "answerType": 1,
        "groupId": 0,
        "answer": 1,
        "score": 1,
        "question1": "",
        "question2": "本年10月11日に死亡したＡさんが所有していた上場株式Ｘを相続により取得した場合の１株当たりの相続税評価額は、下記の＜資料＞によれば、（　　）である。<br>＜資料＞上場株式Xの価格<br><img src=\"/img/yoso/15_5.png\" style='width:420px'/>",
        "choice1": "690円",
        "choice2": "720円",
        "choice3": "730円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "上場株式の評価",
        "important": ""
    },
    {
        "id": 1180,
        "shikenId": 14,
        "no": 1,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "ファイナンシャル・プランニング業務を行うに当たっては、関連業法を順守することが重要である。ファイナンシャル・プランナー（以下「ＦＰ」という）の行為に関する次の記述のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "税理士資格を有していないＦＰが、無料相談会において、相談者が資料を持参した場合に、その資料をもとに相談者が納付すべき税額計算を行った。",
        "choice2": "生命保険募集人、生命保険仲立人、金融サービス仲介業の登録をしていないＦＰが、生命保険契約を検討している顧客につきライフプランを聞きとった上で、必要保障額を具体的に試算した。",
        "choice3": "投資助言・代理業、投資運用業の登録をしていないＦＰが、顧客が保有する投資信託の運用報告書について、その記載内容を説明した。",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "関連法規とコンプライアンス",
        "important": ""
    },
    {
        "id": 1181,
        "shikenId": 14,
        "no": 2,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "下記は、Ａ家のキャッシュフロー表（一部抜粋）である。このキャッシュフロー表の空欄（ア）～（ウ）にあてはまる数値として、最も不適切なものはどれか。なお、計算に当たっては、キャッシュフロー表中に記載の整数を使用し、計算結果については万円未満を四捨五入すること。<br><img src='/img/yoso/10_2.png'/>",
        "question2": "",
        "choice1": "空欄（ア）：６２８",
        "choice2": "空欄（イ）：１４８",
        "choice3": "空欄（ウ）：１,１２７",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "キャッシュフロー表の計算",
        "important": ""
    },
    {
        "id": 1182,
        "shikenId": 14,
        "no": 3,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "<img src='/img/yoso/14_10_3.png'/>",
        "question2": "",
        "choice1": "６５０ （万円）",
        "choice2": "８５０ （万円）",
        "choice3": "１，０５０（万円）",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "バランスシートの計算",
        "important": ""
    },
    {
        "id": 1183,
        "shikenId": 14,
        "no": 4,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "大橋さんは、今後１５年間で毎年３０万円ずつ積立貯蓄をし、将来の生活費の準備をしたいと考えている。積立期間中に年利２.０％で複利運用できるものとした場合、１５年後の積立金額として、正しいものはどれか。なお、下記＜資料＞の３つの係数の中から最も適切な係数を選択して計算し、解答に当たっては、千円未満を四捨五入すること。また、税金や記載のない事項については一切考慮しないこととする。<br><img src='/img/yoso/10_16.png'/>",
        "question2": "",
        "choice1": "４,８４６,０００円",
        "choice2": "５,１８８,０００円",
        "choice3": "３,８５５,０００円",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "係数計算",
        "important": ""
    },
    {
        "id": 1184,
        "shikenId": 14,
        "no": 5,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "大橋さんは、個人型確定拠出年金（以下「ｉＤｅＣｏ」という）について、ＦＰの福田さんに質問をした。ｉＤｅＣｏに関する福田さんの次の説明のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "「ｉＤｅＣｏに加入した場合、支払った掛金は、小規模企業共済等掛金控除として税額控除の対象となります。」",
        "choice2": "「妻の倫子さんが国民年金の第３号被保険者となった場合も、ｉＤｅＣｏの加入対象者となります。」",
        "choice3": "「ｉＤｅＣｏの年金資産は、原則として６０歳になるまで引き出すことができません。」",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "個人型確定拠出年金（iDeCo）",
        "important": ""
    },
    {
        "id": 1185,
        "shikenId": 14,
        "no": 6,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "下記＜資料＞に基づくＭＮ株式会社の投資指標に関する次の記述のうち、最も不適切なものはどれか。なお、購入時の手数料および税金は考慮しないこととし、計算結果については表示単位の小数点以下第３位を四捨五入すること。<br><img src='/img/yoso/10_3.png'/>",
        "question2": "",
        "choice1": "株価収益率（ＰＥＲ）で比較した場合、日経平均採用銘柄の平均より割安である。",
        "choice2": "株価純資産倍率（ＰＢＲ）で比較した場合、ＪＰＸ日経４００採用銘柄より割高である。",
        "choice3": "配当利回りで比較した場合、東証プライム全銘柄の単純平均より高い。",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "株式投資指標の計算",
        "important": ""
    },
    {
        "id": 1186,
        "shikenId": 14,
        "no": 7,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "下記は、投資信託の費用についてまとめた表である。下表の空欄（ア）～（ウ）に入る語句として、最も不適切なものはどれか。<br><img src='/img/yoso/10_4.png'/>",
        "question2": "",
        "choice1": "空欄（ア）：ノーロード型",
        "choice2": "空欄（イ）：日々",
        "choice3": "空欄（ウ）：口座管理料",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "投資信託のコスト",
        "important": "必要保障額の計算"
    },
    {
        "id": 1187,
        "shikenId": 14,
        "no": 8,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "下記＜資料＞の外貨定期預金について、満期時の外貨ベースの元利合計額を円転した金額として、正しいものはどれか。なお、計算結果（円転した金額）について円未満の端数が生じる場合は切り捨てること。また、税金については考慮しないこととする。<br><img src='/img/yoso/10_5.png'/>",
        "question2": "",
        "choice1": "１,３８６,９００円",
        "choice2": "１,３９３,８００円",
        "choice3": "１,４０７,０００円",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "外貨預金の計算",
        "important": ""
    },
    {
        "id": 1188,
        "shikenId": 14,
        "no": 9,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "下記＜資料＞の建築基準法に定める道路およびそれに接する建築物の敷地に関する次の記述の空欄（ア）～（ウ）にあてはまる数値の組み合わせとして、正しいものはどれか。なお、記載のない条件については一切考慮しないこととする。<br><img src='/img/yoso/10_6.png'/>",
        "question2": "",
        "choice1": "（ア）６　（イ）３　（ウ）３",
        "choice2": "（ア）４　（イ）２　（ウ）２",
        "choice3": "（ア）４　（イ）２　（ウ）４",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "建築基準法上の道路",
        "important": ""
    },
    {
        "id": 1189,
        "shikenId": 14,
        "no": 10,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "田上さんは、別荘として利用中の土地および建物を売却する予定である。売却に係る状況が下記＜資料＞のとおりである場合、所得税における次の記述の空欄（ア）、（イ）にあてはまる数値または語句の組み合わせとして、最も適切なものはどれか。<br><img src='/img/yoso/10_7.png'/>",
        "question2": "",
        "choice1": "（ア）５５０　　（イ）長期",
        "choice2": "（ア）６５０　　（イ）短期",
        "choice3": "（ア）６５０　　（イ）長期",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "譲渡所得の計算等",
        "important": ""
    },
    {
        "id": 1190,
        "shikenId": 14,
        "no": 11,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "公正な土地評価に関する下表の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><img src='/img/yoso/14_10_11.png'/>",
        "question2": "",
        "choice1": "（ア）国税庁　　（イ） 市町村（東京 23 区は東京都）　　（ウ） 80%",
        "choice2": "（ア）国土交通省　　（イ） 国税庁　　（ウ） 70%",
        "choice3": "（ア）市町村（東京 23 区は東京都）　　（イ） 国税庁　　（ウ） 80%",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "公的な土地評価",
        "important": ""
    },
    {
        "id": 1191,
        "shikenId": 14,
        "no": 12,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "大津翔太さんが加入しているガン保険（下記＜資料＞参照）の保障内容に関する次の記述の空欄（ア）にあてはまる金額として、正しいものはどれか。なお、保険契約は有効に継続しているものとし、翔太さんはこれまでに＜資料＞の保険から保険金および給付金を一度も受け取っていないものとする。<br><img src='/img/yoso/10_8.png'/>",
        "question2": "",
        "choice1": "１２０万円",
        "choice2": "１３０万円",
        "choice3": "１５０万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険の証券分析",
        "important": ""
    },
    {
        "id": 1192,
        "shikenId": 14,
        "no": 13,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "西山さんは、地震保険についてＦＰの並木さんに質問をした。地震保険に関する次の記述のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "地震保険は、住宅総合保険などの火災保険契約に付帯して契約する必要があり、単独で契約することはできない。",
        "choice2": "地震により、居住用の建物に収容されている家財のうち、１個または１組の価額が３０万円を超える骨とう品が損害を受けた場合、地震保険の補償の対象となる。",
        "choice3": "噴火や津波により、居住用の建物が大半損や一部損となった場合、地震保険の補償の対象となる。",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "地震保険",
        "important": ""
    },
    {
        "id": 1193,
        "shikenId": 14,
        "no": 14,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "大森洋さんが契約している自動車保険の主な内容は、下記＜資料＞のとおりである。＜資料＞に基づく次の記述のうち、自動車保険による補償の対象とならないものはどれか。なお、いずれも保険期間中に発生したものであり、運転者は洋さんである。また、記載のない事項については一切考慮しないこととする。<br><img src='/img/yoso/10_10.png' style='width:350px'/>",
        "question2": "",
        "choice1": "被保険自動車を運転中に、横断歩道の歩行者に接触し、ケガを負わせた場合の損害賠償。",
        "choice2": "被保険自動車を駐車場に駐車する際に、誘導中の妻に誤って車が接触し、ケガを負わせた場合の治療費用。",
        "choice3": "被保険自動車を運転中に、単独事故を起こし、車体が損傷した場合の修理費用。",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "自動車保険",
        "important": ""
    },
    {
        "id": 1194,
        "shikenId": 14,
        "no": 15,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "会社員の北村さんは、本年中に勤務先を定年退職した。北村さんの退職に係るデータが下記＜資料＞のとおりである場合、北村さんの所得税に係る退職所得の金額として、正しいものはどれか。なお、北村さんは役員であったことはなく、退職は障害者になったことに基因するものではない。また、前年以前に受け取った退職金はないものとする。<br><img src='/img/yoso/10_11.png'/>",
        "question2": "",
        "choice1": "４７０万円",
        "choice2": "５０５万円",
        "choice3": "９４０万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "退職所得の計算",
        "important": ""
    },
    {
        "id": 1195,
        "shikenId": 14,
        "no": 16,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "山際さん（６８歳）の本年分の収入等は下記＜資料＞のとおりである。山際さんの本年分の所得税における総所得金額として、正しいものはどれか。なお、記載のない事項については一切考慮しないこととする。<br><img src='/img/yoso/10_12.png'/>",
        "question2": "",
        "choice1": "１６８万円",
        "choice2": "１８８万円",
        "choice3": "２５２万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "総所得金額の計算",
        "important": ""
    },
    {
        "id": 1196,
        "shikenId": 14,
        "no": 17,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "所得税の青色申告特別控除に関する次の記述の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><img src='/img/yoso/14_10_12.png'/>",
        "question2": "",
        "choice1": "（ア）収支内訳書　　（イ）10 万円　　（ウ）55 万円",
        "choice2": "（ア）貸借対照表　　（イ）10 万円　　（ウ）65 万円",
        "choice3": "（ア）貸借対照表　　（イ）55 万円　　（ウ）65 万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "青色申告特別控除",
        "important": ""
    },
    {
        "id": 1197,
        "shikenId": 14,
        "no": 18,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "本年１１月２０日に相続が開始された太田花子さん（被相続人）の＜親族関係図＞が下記のとおりである場合、民法上の相続人および法定相続分の組み合わせとして、正しいものはどれか。なお、記載のない条件については一切考慮しないこととする。<br><img src='/img/yoso/10_13.png'/>",
        "question2": "",
        "choice1": "和則　１／２　　一男　１／４　　洋子　１／４",
        "choice2": "和則　１／２　　一男　１／６　　洋子　１／６　　優奈　１／６",
        "choice3": "和則　２／３　　一男　１／６　　洋子　１／６",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続人と法定相続分",
        "important": ""
    },
    {
        "id": 1198,
        "shikenId": 14,
        "no": 19,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "今年８５歳になる片山さんは、遺産分割等でのトラブルを防ぐために遺言書の作成を検討しており、ＦＰの佐治さんに相談をした。遺言書に関する佐治さんの次の説明のうち、最も適切なものはどれか。",
        "question2": "",
        "choice1": "「自宅に保管されている自筆証書遺言を発見した相続人は、遅滞なく遺言書を公証役場に提出して、その検認を請求しなければなりません。」",
        "choice2": "「自筆証書遺言を作成する場合、遺言者と２人以上の証人の署名と押印が必要です。」",
        "choice3": "「公正証書遺言を作成した後、自筆証書遺言によって、先に作成した公正証書遺言を撤回することができます。」",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "遺言の種類と特徴",
        "important": ""
    },
    {
        "id": 1199,
        "shikenId": 14,
        "no": 20,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "桜井さんは、相続税の計算における遺産に係る基礎控除額について、FP で税理士でもある仁部さんに相談をした。この相談に対する仁部さんの回答の空欄（ア）、( イ ) にあてはまる数値の組み合わせとして、正しいものはどれか。<br><img src='/img/yoso/14_10_15_2.png'/>",
        "question2": "",
        "choice1": "（ア）2,000　　（イ）500",
        "choice2": "（ア）3,000　　（イ）500",
        "choice3": "（ア）3,000　　（イ）600",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続税の基礎控除額",
        "important": ""
    },
    {
        "id": 1200,
        "shikenId": 18,
        "no": 1,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "ファイナンシャル・プランニング業務を行うに当たっては、関連業法を順守することが重要である。ファイナンシャル・プランナー（以下「ＦＰ」という）の行為に関する次の記述のうち、最も適切なものはどれか。",
        "question2": "",
        "choice1": "生命保険募集人・生命保険仲立人、金融サービス仲介業の登録をしていないＦＰが、生命保険契約を検討している顧客から相談を受け、顧客が死亡した場合における遺族にとっての必要保障額の計算を有償で行った。",
        "choice2": "弁護士資格を有していないＦＰが、離婚に伴う財産分与について係争中の顧客から相談を受け、報酬を得る目的でその顧客を代理して離婚協議書の作成に係る法律事務を取り扱った。",
        "choice3": "税理士資格を有していないＦＰが、参加費無料の相談会において、相談者が資料を持参したため、相談者が納付すべき相続税の具体的な税額計算を行った。",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "関連法規とコンプライアンス",
        "important": ""
    },
    {
        "id": 1201,
        "shikenId": 18,
        "no": 2,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "下記は、A家のキャッシュフロー表（一部抜粋）である。このキャッシュフロー表の空欄（ア）～（ウ）にあてはまる数値の組み合わせとして、正しいものはどれか。なお、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><img src='/img/yoso/14_2.png'/>",
        "question2": "",
        "choice1": "（ア）３５０　（イ）　４３　（ウ）８８３",
        "choice2": "（ア）３５７　（イ）▲４３　（ウ）８８３",
        "choice3": "（ア）３５７　（イ）▲４３　（ウ）８９２",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "キャッシュフロー表の計算",
        "important": ""
    },
    {
        "id": 1202,
        "shikenId": 18,
        "no": 3,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "ＦＰの山井さんは、加藤家のバランスシートを作成した。下表の空欄（ア）にあてはまる金額として、正しいものはどれか。なお、＜資料＞に記載のあるデータに基づいて解答することとする。<br><img src='/img/yoso/18_14_18.png'/>",
        "question2": "",
        "choice1": "１,７１０（万円）",
        "choice2": "１,７９０（万円）",
        "choice3": "４,７９０（万円）",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "バランスシートの計算",
        "important": ""
    },
     {
        "id": 1203,
        "shikenId": 18,
        "no": 4,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "加藤さんは、６０歳で定年となり、その後公的年金の支給が始まる６５歳までの５年間の生活資金は、退職一時金の一部を充てようと考えている。仮に退職一時金のうち６００万円を年利２.０％で複利運用しながら５年間で均等に取り崩すこととした場合、年間で取り崩すことができる最大金額として、正しいものはどれか。なお、下記＜資料＞の３つの係数の中から最も適切な係数を選択して計算し、円単位で解答すること。また、税金や記載のない事項については一切考慮しないこととする。<br><img src='/img/yoso/14_18.png'/>",
        "question2": "",
        "choice1": "５６５,８００円",
        "choice2": "１,１５２,９６０円",
        "choice3": "１,２７２,９６０円",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "係数計算",
        "important": ""
    },
    {
        "id": 1204,
        "shikenId": 18,
        "no": 5,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "加藤さん（４８歳）は、通常６５歳から支給される老齢基礎年金を繰り上げて受給できることを知り、ＦＰの山井さんに質問をした。老齢基礎年金の繰上げ受給に関する次の記述のうち、最も適切なものはどれか。なお、老齢基礎年金の受給要件は満たしているものとする。",
        "question2": "",
        "choice1": "老齢基礎年金を繰上げ受給した場合の年金額の減額は、一生涯続く。",
        "choice2": "老齢基礎年金を６０歳から繰上げ受給した場合でも、老齢厚生年金を同時に繰上げ受給する必要はない。",
        "choice3": "老齢基礎年金を繰上げ受給した場合の年金額は、繰上げ月数１月当たり０.７％の割合で減額される。",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "繰上げ支給",
        "important": ""
    },
    {
        "id": 1205,
        "shikenId": 18,
        "no": 6,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "大田さんは、預金保険制度の対象となるＧＹ銀行の国内支店に下記＜資料＞の金融資産を預け入れている。仮に、ＧＹ銀行が破綻した場合、預金保険制度によって保護される金額として、正しいものはどれか。<br><img src='/img/yoso/14_3.png'/>",
        "question2": "",
        "choice1": "５００万円",
        "choice2": "８００万円",
        "choice3": "１,０００万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "預金保険の計算",
        "important": ""
    },
    {
        "id": 1206,
        "shikenId": 18,
        "no": 7,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "金投資に関する次の記述の空欄 （ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、金の取引は継続的な売買でないものとする。<br><img src='/img/yoso/18_14_3.png'/>",
        "question2": "",
        "choice1": "（ア）雑所得　（イ）上昇　（ウ）できる",
        "choice2": "（ア）譲渡所得　（イ）上昇　（ウ）できない",
        "choice3": "（ア）譲渡所得　（イ）下落　（ウ）できる",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "金投資",
        "important": ""
    },
    {
        "id": 1207,
        "shikenId": 18,
        "no": 8,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "広川さんはＳＴ投資信託を新規募集時に５００万口購入し、特定口座（源泉徴収口座）で保有して収益分配金を受け取っている。下記＜資料＞に基づき、広川さんが保有するＳＴ投資信託に関する次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、正しいものはどれか。<br><img src='/img/yoso/14_5.png'/>",
        "question2": "",
        "choice1": "（ア）５５,０００円　　　（イ）普通分配金",
        "choice2": "（ア）５５,０００円　　　（イ）元本払戻金（特別分配金）",
        "choice3": "（ア）１６,５００円　　　（イ）普通分配金",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "投資信託の手数料と分配金の計算",
        "important": ""
    },
    
    
    {
        "id": 1208,
        "shikenId": 18,
        "no": 9,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "建物の登記記録に関する下表の空欄（ア）～（ウ）にあてはまる記録事項の組み合わせとして、正しいものはどれか。<br><img src='/img/yoso/14_6.png'/>",
        "question2": "",
        "choice1": "（ア）所有権保存登記　　（イ）所有権移転登記　（ウ）抵当権設定登記",
        "choice2": "（ア）建物の所在や構造　（イ）所有権移転登記　（ウ）抵当権設定登記",
        "choice3": "（ア）建物の所在や構造　（イ）所有権保存登記　（ウ）所有権移転登記",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産登記",
        "important": ""
    },
    {
        "id": 1209,
        "shikenId": 18,
        "no": 10,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "建築基準法に従い、下記＜資料＞の土地に建築物を建築する場合の延べ面積（床面積の合計）の最高限度として、正しいものはどれか。なお、記載のない条件については一切考慮しないこととする。<br><img src='/img/yoso/14_7.png'/>",
        "question2": "",
        "choice1": "４２０㎡",
        "choice2": "２,５２０㎡",
        "choice3": "２,８００㎡",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "建築物の延べ面積の計算",
        "important": ""
    },
    {
        "id": 1210,
        "shikenId": 18,
        "no": 11,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "下表は、宅地建物の売買・交換において、宅地建物取引業者と交わす媒介契約の種類とその概要についてまとめた表である。下表の空欄（ア）～（ウ）にあてはまる語句または数値の組み合わせとして、最も適切なものはどれか。なお、自己発見取引とは、自ら発見した相手方と売買または交換の契約を締結する行為を示すものとする。<br><img src='/img/yoso/18_14_7.png'/>",
        "question2": "",
        "choice1": "（ア）なし （イ）可　 （ウ）７",
        "choice2": "（ア）なし （イ）不可 （ウ）10",
        "choice3": "（ア）４週間に１回以上 （イ）可 （ウ）10",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "媒介契約 ",
        "important": ""
    },
    {
        "id": 1211,
        "shikenId": 18,
        "no": 12,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "西田幸二さんが加入している生命保険（下記＜資料＞参照）の保障内容に関する次の記述の空欄（ア）にあてはまる金額として、正しいものはどれか。なお、保険契約は有効に継続しているものとし、幸二さんはこれまでに＜資料＞の保険から保険金および給付金を一度も受け取っていないものとする。<br><img src='/img/yoso/14_8.png'/>",
        "question2": "",
        "choice1": "１，０６２万円",
        "choice2": "１，０７８万円",
        "choice3": "１，０８２万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険の証券分析",
        "important": ""
    },
    {
        "id": 1212,
        "shikenId": 18,
        "no": 13,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "内藤和夫さんが本年中に支払った生命保険の保険料は下記＜資料＞のとおりである。この場合の和夫さんの本年分の所得税の計算における生命保険料控除の金額として、正しいものはどれか。なお、下記＜資料＞の保険について、これまでに契約内容の変更はないものとする。また、本年分の生命保険料控除額が最も多くなるように計算すること。<br><img src='/img/yoso/14_9.png'/>",
        "question2": "",
        "choice1": "４０，０００円",
        "choice2": "５５，０００円",
        "choice3": "６５，０００円",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険料控除の計算",
        "important": ""
    },
    {
        "id": 1213,
        "shikenId": 18,
        "no": 14,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "損害保険の用語に関する次の記述のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "再調達価額とは、保険の対象と同等のものを新たに建築または購入するのに必要な金額から、使用による消耗分を差し引いた金額のことである。",
        "choice2": "超過保険とは、保険金額が保険の対象の価額（保険価額）を超えている保険 のことである。",
        "choice3": "保険金とは、保険事故によって損害が生じたとき、保険会社から被保険者または保険金受取人に支払われる金銭のことである。",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "損害保険の用語",
        "important": ""
    },
    {
        "id": 1214,
        "shikenId": 18,
        "no": 15,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "桜田さんは本年中に勤務先を退職し、個人事業主として活動を始めた。桜田さんの本年分の各種所得の金額が下記＜資料＞のとおりである場合、桜田さんの本年分の所得税における総所得金額として正しいものはどれか。なお、桜田さんの本年中の所得は＜資料＞に記載されている所得以外にはないものとする。<br><img src='/img/yoso/14_11.png'/>",
        "question2": "",
        "choice1": "７００万円",
        "choice2": "９００万円",
        "choice3": "１,１００万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "総所得金額の計算",
        "important": ""
    },
    {
        "id": 1215,
        "shikenId": 18,
        "no": 16,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "山野さんは、本年６月に新築のアパートを購入し、新たに不動産賃貸業を開始した。購入したアパートの建物部分の情報は下記＜資料＞のとおりである。山野さんの本年分の所得税における不動産所得の金額の計算上、必要経費に算入する減価償却費の金額として、正しいものはどれか。<br><img src='/img/yoso/14_12.png'/>",
        "question2": "",
        "choice1": "６６０,０００円",
        "choice2": "７７０,０００円",
        "choice3": "１,３２０,０００円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "減価償却費の計算",
        "important": ""
    },
    {
        "id": 1216,
        "shikenId": 18,
        "no": 17,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "坂本さんは、マンション賃貸業を営む個人事業主で青色申告者である。坂本さんの本年分の所得および所得控除が下記＜資料＞のとおりである場合、坂本さんの本年分の所得税額として、正しいものはどれか。なお、坂本さんに＜資料＞以外の所得はなく、復興特別所得税や税額控除、源泉徴収税額、予定納税等については一切考慮しないこととする。<br><img src='/img/yoso/14_13.png'/>",
        "question2": "",
        "choice1": "７７２,５００円",
        "choice2": "１,１０１,５００円",
        "choice3": "１,２０４,０００円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "所得税額の計算",
        "important": ""
    },
    {
        "id": 1217,
        "shikenId": 18,
        "no": 18,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "本年１１月１５日に相続が開始された松本二郎さん（被相続人）の＜親族関係図＞が下記のとおりである場合、民法上の相続人および法定相続分の組み合わせとして、正しいものはどれか。なお、記載のない条件については一切考慮しないこととする。<br><img src='/img/yoso/14_14.png'/>",
        "question2": "",
        "choice1": "幸子　１／２　　花子　１／４　　一郎　１／４",
        "choice2": "幸子　２／３　　花子　１／６　　一郎　１／６",
        "choice3": "幸子　３／４　　花子　１／８　　一郎　１／８",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続人と法定相続分",
        "important": ""
    },
    {
        "id": 1218,
        "shikenId": 18,
        "no": 19,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "渡辺清高さん（３２歳）が本年中に贈与を受けた財産の価額と贈与者は以下のとおりである。清高さんの本年分の贈与税額として、正しいものはどれか。なお、本年中において、清高さんはこれ以外の財産の贈与を受けておらず、相続時精算課税制度は選択していないものとする。<br><img src='/img/yoso/14_15.png'/>",
        "question2": "",
        "choice1": "６８万円",
        "choice2": "９０万円",
        "choice3": "１２３万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税の計算",
        "important": ""
    },
    {
        "id": 1219,
        "shikenId": 18,
        "no": 20,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "路線価方式による相続税評価額を算定する場合、下記＜資料＞の宅地の借地権（普通借地権）の金額として、正しいものはどれか。なお、奥行価格補正率は１.０とし、記載のない条件については一切考慮しないこととする。<br><img src='/img/yoso/14_16.png'/>",
        "question2": "",
        "choice1": "２１,６００千円",
        "choice2": "５０,４００千円",
        "choice3": "７２,０００千円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "借地権の計算",
        "important": ""
    },
    {
        "id": 1220,
        "shikenId": 22,
        "no": 1,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "公表された他人の著作物を自分の著作物に引用する場合に気をつけるべき事項に関する次の記述のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "自らが作成する部分と引用する部分を区別して記述し、自らが作成する部分が「主」で、引用する部分が「従」となる内容にした。",
        "choice2": "引用する著作物のタイトルと著作者名を明記した。",
        "choice3": "民間の新聞社が発行する記事を自らが主催する無料のセミナーや勉強会で配付する場合であれば、新聞社の許諾を得る必要はない。",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "著作権",
        "important": ""
    },
    {
        "id": 1221,
        "shikenId": 22,
        "no": 2,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "下記は、A家のキャッシュフロー表（一部抜粋）である。このキャッシュフロー表の空欄（ア）～（ウ）に入る数値とその求め方として、最も適切なものはどれか。なお、計算に当たっては、キャッシュフロー表中に記載の整数を使用し、計算結果は万円未満を四捨五入すること。<br><img src='/img/yoso/18_2.png'/>",
        "question2": "",
        "choice1": "空欄（ア）： 「１８２ × (１＋０.０１)<sup>2</sup> ≒１８６」",
        "choice2": "空欄（イ）： 「３８３－４６０＝▲７７」",
        "choice3": "空欄（ウ）： 「（３３５＋５４）×（１＋０.０１）≒３９３」",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "キャッシュフロー表の計算",
        "important": ""
    },
    {
        "id": 1222,
        "shikenId": 22,
        "no": 3,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "<img src='/img/yoso/1221_18.png'/>",
        "question2": "",
        "choice1": "８００（万円）",
        "choice2": "８５０（万円）",
        "choice3": "９００（万円）",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "キャッシュフロー表の計算",
        "important": ""
    },
    {
        "id": 1223,
        "shikenId": 22,
        "no": 4,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "福井さんは、今後１５年間で積立貯蓄をして、長女の教育資金として５００万円を準備したいと考えている。積立期間中に年利２.０％で複利運用できるものとした場合、５００万円を準備するために必要な毎年の積立金額として、正しいものはどれか。なお、下記＜資料＞の３つの係数の中から最も適切な係数を選択して計算し、解答に当たっては、千円未満を切り上げること。また、税金や記載のない事項については一切考慮しないこととする。<br><img src='/img/yoso/18_18.png'/>",
        "question2": "",
        "choice1": "２８９,０００円",
        "choice2": "２９０,０００円",
        "choice3": "３９０,０００円",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "係数計算",
        "important": ""
    },
    {
        "id": 1224,
        "shikenId": 22,
        "no": 5,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "木下大介さんの公的年金加入歴は下記のとおりである。万一、大介さんが現時点（ 55 歳）で死亡した場合、大介さんの死亡時点において妻の美奈さんに支給される公的年金の遺族給付に関する次の記述のうち、最も適切なものはどれか。なお、大介さんは、入社時（２２歳）から死亡時まで厚生年金保険に加入しているものとし、遺族給付における生計維持要件は満たされているものとする。<br><img src='/img/yoso/1237_18.png'/>",
        "question2": "",
        "choice1": "遺族基礎年金と中高齢寡婦加算が加算された遺族厚生年金が支給される。",
        "choice2": "遺族基礎年金と死亡一時金が支給される。",
        "choice3": "中高齢寡婦加算が加算された遺族厚生年金が支給される。",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "係数計算",
        "important": ""
    },
    {
        "id": 1225,
        "shikenId": 22,
        "no": 6,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "下記＜資料＞に基づくＭＮ株式会社の投資指標に関する次の記述のうち、最も適切なものはどれか。なお、購入時の手数料および税金は考慮しないこととし、計算結果については表示単位の小数点以下第３位を四捨五入すること。<br><img src='/img/yoso/18_3.png'/>",
        "question2": "",
        "choice1": "株価純資産倍率（ＰＢＲ）は、０.８倍である。",
        "choice2": "配当性向は、３０％である。",
        "choice3": "配当利回りは、３.７５％である。",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "株式投資指標の計算",
        "important": ""
    },
    {
        "id": 1226,
        "shikenId": 22,
        "no": 7,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "下記は、一般的な証券取引所に上場しているＥＴＦ（上場投資信託）とＪ－ＲＥＩＴ（上場不動産投資信託）および公募株式投資信託（非上場）の特徴についてまとめた表である。下表の空欄（ア）～（ウ）にあてはまる語句に関する次の記述のうち、最も適切なものはどれか。<br><img src='/img/yoso/18_4.png'/>",
        "question2": "",
        "choice1": "空欄（ア）に入る語句は、「信託銀行」である。",
        "choice2": "空欄（イ）に入る語句は、「基準価額」である。",
        "choice3": "空欄（ウ）に入る語句は、「証券取引所が定めた手数料率を一律に適用」である。",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "投資信託の比較",
        "important": "必要保障額の計算"
    },
    {
        "id": 1227,
        "shikenId": 22,
        "no": 8,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "会社員の吉田さんは、ＦＰの清水さんに、ＮＩＳＡの成長投資枠およびつみたて投資枠について質問をした。次の清水さんの回答のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "「ＮＩＳＡの成長投資枠やつみたて投資枠で売却損が出た場合、特定口座で生じた売却益などと相殺することができません。」",
        "choice2": "「ＮＩＳＡの成長投資枠は、上場株式を投資対象とすることができます。」",
        "choice3": "「ＮＩＳＡの成長投資枠やつみたて投資枠は、個人向け国債を投資対象とすることができます。」",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "新NISA",
        "important": ""
    },
    {
        "id": 1228,
        "shikenId": 22,
        "no": 9,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "不動産の取得・保有に係る税金について、下表の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><img src='/img/yoso/18_6.png'/>",
        "question2": "",
        "choice1": "（ア）都道府県　　（イ）４月１日　　（ウ）取得価額",
        "choice2": "（ア）市町村　　　（イ）１月１日　　（ウ）固定資産税評価額",
        "choice3": "（ア）国　　（イ）１月１日　　（ウ）固定資産税評価額",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "取得と保有の税金",
        "important": ""
    },
    {
        "id": 1229,
        "shikenId": 22,
        "no": 10,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "建築基準法に従い、下記＜資料＞の土地に建築物を建築する場合、その土地に対する建築物の建築面積の最高限度として、正しいものはどれか。なお、記載のない条件については一切考慮しないこととする。<br><img src='/img/yoso/18_7.png'/>",
        "question2": "",
        "choice1": "３００㎡",
        "choice2": "１,５００㎡",
        "choice3": "１,８００㎡",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "建築面積の計算",
        "important": ""
    },
    {
        "id": 1230,
        "shikenId": 22,
        "no": 11,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "中田さんは、下記＜資料＞の新築分譲物件の購入を検討している。この物件の購入金額（消費税を含んだ金額）として、正しいものはどれか。なお、＜資料＞に記載されている金額は消費税を除いた金額であり、消費税率は１０％として計算すること。また、売買に係る諸経費については一切考慮しないこととする。<br><img src='/img/yoso/18_8.png'/>",
        "question2": "",
        "choice1": "５,７５０万円",
        "choice2": "５,８００万円",
        "choice3": "６,０５０万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "不動産の消費税の計算",
        "important": ""
    },
    {
        "id": 1231,
        "shikenId": 22,
        "no": 12,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "古賀秀紀さんが加入している生命保険（下記＜資料＞参照）の保障内容に関する次の記述の空欄（ア）にあてはまる金額として、正しいものはどれか。なお、保険契約は有効に継続しているものとし、特約は自動更新されているものとする。また、秀紀さんはこれまでに＜資料＞の保険から保険金および給付金を一度も受け取っていないものとする。<br><img src='/img/yoso/18_9.png'/>",
        "question2": "",
        "choice1": "１,３００万円",
        "choice2": "１,６００万円",
        "choice3": "２,６００万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "生命保険の証券分析",
        "important": ""
    },
    {
        "id": 1232,
        "shikenId": 22,
        "no": 13,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "損害保険の保険種類と事故の内容について記述した下表１～３のうち、対応する保険で補償の対象となるものはどれか。なお、記載のない事項については一切考慮しないこととする。<br><img src='/img/yoso/18_10.png'/>",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "損害保険",
        "important": ""
    },
    {
        "id": 1233,
        "shikenId": 22,
        "no": 14,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "２人とも会社員である瀬古さん夫妻が加入している生命保険は下表のとおりである。下表の契約Ａ～Ｃについて、保険金が支払われた場合の課税関係に関する次の記述のうち、最も適切なものはどれか。<br><img src='/img/yoso/18_11.png'/>",
        "question2": "",
        "choice1": "契約Ａについて、被保険者である妻が受け取った特定疾病保険金は一時所得として所得税の課税対象となる。",
        "choice2": "契約Ｂについて、子が受け取った死亡保険金は相続税の課税対象となる。",
        "choice3": "契約Ｃについて、夫が受け取った年金は雑所得として所得税の課税対象となる。",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "個人契約の生命保険の税務",
        "important": ""
    },
    {
        "id": 1234,
        "shikenId": 22,
        "no": 15,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "会社員の内田純さんが本年中に支払った医療費等が下記＜資料＞のとおりである場合、純さんの本年分の所得税の確定申告における医療費控除の金額として、正しいものはどれか。なお、純さんの本年分の所得は給与所得６５０万円のみであり、支払った医療費等はすべて純さんおよび生計を一にする妻のために支払ったものである。また、医療費控除の金額が最も大きくなるよう計算することとし、「特定一般用医薬品等購入費を支払った場合の医療費控除の特例」は考慮しないこととする。<br><img src='/img/yoso/18_12.png'/>",
        "question2": "",
        "choice1": "１７３,０００円",
        "choice2": "２５３,０００円",
        "choice3": "２７３,０００円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "医療費控除の計算",
        "important": ""
    },
    {
        "id": 1235,
        "shikenId": 22,
        "no": 16,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "菊地さんは、２２年前に購入し、現在居住している自宅の土地および建物を売却する予定である。売却に係る状況が下記＜資料＞のとおりである場合、所得税における課税長期譲渡所得の金額として、正しいものはどれか。<br><img src='/img/yoso/18_13.png'/>",
        "question2": "",
        "choice1": "２,２００万円",
        "choice2": "２,５００万円",
        "choice3": "２,８００万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "居住用財産の譲渡所得の計算",
        "important": ""
    },
    {
        "id": 1236,
        "shikenId": 22,
        "no": 17,
        "answerType": 3,
        "groupId": 0,
        "answer": 1,
        "score": 5,
        "question1": "会社員の大城さんの本年分の所得等が下記＜資料＞のとおりである場合、大城さんが本年分の所得税の確定申告をする際に、給与所得と損益通算できる損失の金額として、正しいものはどれか。なお、▲が付された所得の金額は、その所得に損失が発生していることを意味するものとする。<br><img src='/img/yoso/1232_13.png'/>",
        "question2": "",
        "choice1": "▲１８０万円",
        "choice2": "▲１８５万円",
        "choice3": "▲２５５万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "居住用財産の譲渡所得の計算",
        "important": ""
    },
    {
        "id": 1237,
        "shikenId": 22,
        "no": 18,
        "answerType": 3,
        "groupId": 0,
        "answer": 3,
        "score": 5,
        "question1": "相続開始後の各種手続きにおいて、下記＜資料＞の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、正しいものはどれか。なお、記載のない事項については一切考慮しないこととする。<br><img src='/img/yoso/18_14.png'/>",
        "question2": "",
        "choice1": "（ア）１ヵ月 （イ） ４ヵ月",
        "choice2": "（ア）３ヵ月 （イ） ４ヵ月",
        "choice3": "（ア）３ヵ月 （イ） １０ヵ月",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続手続きの期限",
        "important": ""
    },
    {
        "id": 1238,
        "shikenId": 22,
        "no": 19,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "本年１０月２４日に相続が開始された高山大介さん（被相続人）の＜親族関係図＞が下記のとおりである場合、民法上の相続人および法定相続分の組み合わせとして、正しいものはどれか。なお、記載のない条件については一切考慮しないこととする。<br><img src='/img/yoso/18_15.png'/>",
        "question2": "",
        "choice1": "幸子　１／２　　一郎　１／２",
        "choice2": "幸子　１／２　　一郎　１／４　　健　１／８　　芳江　１／８",
        "choice3": "幸子　１／２　　一郎　１／６　　健　１／６　　芳江　１／６",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "相続人と法定相続分",
        "important": ""
    },
    {
        "id": 1239,
        "shikenId": 22,
        "no": 20,
        "answerType": 3,
        "groupId": 0,
        "answer": 2,
        "score": 5,
        "question1": "香川新太郎さん（５５歳）は、夫婦間で居住用不動産の贈与、父（８０歳）からは相続時精算課税制度による贈与を考えている。居住用不動産の贈与については贈与税の配偶者控除、父からの贈与については相続時精算課税制度の活用について、ＦＰで税理士でもある徳島さんの回答の空欄（ア）～（オ）に当てはまる数値に関する記述として、最も不適切なものはどれか。<br><img src='/img/yoso/18_16.png'/>",
        "question2": "",
        "choice1": "（ア）と（オ）は「２０」が入る。",
        "choice2": "（ウ）と（エ）は「２，０００」が入る。",
        "choice3": "（イ）は「１１０」が入る。",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "贈与税の配偶者控除、相続時精算課税制度",
        "important": ""
    },

    {
        "id": 1240,
        "shikenId": 12,
        "no": 1,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/yoso/471_1.png'/>",
        "question2": "はじめに、Ｍさんは、Ａさんが老齢基礎年金の受給を65歳から開始した場合の年金額を試算した。Ｍさんが試算した老齢基礎年金の年金額の計算式として、次のうち最も適切なものはどれか。なお、老齢基礎年金の年金額は、本年度価額に基づいて計算するものとする。",
        "choice1": "831,700円 × 450月 / 480月",
        "choice2": "831,700円 × 480月 / 480月",
        "choice3": "831,700円 × 510月 / 540月",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1241,
        "shikenId": 12,
        "no": 2,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/yoso/471_1.png'/>",
        "question2": "次に、Ｍさんは、会社員の老齢厚生年金について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「Ａさんには、特別支給の老齢厚生年金は支給されず、原則として、65歳から老齢厚生年金を受給することになります」",
        "choice2": "「Ａさんは厚生年金保険の被保険者期間が20年以上ありますので、Ａさんが65歳から受給する老齢厚生年金の額には、加給年金額は加算されます」",
        "choice3": "「Ａさんが70歳０カ月で老齢厚生年金の繰下げ支給の申出をする場合、当該年金額の増額率は42％になります」",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1242,
        "shikenId": 12,
        "no": 3,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/471_1.png'/>",
        "question2": "最後に、Ｍさんは、確定拠出年金の個人型年金について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「Ａさんが個人型年金に加入する場合、最長 65 歳に達するまで加入できます」",
        "choice2": "「Ａさんは、国民年金基金と個人型年金の両方に加入することができ、掛金の限度額は合わせて月額68,000円が限度となります」",
        "choice3": "「通算加入者等期間が10年以上ある場合、60歳到達時に老齢給付金を受給できますが、Ａさんが現時点から加入する場合、60歳から受給することはできません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1243,
        "shikenId": 12,
        "no": 4,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/474_1.png'/>",
        "question2": "Ｍさんは、《設例》の米ドル建定期預金について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「Ｘ銀行の米ドル建定期預金の場合、Ａさんが満期時に受け取ることができる利息額は300米ドル（税引前）になります」",
        "choice2": "「Ａさんが預入時に円を米ドルに換える際に適用される為替レートは、１米ドル＝150.00円になります」",
        "choice3": "「ＴＴＭとＴＴＳ（ＴＴＢ）の差分は為替スプレッドと呼ばれるもので、取引金融機関による差異はありません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1244,
        "shikenId": 12,
        "no": 5,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/yoso/474_1.png'/>",
        "question2": "Ａさんが、《設例》の条件のとおり、10,000米ドルを外貨預金に預け入れ、満期時に円貨で受け取った場合における元利金の合計額として、次のうち最も適切なものはどれか。なお、計算にあたっては税金等を考慮せず、預入期間３カ月は0.25年として計算すること。",
        "choice1": "1,491,100円",
        "choice2": "1,541,475円",
        "choice3": "1,575,900円",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1245,
        "shikenId": 12,
        "no": 6,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/474_1.png'/>",
        "question2": "Ｍさんは、《設例》の米ドル建定期預金の課税関係について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「満期時に為替差益が生じた場合、当該金額は雑所得として総合課税の対象となります」",
        "choice2": "「満期時に為替差損が生じた場合、所得税の確定申告をすることにより、当該損失の金額をＡさんの役員給与として得た所得と損益通算することができます」",
        "choice3": "「Ａさんが受け取る利子は、利子所得として源泉分離課税の対象となり、20.315％相当額が源泉徴収等されます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1246,
        "shikenId": 12,
        "no": 7,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/yoso/477_1.png'/>",
        "question2": "Ａさんの本年分の所得税における総所得金額は、次のうちどれか。<br><img src='/img/yoso/477_2.png'/>",
        "choice1": "436 万円",
        "choice2": "461 万円",
        "choice3": "486 万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1247,
        "shikenId": 12,
        "no": 8,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/yoso/477_1.png'/>",
        "question2": "Ａさんの本年分の所得税における所得控除に関する以下の文章の空欄①～③に入る語句の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/yoso/478_1.png'/>",
        "choice1": "①　小規模企業共済等掛金控除　　②　26 万円　　　③　63 万円",
        "choice2": "①　社会保険料控除　　　　　　　②　38 万円　　　③　63 万円",
        "choice3": "①　小規模企業共済等掛金控除　　②　38 万円　　　③　38 万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1248,
        "shikenId": 12,
        "no": 9,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/yoso/477_1.png'/>",
        "question2": "Ａさんの本年分の所得税の確定申告に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「Ａさんは、ふるさと納税に係る寄附金控除について、年末調整では適用を受けることができませんので、所得税の確定申告が必要となります」",
        "choice2": "「一時払養老保険の満期保険金に係る保険差益は、雑所得として総合課税の対象となります。Ａさんは所得税の確定申告をする義務が生じます」",
        "choice3": "「確定申告書は、原則として、所得が生じた年の翌年2月1日から３月15日までの間にＡさんの勤務地を所轄する税務署長に提出してください」",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1249,
        "shikenId": 12,
        "no": 10,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 4,
        "question1": "<img src='/img/yoso/480_1.png'/>",
        "question2": "甲土地に賃貸マンション（準耐火建築物）を建築する場合の①建蔽率の上限となる建築面積と②容積率の上限となる延べ面積の組み合わせとして、次のうち最も適切なものはどれか。",
        "choice1": "①　320㎡　　②　1,600㎡",
        "choice2": "①　360㎡　　②　1,600㎡",
        "choice3": "①　400㎡　　②　1,440㎡",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1250,
        "shikenId": 12,
        "no": 11,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/480_1.png'/>",
        "question2": "甲土地についての A さんに対するアドバイスとして、次の記述のうち最も適切なものはどれか。",
        "choice1": "「自己建設方式は、 A さんがマンション等の建築資金の調達や建築工事の発注、建物の管理・運営を自ら行う方式です。A さん自らが貸主となってマンションの賃貸を行うには、宅地建物取引業の免許が必要です。」",
        "choice2": "「等価交換方式とは、A さんが所有する土地の上に、事業者が建設資金を負担してマンション等を建設し、完成した建物と土地を A さんと事業者がそれぞれの出資割合に応じて取得する方式です。",
        "choice3": "「甲土地の前面道路（幅員 6m の公道）の相続税路線価は、1㎡当たりの価額が300 万円であることを示しています」",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1251,
        "shikenId": 12,
        "no": 12,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/yoso/480_1.png'/>",
        "question2": "甲土地の有効活用に関する以下の文章の空欄①～③に入る語句の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/yoso/482_1.png'/>",
        "choice1": "①　貸宅地　　　　　②　80％　　　③　３分の１",
        "choice2": "①　貸宅地　　　　　②　50％　　　③　６分の１",
        "choice3": "①　貸家建付地　　　②　50％　　　③　６分の１",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1252,
        "shikenId": 12,
        "no": 13,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/yoso/483_1.png'/>",
        "question2": "生前贈与に関する以下の文章の空欄①～③に入る数値の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/yoso/483_2.png'/>",
        "choice1": "①　2,500　　　　②　20　　　　③　1,500",
        "choice2": "①　2,500　　　　②　20　　　　③　1,000",
        "choice3": "①　2,000　　　　②　10　　　　③　1,500",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1253,
        "shikenId": 12,
        "no": 14,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/yoso/483_1.png'/>",
        "question2": "現時点において、Ａさんの相続が開始した場合に関する次の記述のうち、最も不適切なものはどれか。なお、Ａさんの相続税の課税価格は5億円以下であるものとする。",
        "choice1": "「孫であるＥさん、Ｆさん、Ｇさん、ＨさんがＡさんからの遺贈により財産を取得した場合、相続税額の２割加算の対象となります」",
        "choice2": "「 『配偶者に対する相続税額の軽減』の適用を受けた場合、妻Ｂさんが相続により取得した財産の金額が、配偶者の法定相続分相当額と１億6,000万円とのいずれか多い金額までであれば、納付すべき相続税額は算出されません」",
        "choice3": "「本年中に孫であるＥさん、Ｆさん、Ｇさん、Ｈさんが、『直系尊属から教育資金の一括贈与を受けた場合の贈与税の非課税制度』の適用を受けて教育資金の贈与を受け、その後本年中にＡさんが死亡した場合、非課税拠出額から教育資金支出額を控除した残額があるときは、当該残額は、原則として相続税の課税価格に加算されます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1254,
        "shikenId": 12,
        "no": 15,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/yoso/483_1.png'/>",
        "question2": "仮に、長男Ｃさんが暦年課税（各種非課税制度の適用はない）により、本年中にＡさんから現金700万円の贈与を受けた場合の贈与税額は、次のうちどれか。<br><img src='/img/yoso/485_1.png'/>",
        "choice1": "88万円",
        "choice2": "112 万円",
        "choice3": "120 万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1255,
        "shikenId": 13,
        "no": 1,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/yoso/486_1.png'/><br><img src='/img/yoso/486_2.png'/>",
        "question2": "はじめに、Ｍさんは、《設例》の＜Ａさん夫妻に関する資料＞に基づき、Ａさんおよび妻Ｂさんが老齢基礎年金の受給を65歳から開始した場合の年金額（本年度価額）を試算した。Ｍさんが試算した老齢基礎年金の年金額の計算式の組合せとして、次のうち最も適切なものはどれか。",
        "choice1": "Ａさん　：831,700円 × 510月 / 480 月<br>妻Ｂさん：831,700円 × 374 月 / 480月",
        "choice2": "Ａさん　：831,700円 × 450月 / 480 月<br>妻Ｂさん：831,700円 × 480 月 / 480月",
        "choice3": "Ａさん　：831,700円 × 480月 / 480 月<br>妻Ｂさん：831,700円 × 494 月 / 480月",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1256,
        "shikenId": 13,
        "no": 2,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/486_1.png'/><br><img src='/img/yoso/486_2.png'/>",
        "question2": "次に、Ｍさんは、老齢基礎年金の繰上げ支給および繰下げ支給について説明した。Ｍさんが、Ａさんに対して説明した以下の文章の空欄①～③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/yoso/487_1.png'/>",
        "choice1": "①　24　　　②　するか否か選択できます　　　③　42",
        "choice2": "①　24　　　②　しなければなりません　　　　③　84",
        "choice3": "①　30　　　②　しなければなりません　　　　③　84",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1257,
        "shikenId": 13,
        "no": 3,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/yoso/486_1.png'/><br><img src='/img/yoso/486_2.png'/>",
        "question2": "最後に、Ｍさんは、Ａさんおよび妻Ｂさんが受給することができる公的年金制度からの老齢給付について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「Ａさんが65歳から受給することができる老齢厚生年金には、配偶者の加給年金額が加算されます」",
        "choice2": "「Ａさんが現在の勤務先で引き続き厚生年金保険の被保険者として65歳になるまで勤務した場合、65歳から支給される老齢厚生年金は、65歳到達時における厚生年金保険の被保険者記録を基に計算されます」",
        "choice3": "「Ａさんおよび妻Ｂさんは、いずれも特別支給の老齢厚生年金の支給はなく、原則として、65歳から老齢基礎年金および老齢厚生年金が支給されます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1258,
        "shikenId": 13,
        "no": 4,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/yoso/489_1.png'/>",
        "question2": "まず、Ｍさんは、生命保険の見直しを検討する前に、現時点の必要保障額を試算することにした。下記の＜算式＞および＜条件＞に基づき、Ａさんが現時点で死亡した場合の必要保障額は、次のうちどれか。<br><img src='/img/yoso/489_2.png'/>",
        "choice1": "500 万円",
        "choice2": "1,000万円",
        "choice3": "1,500万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1259,
        "shikenId": 13,
        "no": 5,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/489_1.png'/>",
        "question2": "次に、Ｍさんは、ＡさんがＸ社を退職した後の公的医療保険について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「Ａさんの退職後、健康保険の任意継続被保険者とならなかった場合、国民健康保険に加入します。Ａさんが国民健康保険に加入した場合、妻Ｂさんを国民健康保険の被扶養者とすることができます」",
        "choice2": "「Ａさんが退職後、国民健康保険に加入した場合、健康保険と同様に高額療養費の支給があります」",
        "choice3": "「Ａさんは、退職日の翌日から65 歳になるまでの間、健康保険の任意継続被保険者として加入することができます。ただし、在職中とは異なり、保険料はＡさんが全額負担することになります」",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1260,
        "shikenId": 13,
        "no": 6,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/yoso/489_1.png'/>",
        "question2": "さらに、Ｍさんは、生命保険の見直しについてアドバイスした。ＭさんのＡさんに対するアドバイスとして、次のうち最も適切なものはどれか。",
        "choice1": "「終身保険や定期保険特約の保険金額を減額することで、保険料負担を軽減できます。軽減した保険料をもとに医療保険に新規加入することで医療保障の充実を図れます」",
        "choice2": "「厚生労働省の各種データによれば、入院日数が年々長くなる傾向があり、退院後の通院時の療養に係る費用負担も大きくなっていますので、医療保障を検討する場合は、入院中および退院後の通院に対する保障を充実させることが大切です」",
        "choice3": "「定期保険特約付終身保険を払済終身保険に変更した場合、入院特約や傷害特約などの医療保障目的の特約は消滅しますが、定期保険特約などの死亡保障を目的とした特約は継続します」",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1261,
        "shikenId": 13,
        "no": 7,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/492_1.png'/>",
        "question2": "仮に、将来Ｘ社がＡさんに役員退職金5,000万円を支給した場合、Ａさんが受け取る役員退職金に係る退職所得の金額として、次のうち最も適切なものはどれか。なお、Ａさんの役員在任期間（勤続年数）を40年とし、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。",
        "choice1": "1,100 万円",
        "choice2": "1,400 万円",
        "choice3": "2,800 万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1262,
        "shikenId": 13,
        "no": 8,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/yoso/492_1.png'/>",
        "question2": "次に、Ｍさんは、《設例》の＜資料＞の終身保険について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「Ａさんの勇退時に、役員退職金の一部または全部として終身保険の契約者をＡさん、死亡保険金受取人をＡさんの相続人に名義を変更することで、Ａさんの個人の保険として継続することができます」",
        "choice2": "「Ｘ社が契約者貸付制度を利用し、契約者貸付金を受け取った場合や返済する場合、経理処理は必要ありません」",
        "choice3": "「この終身保険は、保険料払込期間中の解約返戻金額を抑えることで、低解約返戻金型ではない終身保険と比較して保険料が割安となっています」",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1263,
        "shikenId": 13,
        "no": 9,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/yoso/492_1.png'/>",
        "question2": "Ｍさんは、総合福祉団体定期保険の一般的な商品性について説明した。Ｍさんが、Ａさんに対して説明した以下の文章の空欄①～③に入る語句の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/yoso/494_1.png'/>",
        "choice1": "①  ができます　　②  全額　　　③  契約者である法人",
        "choice2": "①  はできません　②  ２分の１　③  契約者である法人",
        "choice3": "①  はできません　②  全額　　　③  被保険者である従業員またはその遺族",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1264,
        "shikenId": 13,
        "no": 10,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/yoso/495_1.png'/><br><img src='/img/yoso/495_2.png'/>",
        "question2": "Ａさんの本年分の所得税における所得控除に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「Ａさんが支払っている長男Ｃさんの国民年金の保険料は、社会保険料控除の対象となりません」",
        "choice2": "「会社員であるＡさんは、勤務先の年末調整においてセルフメディケーション税制の適用を受けることができます」",
        "choice3": "「セルフメディケーション税制の適用を受ける場合、特定一般用医薬品等購入費の総額（保険金などで補てんされる金額を除く）が12,000円を超えるときに、その超える部分の金額（最高88,000円）を総所得金額等から控除することができます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1265,
        "shikenId": 13,
        "no": 11,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/yoso/495_1.png'/><br><img src='/img/yoso/495_2.png'/>",
        "question2": "Ａさんの本年分の所得税における総所得金額は、次のうちどれか。<br><img src='/img/yoso/496_1.png'/>",
        "choice1": "695 万円",
        "choice2": "715 万円",
        "choice3": "720 万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1266,
        "shikenId": 13,
        "no": 12,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/495_1.png'/><br><img src='/img/yoso/495_2.png'/>",
        "question2": "Ａさんの本年分の所得税における所得控除に関する以下の文章の空欄①～ ③に入る数値の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/yoso/497_1.png'/>",
        "choice1": "①　26　　　②　38　　　③　48",
        "choice2": "①　38　　　②　63　　　③　58",
        "choice3": "①　38　　　②　58　　　③　63",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1267,
        "shikenId": 13,
        "no": 13,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/498_1.png'/>",
        "question2": "Ａさんの相続に関する以下の文章の空欄①～③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/yoso/498_2.png'/>",
        "choice1": "①　８分の１　　②　6 , 000　　③　４",
        "choice2": "①　12 分の１　　②　6 , 000　　③　10",
        "choice3": "①　12 分の１　　②　5 , 400　　③　４",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1268,
        "shikenId": 13,
        "no": 14,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/yoso/498_1.png'/>",
        "question2": "Ａさんの相続に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "妻Ｂさんが『配偶者に対する相続税額の軽減』の適用を受けた場合、原則として、妻Ｂさんの相続税の課税価格が、相続税の課税価格の合計額に対する配偶者の法定相続分相当額と１億6,000万円とのいずれか多い金額までであれば、納付すべき相続税額は算出されません」",
        "choice2": "「長女Ｃさんが受け取った死亡保険金は、みなし相続財産として相続税の課税対象となりますが、死亡保険金の非課税金額の規定の適用を受けることで、相続税の課税価格に算入される金額は2,500万円となります」",
        "choice3": "「孫Ｆさん、孫Ｇさんおよび孫Ｈさんは、相続税額の２割加算の対象となります」",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1269,
        "shikenId": 13,
        "no": 15,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/498_1.png'/>",
        "question2": "Ａさんの相続に係る課税遺産総額（課税価格の合計額－遺産に係る基礎控 除額）が8,400 万円であった場合の相続税の総額は、次のうちどれか。<br><img src='/img/yoso/500_1.png'/>",
        "choice1": "1,070 万円",
        "choice2": "1,100 万円",
        "choice3": "1,820 万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1270,
        "shikenId": 16,
        "no": 1,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/yoso/501_1.png'/>",
        "question2": "本年度現時点においてＡさんが死亡した場合、妻Ｂさんに支給される遺族基礎年金の年金額（本年度価額）は、次のうちどれか。",
        "choice1": "831,700 円",
        "choice2": "831,700 円＋ 239,300 円＋ 239,300 円",
        "choice3": "831,700 円＋ 239,300 円＋ 79,800 円",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1271,
        "shikenId": 16,
        "no": 2,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/501_1.png'/>",
        "question2": "Ｍさんは、本年度現時点においてＡさんが死亡した場合に妻Ｂさんに支給される遺族厚生年金の金額等について説明した。Ｍさんが、Ａさんに対して説明した以下の文章の空欄①～③に入る語句の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/yoso/502_1.png'/>",
        "choice1": "①　３分の２　　　②　240 月　　　③　加給年金額",
        "choice2": "①　４分の３　　　②　300 月　　　③　中高齢寡婦加算",
        "choice3": "①　４分の３　　　②　240 月　　　③　加給年金額",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1272,
        "shikenId": 16,
        "no": 3,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/yoso/501_1.png'/>",
        "question2": "Ｍさんは、公的介護保険（以下、「介護保険」という）の保険給付について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「介護保険の被保険者は、65歳以上の第１号被保険者と40歳以上65歳未満の医療保険加入者である第２号被保険者に区分されます」",
        "choice2": "「第１号被保険者は、要介護状態となった原因が特定疾病であるか否かにかかわらず、介護給付を受けることができます」",
        "choice3": "「第２号被保険者が介護給付を受けた場合、実際にかかった費用（食費、居住費等を除く）の３割を自己負担する必要があります」",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1273,
        "shikenId": 16,
        "no": 4,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/yoso/504_1.png'/>",
        "question2": "まず、Ｍさんは、Ｘ社株式を売買する場合の留意点等について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「その他の取引や手数料等を考慮しない場合、仮に、特定口座（源泉徴収あり）でＸ社株式を株価1,500円で100株購入し、同年中に株価1,800円で全株を売却した場合、譲渡益３万円に対して20.315％が源泉徴収等されます」",
        "choice2": "「2026年3月30日（月）までに、Ｘ社株式を購入すれば、Ｘ社株式の次回の期末配当を受け取ることができます」",
        "choice3": "「証券取引所における株式の売買注文の方法のうち、成行注文は、指値注文よりも優先して売買が成立します」",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1274,
        "shikenId": 16,
        "no": 5,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/yoso/504_1.png'/>",
        "question2": "Ｍさんは、Ｙ社債に投資する場合の留意点等について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「通常は、ＢＢＢ（トリプルＢ）格相当以上の格付がついていれば、投資適格債とされます」",
        "choice2": "Ｙ社債を設例の条件で購入した場合の最終利回りは、2.45%（小数点第３位四捨五入）である。",
        "choice3": "「Ｙ社債の利子は、申告分離課税の対象となり、利子の支払時において所得税および復興特別所得税と住民税の合計で15.315％相当額が源泉徴収等されます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1275,
        "shikenId": 16,
        "no": 6,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/yoso/504_1.png'/>",
        "question2": "最後に、Ｍさんは、上場不動産投資信託（J-REIT）について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「上場不動産投資信託（J-REIT）は、NISAの成長投資枠を利用して購入することができますが、NISAのつみたて投資枠を利用して購入することはできません」",
        "choice2": "「上場不動産投資信託（J-REIT）の分配金は、不動産所得として課税の対象となります」",
        "choice3": "「上場不動産投資信託（J-REIT）は、投資家から集めた資金を不動産や不動産会社の株式に投資し、不動産の賃貸収入や売買益、不動産会社の株式への投資による配当金や売買益を投資家に分配する投資信託です」",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1276,
        "shikenId": 16,
        "no": 7,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/507_1.png'/>",
        "question2": "所得税における青色申告制度に関する以下の文章の空欄①～③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/yoso/507_2.png'/>",
        "choice1": "①　55　　　②　10　　　③　雑損失",
        "choice2": "①　65　　　②　10　　　③　純損失",
        "choice3": "①　65　　　②　20　　　③　雑損失",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1277,
        "shikenId": 16,
        "no": 8,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/yoso/507_1.png'/>",
        "question2": "Ａさんの本年分の所得税の課税に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「Ａさんは公的年金等の収入金額の合計額が108万円であるため、公的年金等に係る雑所得の金額は算出されません」",
        "choice2": "「Ａさんが適用を受けることができる配偶者控除の金額は、38万円です」",
        "choice3": "「一時払養老保険の満期保険金に係る保険差益は、源泉分離課税の対象となります」",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1278,
        "shikenId": 16,
        "no": 9,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/yoso/507_1.png'/>",
        "question2": "Ａさんの本年分の所得税における総所得金額は、次のうちどれか。",
        "choice1": "525 万円",
        "choice2": "550 万円",
        "choice3": "575 万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1279,
        "shikenId": 16,
        "no": 10,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/yoso/511_1.png'/>",
        "question2": "甲土地に耐火建築物を建築する場合の①建蔽率の上限となる建築面積と②容積率の上限となる延べ面積の組合せとして、次のうち最も適切なものはどれか。",
        "choice1": "①　500㎡　     ②　2 , 000㎡",
        "choice2": "①　500㎡　     ②　1 , 500㎡",
        "choice3": "①　450㎡　     ②　2 , 400㎡",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1280,
        "shikenId": 16,
        "no": 11,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/yoso/511_1.png'/>",
        "question2": "自宅（建物およびその敷地である甲土地）の譲渡に関する以下の文章の空欄①～③に入る語句の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/yoso/512_1.png'/>",
        "choice1": "①　３年　 ②　 6 , 000 万円　 ③　10 年",
        "choice2": "①　３年　 ②　 １億円　 ③　10 年",
        "choice3": "①　５年　 ②　 １億円　 ③　５年",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1281,
        "shikenId": 16,
        "no": 12,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/511_1.png'/>",
        "question2": "甲土地の有効活用と宅地の評価に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「甲土地の前面道路（幅員６ｍ）の相続税路線価は１㎡当たりの価額が30万円、借地権割合が70％であることを示しています」",
        "choice2": "「Ａさんが甲土地に賃貸マンションを建築した場合、相続税の課税価格の計算上、甲土地は貸宅地として評価され、自用地価額×（１－借地権割合×借家権割合×賃貸割合）により計算されます」",
        "choice3": "「Ａさんが甲土地に賃貸マンションを建築するための資金を金融機関からの借入金で調達した場合、Ａさんの相続における相続税額の計算上、当該借入金の残高は債務控除の対象となります」",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1282,
        "shikenId": 16,
        "no": 13,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/yoso/513_1.png'/>",
        "question2": "A さんの相続等に関する次の記述のうち、 最も不適切なものはどれか。",
        "choice1": "「自筆証書遺言は、遺言者が、遺言の全文、日付、氏名を自書し、押印して作成します。自筆証書に添付する財産目録については、パソコン等で作成することもできます。」",
        "choice2": "「遺産分割を少しでも円滑に行うために、公正証書遺言の作成をお勧めします。公正証書遺言は証人 2 人以上の立会いのもと、遺言者が遺言の趣旨を公証人に口述し、公証人がこれを筆記して作成します。」",
        "choice3": "遺言により妻 B さんおよび長女 C さんが相続財産の大半を取得した場合、長男 D さんの遺留分を侵害する可能性があります。仮に、遺留分を算定するための財産の価額が2 億円である場合、長男 D さんの遺留分の金額は5,000 万円となります。",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1283,
        "shikenId": 16,
        "no": 14,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/yoso/513_1.png'/>",
        "question2": "仮に、 Ａさんの相続が本年現時点で開始し、Ａさんの相続に係る課税遺産総額（課税価格の合計額－遺産に係る基礎控除額）が1 億 5,000 万円であった場合の相続税の総額は、次のうちどれか。<br><img src='/img/yoso/514_1.png'/>",
        "choice1": "1,495 万円",
        "choice2": "2,650 万円",
        "choice3": "4,300 万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1284,
        "shikenId": 16,
        "no": 15,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/yoso/513_1.png'/>",
        "question2": "Ａさんの相続に係る小規模宅地等についての相続税の課税価格の計算の特例（以下、「本特例」という）に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「自宅の敷地と賃貸ビルの敷地について、本特例の適用を受けようとする場合、適用対象面積の調整はせず、それぞれの宅地等の適用対象の限度面積まで適用を受けることができます」",
        "choice2": "「妻Ｂさんが自宅の敷地を相続により取得し、相続税の申告期限までに自宅の敷地を売却した場合、当該敷地は特定居住用宅地等として本特例の適用を受けることができなくなります」",
        "choice3": " 「妻 B さんが自宅の敷地と建物を相続により取得し、『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けた場合、自宅の敷地（相続税評価額 6,000 万円）について、相続税の課税価格に算入すべき価額を1,200 万円とすることができます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1285,
        "shikenId": 17,
        "no": 1,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 4,
        "question1": "<img src='/img/yoso/516_1.png'/><br><img src='/img/yoso/516_2.png'/>",
        "question2": "はじめに、Ｍさんは、Ａさんが本年度の現時点において死亡した場合に妻Ｂさんが受給することができる遺族基礎年金の年金額（本年度価額）を試算した。Ｍさんが試算した遺族基礎年金の年金額の計算式として、次のうち最も適切なものはどれか。",
        "choice1": "831,700円＋79,800円＋79,800円＋79,800円",
        "choice2": "831,700円＋239,300円＋79,800円＋79,800円",
        "choice3": "831,700円＋239,300円＋239,300円＋79,800円",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1286,
        "shikenId": 17,
        "no": 2,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/516_1.png'/><br><img src='/img/yoso/516_2.png'/>",
        "question2": "次に、Ｍさんは、Ａさんが現時点において死亡した場合に妻Ｂさんに支給される遺族厚生年金について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「妻Ｂさんに支給される遺族厚生年金の額は、原則として、Ａさんの厚生年金保険の被保険者記録を基礎として計算した老齢厚生年金の報酬比例部分の額の２分の１に相当する額になります」",
        "choice2": "「二女Ｅさんの18歳到達年度の末日が終了し、妻Ｂさんの有する遺族基礎年金の受給権が消滅したときは、妻Ｂさんが受給する遺族厚生年金に中高齢寡婦加算が加算されます」",
        "choice3": "「妻Ｂさんに支給される遺族厚生年金の額は、その年金額の計算の基礎となる被保険者期間の月数が360月に満たないため、360月として計算した額になります」",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1287,
        "shikenId": 17,
        "no": 3,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/yoso/516_1.png'/><br><img src='/img/yoso/516_2.png'/>",
        "question2": "最後に、Ｍさんは、公的介護保険（以下、「介護保険」という）について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「介護保険の介護給付を受けようとする場合は、要介護者に該当することおよびその該当する要介護状態区分について、都道府県の認定を受ける必要があります」",
        "choice2": "「介護保険の被保険者は、65歳以上の第１号被保険者と40歳以上65歳未満の医療保険加入者である第２号被保険者に分けられます」",
        "choice3": "「介護保険の第２号被保険者については、要介護状態となった原因が、初老期における認知症や脳血管疾患などの特定疾病によって生じたものでなければ介護給付を受けられません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1288,
        "shikenId": 17,
        "no": 4,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/yoso/519_1.png'/>",
        "question2": "はじめに、Ｍさんは、生命保険の加入等についてアドバイスした。ＭさんのＡさんに対するアドバイスとして、次のうち最も適切なものはどれか。",
        "choice1": "「生命保険の申込みをした後、保険会社指定の医師による診査を受けた場合には、保険業法に定める保険契約の申込みの撤回等（クーリング・オフ）はできません」",
        "choice2": "「生命保険は、一般的に、契約の申込みまたは申込みの撤回等（クーリング・オフ）に関する事項を記載した書面の交付日のいずれか遅い日から起算して8日以内であれば、書面（電磁的記録を含む）または口頭により申込みの撤回等をすることができます」",
        "choice3": "「生命保険に加入する際、Ａさんの過去の傷病歴や現在の健康状態など、事実をありのままに正しく告知しなければなりません。なお、告知受領権は生命保険募集人が有していますので、当該募集人に対して、口頭で告知すれば正しく告知したことになります」",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1289,
        "shikenId": 17,
        "no": 5,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/519_1.png'/>",
        "question2": "次に、Ｍさんは、Ａさんが提案を受けた生命保険の保障内容等について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「先進医療特約では、契約日時点において厚生労働大臣により先進医療として定められたものであれば、療養を受けた時点において先進医療としての承認を取り消されたものであっても給付の対象となります」",
        "choice2": "「引受基準緩和型の医療保険は、一般に、他の契約条件が同一で、引受基準緩和型ではない通常の医療保険と比べて、保険料が高く設定されています」",
        "choice3": "「Ａさんが、がんに罹患し、三大疾病一時金特約から一時金を受け取った場合、当該一時金の額は一時所得として総合課税の対象となります」",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1290,
        "shikenId": 17,
        "no": 6,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/yoso/519_1.png'/>",
        "question2": "最後に、Ｍさんは、Ａさんが加入する健康保険の給付について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「Ａさんが医師の診察を受けた場合、外来・入院を問わず、医療費の一部負担割合は､70歳に達するまでは原則３割です」",
        "choice2": "「Ａさんが一医療機関の窓口で支払う同一月内の一部負担金が所得金額に応じた自己負担限度額を超える場合、所得区分に応じて高額療養費が支給されます」",
        "choice3": "「Ａさんが業務外の事由による負傷や疾病のために連続して３日間休業した場合、休業４日目以降の休業した日について、通算２年を限度に傷病手当金が支給されます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1291,
        "shikenId": 17,
        "no": 7,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/yoso/522_1.png'/>",
        "question2": "Ｍさんは、中小企業A さんが65 歳で退職し、X 社が役員退職金 2,800 万円を支給した場合、A さんが受け取る退職所得の金額として、次のうち最も適切なものはどれか。なお、Aさんの役員在任期間（勤続年数）は25 年とし、これ以外に退職等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。",
        "choice1": "825万円",
        "choice2": "900万円",
        "choice3": "1,650万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1292,
        "shikenId": 17,
        "no": 8,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/yoso/522_1.png'/>",
        "question2": "次に M さんは、《設例》の長期平準定期保険について説明した。M さんの A さんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「X 社が当該保険を A さんが 65 歳のときに解約した場合、解約時点における払込保険料累計額と解約返戻金額との差額は雑損失として処理します」",
        "choice2": "「契約者貸付制度を利用すると、解約返戻金の一定の範囲内で資金を調達できます。なお、契約者貸付金には、保険会社所定の利息が発生します」",
        "choice3": "「現時点で当該生命保険を払済終身保険に変更する場合、契約は継続するため、経理処理は必要ありません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1293,
        "shikenId": 17,
        "no": 9,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/522_1.png'/>",
        "question2": "Ｍさんは、中小企業退職金共済制度（以下、「中退共」という）の特徴について説明した。Ｍさんが、Ａさんに対して説明した以下の文章の空欄①～③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/yoso/522_2.png'/>",
        "choice1": "①　２分の１　　　②　１　　　③　法人を経由して従業員に",
        "choice2": "①　全額　　　　　②　１　　　③　従業員本人に直接",
        "choice3": "①　全額　　　　　②　２　　　③　法人を経由して従業員に",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1294,
        "shikenId": 17,
        "no": 10,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/525_1.png'/><br><img src='/img/yoso/525_2.png'/>",
        "question2": "所得税における青色申告制度に関する以下の文章の空欄①～③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/yoso/525_3.png'/>",
        "choice1": "①　譲渡所得　　　　②　10　　　③　３",
        "choice2": "①　不動産所得　　　②　10　　　③　３",
        "choice3": "①　不動産所得　　　②　55　　　③　５",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1295,
        "shikenId": 17,
        "no": 11,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/yoso/525_1.png'/><br><img src='/img/yoso/525_2.png'/>",
        "question2": "Ａさんの本年分の所得税における所得控除に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「長男Ｃさんの合計所得金額は58万円以下であるため、Ａさんは長男Ｃさんに係る扶養控除の適用を受けることができます。長男Ｃさんに係る扶養控除の額は63万円となります」",
        "choice2": "「Ａさんは長女Ｄさんに係る扶養控除の適用を受けることができます。長女Ｄさんに係る扶養控除の額は38万円となります」",
        "choice3": "「妻Ｂさんは青色事業専従者として給与の支払を受けていますが、妻Ｂさんの合計所得金額は58万円以下であるため、Ａさんは、配偶者控除の適用を受けることができます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1296,
        "shikenId": 17,
        "no": 12,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/yoso/525_1.png'/><br><img src='/img/yoso/525_2.png'/>",
        "question2": "甲土地の有効活用と宅地の評価に関する次の記述のうち、最も不適切なものはどれか。<br><img src='/img/yoso/527_1.png'/>",
        "choice1": "①　1.0　　　②　10　　　③　できません",
        "choice2": "①　0.7　　　②　10　　　③　できます",
        "choice3": "①　0.7　　　②　13　　　③　できません",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1297,
        "shikenId": 17,
        "no": 13,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/528_1.png'/>",
        "question2": "遺言に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「自筆証書遺言は、遺言者が、その遺言の全文、日付および氏名を自書し、これに押印して作成するものですが、自筆証書遺言に添付する財産目録については、パソコン等で作成することも認められています」",
        "choice2": "「公正証書遺言は、証人２人以上の立会いのもと、遺言者が遺言の趣旨を公証人に口授し、公証人がこれを筆記して作成するものです。相続開始後に円滑に手続を進めるために、妻Ｂさんと長女Ｃさんの２人を証人にすることをお勧めします」",
        "choice3": "「自筆証書遺言は、所定の手続により、法務局（遺言書保管所）に保管することができます。法務局（遺言書保管所）に保管された自筆証書遺言は、相続開始時、家庭裁判所での検認が不要となります」",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1298,
        "shikenId": 17,
        "no": 14,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/yoso/528_1.png'/>",
        "question2": "Ａさんの相続等に関する以下の文章の空欄①～③に入る数値の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/yoso/529_1.png'/>",
        "choice1": "①　3,000　　　②　4,500　　　③　1,000",
        "choice2": "①　6,000　　　②　4,500　　　③　4,000",
        "choice3": "①　3,000　　　②　1,500　　　③　4,000",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1299,
        "shikenId": 17,
        "no": 15,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/528_1.png'/>",
        "question2": "仮に、Ａさんの相続が本年現時点で開始し、Ａさんの相続に係る課税遺産総額（課税価格の合計額－遺産に係る基礎控除額）が２億4,000万円であった場合の相続税の総額は、次のうちどれか。<br><img src='/img/yoso/530_1.png'/>",
        "choice1": "5,100万円",
        "choice2": "5,300万円",
        "choice3": "8,100万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1300,
        "shikenId": 20,
        "no": 1,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/531_1.png'/>",
        "question2": "Ｍさんは、Ａさんに対して、Ａさんが40歳でＸ社を退職した後の公的医療保険制度について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る語句の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/yoso/531_2.png'/>",
        "choice1": "①　14 日　　　②　１年　　　③　全額自己負担",
        "choice2": "①　20 日　　　②　２年　　　③　全額自己負担",
        "choice3": "①　14 日　　　②　２年　　　③　労使折半",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1301,
        "shikenId": 20,
        "no": 2,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/531_1.png'/>",
        "question2": "次に、Ｍさんは、Ａさんが退職後、老後の年金収入を増やすための各種制度について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「国民年金基金は、国民年金の第１号被保険者や任意加入被保険者が利用できる年金制度です。加入は口数制であり、１口目は２種類の終身年金（Ａ型・Ｂ型）のいずれかを選択します」",
        "choice2": "「付加保険料を納付することで、将来の年金を増やすことができます。仮に、Ａさんが付加保険料を240月納付し、65歳から老齢基礎年金を受給する場合は、年額96,000円の付加年金を受給することができます」",
        "choice3": "「Ａさんが確定拠出年金の個人型年金に加入する場合、国民年金基金と合わせて加入することができます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1302,
        "shikenId": 20,
        "no": 3,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/yoso/531_1.png'/>",
        "question2": "最後に、Ｍさんは、Ａさんに対して、Aさんの老齢給付について説明した。Mさんの説明に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「Ａさんが老齢基礎年金を受給するためには、原則として、受給資格期間が25年以上必要です」",
        "choice2": "「Ａさんが受給する老齢厚生年金は、総報酬月額相当額と基本月額との合計額が51万円（本年度の支給停止調整額）を超えると、超える部分の２分の１の額が支給停止となります」",
        "choice3": "「Ａさんが老齢厚生年金の繰下げ支給の申出をするには、老齢基礎年金も同時に繰下げ支給の申出を行わなければなりません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1303,
        "shikenId": 20,
        "no": 4,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/yoso/534_1.png'/>",
        "question2": "まず、M さんは、X 社株式の投資指標について説明した。M さんの A さんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「株価の相対的な割高・ 割安を判断する指標として、PER（株価収益率）と PBR（株価純資産倍率）があります。X 社株式の PER は 1. 2 倍、PBR は６倍です。PER と PBR はどちらも低いほうが株価は割安、高いほうが株価は割高だと判断されます。",
        "choice2": "「 X 社の配当利回りは５％となります。一般に、配当利回りが高いほうが株主への還元率が高いと判断されます。",
        "choice3": "「会社の収益性や経営効率を測る指標として、ROE（自己資本利益率）があります。X 社のROE は 10% です。一般に、ROE が高い会社ほど、自己資本の効率的な活用がなされていると判断できます。」",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1304,
        "shikenId": 20,
        "no": 5,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/yoso/534_1.png'/>",
        "question2": "次に、 M さんは Y 投資信託の費用と課税関係について説明した。M さんの A さんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「信託財産留保額は、投資信託の資産を売却する際に発生する手数料等を、投資信託を換金する投資家に負担してもらうことを目的として設定されているものですが、Y 投資信託ではかかりません。」",
        "choice2": "「運用管理費用 （信託報酬）は、投資信託を保有する投資家が間接的に負担する費用であり、日々差し引かれます。一般に、Y 投資信託のようなインデックス型投資信託よりも、アクティブ型投資信託のほうが高めに設定される傾向があります。",
        "choice3": "「 Y 投資信託を基準価額 12, 300 円（１万口当たり）で１万口購入した後、最初の決算時に 1 万口当たり 500 円の収益分配金が支払われ、分配落ち後の基準価額が 12, 100 円（ 1 万口当たり）となった場合、その収益分配金は、全額が元本払戻金（特別分配金）として非課税となります」",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1305,
        "shikenId": 20,
        "no": 6,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/534_1.png'/>",
        "question2": "最後に、Ｍさんは、「ＮＩＳＡのつみたて投資枠」についてアドバイスした。ＭさんのＡさんに対するアドバイスとして、次のうち最も不適切なものはどれか。",
        "choice1": "「ＮＩＳＡのつみたて投資枠の年間投資上限額は120万円で、購入は定期かつ継続的な買付けを行う方法に限定されます」",
        "choice2": "「ＮＩＳＡのつみたて投資枠を利用して購入した公募株式投資信託を解約した際に損失が生じた場合、その損失は、他の課税口座（特定口座など）の上場株式等の譲渡益と通算することができます」",
        "choice3": "「ＮＩＳＡのつみたて投資枠の対象となる金融商品は、長期の積立・分散投資に適した一定の商品性を有する公募株式投資信託やＥＴＦとされ、上場株式や債券はつみたて投資枠の対象ではありません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "金融",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1306,
        "shikenId": 20,
        "no": 7,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/yoso/537_1.png'/>",
        "question2": "Ａさんの本年分の所得税における総所得金額は、次のうちどれか。<br><img src='/img/yoso/537_2.png'/>",
        "choice1": "705 万円",
        "choice2": "725 万円",
        "choice3": "760 万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1307,
        "shikenId": 20,
        "no": 8,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/yoso/537_1.png'/>",
        "question2": "Ａさんの本年分の所得税における所得控除に関する以下の文章の空欄①～ ③に入る数値の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/yoso/538_1.png'/><br><img src='/img/yoso/538_2.png'/>",
        "choice1": "① 58　　② 38　　③ 38",
        "choice2": "① 38　　② 13　　③ 38",
        "choice3": "① 123　　② 26　　③ 63",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1308,
        "shikenId": 20,
        "no": 9,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/yoso/537_1.png'/>",
        "question2": "Ａさんの本年分の所得税における医療費控除に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「Ａさんが本年中に支払った医療費の金額の合計額が20万円を超えていない場合、医療費控除額は算出されません」",
        "choice2": "「Ａさんは、本年中に支払った医療費の領収書を勤務先に提出することで、年末調整において医療費控除の適用を受けることができます」",
        "choice3": "「生命保険契約から支払われた入院給付金や健康保険から支給を受けた高額療養費がある場合は、支払った医療費の総額からそれらの金額を控除する必要があります」",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1309,
        "shikenId": 20,
        "no": 10,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 4,
        "question1": "<img src='/img/yoso/540_1.png'/>",
        "question2": "甲土地に賃貸マンション（耐火建築物）を建築する場合の①建蔽率の上限となる建築面積と②容積率の上限となる延べ面積の組合せとして、次のうち最も適切なものはどれか。",
        "choice1": "①　1,120㎡　　　②　4,800㎡",
        "choice2": "①　1,120㎡　　　②　3,840㎡",
        "choice3": "①　1,280㎡　　　②　3,840㎡",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1310,
        "shikenId": 20,
        "no": 11,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/540_1.png'/>",
        "question2": "「被相続人の居住用財産（空き家）に係る譲渡所得の特別控除の特例」（以下、「本特例」という）に関する以下の文章の空欄①～③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/yoso/541_1.png'/>",
        "choice1": "①　1,000　　　②　1971（昭和 46 ）　            ③　１億",
        "choice2": "①　3,000　　　②　1981（昭和 56 ）　            ③　１億",
        "choice3": "①　3,000　　　②　1991（平成３）　             ③　１億 6,000 万",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1311,
        "shikenId": 20,
        "no": 12,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/yoso/540_1.png'/>",
        "question2": "甲土地の有効活用に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「建設協力金方式により、甲土地上に建築した店舗をテナントに貸し出す手法が考えられます。契約期間満了後、借主であるテナントが建物を撤去し、甲土地は更地で返還されます」",
        "choice2": "「事業用定期借地権方式により、甲土地を一定期間賃貸する手法が考えられます。甲土地を手放さず、資金も不要で安定した地代収入を得ることができます」",
        "choice3": "「等価交換方式により、マンションを建築する手法が考えられます。Ａさんとしては、自己資金を使わず、マンション住戸を取得することができます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "不動産",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1312,
        "shikenId": 20,
        "no": 13,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/543_1.png'/>",
        "question2": "Ａさんの相続に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「本年分の所得税および復興特別所得税についてＡさんが確定申告書を提出しなければならない場合に該当するとき、相続人は、原則として、相続の開始があったことを知った日の翌日から４カ月以内に準確定申告書を提出しなければなりません」",
        "choice2": "「自宅に保管されていたＡさんの自筆証書遺言を相続人が発見した場合、相続人は、遅滞なく、自筆証書遺言を法務局に提出して、その検認を請求しなければなりません」",
        "choice3": "「相続税の申告書は、原則として、相続の開始があったことを知った日の翌日から10カ月以内に被相続人であるＡさんの死亡時の住所地を所轄する税務署長に提出しなければなりません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1313,
        "shikenId": 20,
        "no": 14,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/543_1.png'/>",
        "question2": "Ａさんの相続に関する以下の文章の空欄①～③に入る数値の組合せとして、 次のうち最も適切なものはどれか。<br><img src='/img/yoso/544_1.png'/>",
        "choice1": "①　4,200　　　②　1,500　　　③　4,800",
        "choice2": "①　4,800　　　②　3,500　　　③　1,200",
        "choice3": "①　4,800　　　②　1,500　　　③　1,200",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1314,
        "shikenId": 20,
        "no": 15,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/yoso/543_1.png'/>",
        "question2": "Ａさんの相続に係る課税遺産総額（「課税価格の合計額－遺産に係る基礎控除額」）が２億4,000万円であった場合の相続税の総額は、次のうちどれか。<br><img src='/img/yoso/545_1.png' style='width:500px'/>",
        "choice1": "5,100万円",
        "choice2": "5,300万円",
        "choice3": "8,100万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1315,
        "shikenId": 21,
        "no": 1,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/546_1.png'/>",
        "question2": "まず、M さんは、《設例》の〈 A さんに関する資料〉に基づき、A さんが老齢基礎年金の受給を65 歳から開始した場合の年金額（本年度価額）を試算した。M さんが試算した老齢基礎年金の年金額の計算式として、次のうち最も適切なものはどれか。",
        "choice1": "831,700円 × 327月 / 480月",
        "choice2": "831,700円 × 447月 / 480月",
        "choice3": "831,700円 ×（447月＋ 33月× 1 / 3）/ 480月",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1316,
        "shikenId": 21,
        "no": 2,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 4,
        "question1": "<img src='/img/yoso/546_1.png'/>",
        "question2": "次に、Ｍさんは、老後の年金収入を増やすための各種方法について説明した。Ｍさんが、Ａさんに対して説明した以下の文章の空欄①～③に入る語句の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/yoso/547_1.png'/>",
        "choice1": "①　70,000円　　　②　48,000円　　　③　一時所得",
        "choice2": "①　68,000円　　　②　48,000円　　　③　退職所得",
        "choice3": "①　68,000円　　　②　24,000円　　　③　退職所得",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1317,
        "shikenId": 21,
        "no": 3,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/yoso/546_1.png'/>",
        "question2": "最後に、Ｍさんは、確定拠出年金の個人型年金（以下、「個人型年金」という）について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「個人型年金のメリットとして、税制の優遇措置が挙げられます。加入者が拠出する掛金は、その全額が小規模企業共済等掛金控除として所得控除の対象となります。」",
        "choice2": "「年金の老齢給付金を 60 歳から受け取ることができるのは、通算加入者等期間が 20 年以上ある場合です。」",
        "choice3": "「個人型年金の実施機関は国民年金基金連合会であり、加入時には手数料が必要ですが、それ以降に負担する手数料はありません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "ライフ",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1318,
        "shikenId": 21,
        "no": 4,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/yoso/549_1.png'/><br><img src='/img/yoso/549_2.png'/>",
        "question2": "はじめに、Ｍさんは、必要保障額の考え方について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「Ａさんの必要保障額の計算上、住宅ローンの残債務は遺族に必要な生活資金等の支出の総額に含める必要があります」",
        "choice2": "「Ａさんのような会社員と個人事業主とでは、遺族が受け取る公的年金等の総額や、死亡退職金の有無など、必要保障額を計算する際の条件が異なります。他の条件が同じ場合、一般に、会社員よりも個人事業主のほうが、遺族年金の総額が少ないケースが多くなっています」",
        "choice3": "「必要保障額は、通常、末子誕生時が最大となり、その後、子どもの成長とともに逓減していきますので、期間の経過に伴って年金受取総額が逓減していく収入保障保険で死亡保障を準備することも１つの方法です」",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1319,
        "shikenId": 21,
        "no": 5,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/yoso/549_1.png'/><br><img src='/img/yoso/549_2.png'/>",
        "question2": "次に、Ｍさんは、生命保険の見直しについて説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「提案を受けた終身介護保障保険の保険料払込期間を有期払込にすることで、毎月の保険料負担は減少し、保険料の払込総額も少なくなります。月々の保険料負担を軽減するために有期払込を選択することをお勧めします」",
        "choice2": "「契約転換制度を活用して現在加入している定期保険特約付終身保険を転換し、介護保障を準備することもできます。転換後の保険料は転換時点の年齢・保険料率で計算されますが、転換することで、新規に加入する場合と比較し、保険料負担を抑えることができます」",
        "choice3": "「契約転換制度利用時には、告知や医師の診査等が不要のため、健康状態にかかわらず、保障内容を見直すことができます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1320,
        "shikenId": 21,
        "no": 6,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/yoso/549_1.png'/><br><img src='/img/yoso/549_2.png'/>",
        "question2": "最後に、Ｍさんは、Ａさんが提案を受けた生命保険の課税関係について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「提案を受けた生命保険の支払保険料は、生命保険料控除の一つである介護医療保険料控除の対象となります。介護医療保険料控除の控除限度額は、所得税で40,000円、住民税で28,000円です」",
        "choice2": "「Ａさんが介護一時金を請求できない特別な事情がある場合、指定代理請求人である妻ＢさんがＡさんに代わって請求することができます。妻Ｂさんが受け取る当該一時金は、一時所得として総合課税の対象となります」",
        "choice3": "「Ａさんが当該生命保険から介護終身年金を受け取った場合、Ａさんは所得税の確定申告をしなければなりません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1321,
        "shikenId": 21,
        "no": 7,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/552_1.png'/>",
        "question2": "仮に、将来Ｘ社がＡさんに役員退職金4,000万円を支給した場合、Ａさんが受け取る役員退職金に係る退職所得の金額として、次のうち最も適切なものはどれか。なお、Ａさんの役員在任期間（勤続年数）を36年とし、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。",
        "choice1": "740万円",
        "choice2": "1,040万円",
        "choice3": "1,920万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1322,
        "shikenId": 21,
        "no": 8,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 4,
        "question1": "<img src='/img/yoso/552_1.png'/>",
        "question2": "Ｍさんは＜資料１＞の生命保険について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「当該生命保険の第１回保険料払込時の支払保険料90万円のうち、前払保険料36万円を資産に計上し、残りの54万円は定期保険料として損金の額に算入することができます」",
        "choice2": "「当該生命保険から死亡保険金をＸ社が受け取った場合、資産計上額との差額を雑収入として益金の額に算入します」",
        "choice3": "「当該生命保険の単純返戻率（解約返戻金額÷払込保険料累計額）は、保険始期から徐々に上昇し、保険期間満了直前にピークを迎え、保険期間終了時には急激に減少し、ゼロとなります」",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1323,
        "shikenId": 21,
        "no": 9,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/yoso/552_1.png'/>",
        "question2": "Ｍさんは＜資料２＞の医療保険について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「Ａさんが入院し、Ｘ社が受け取った入院給付金は、その全額が非課税となります」",
        "choice2": "「Ａさんが入院中に公的医療保険制度の手術料の算定対象となる所定の手術を受けた場合には20万円、所定の外来手術を受けた場合には５万円の手術給付金が支払われます」",
        "choice3": "「当該生命保険の支払保険料は、その全額を損金に算入することができます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "リスク",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1324,
        "shikenId": 21,
        "no": 10,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 4,
        "question1": "<img src='/img/yoso/555_1.png'/>",
        "question2": "Ａさんの本年分の所得税における総所得金額は、次のうちどれか。<br><img src='/img/yoso/555_2.png'/>",
        "choice1": "550 万円",
        "choice2": "575 万円",
        "choice3": "580 万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1325,
        "shikenId": 21,
        "no": 11,
        "answerType": 2,
        "groupId": 0,
        "answer": 3,
        "score": 3,
        "question1": "<img src='/img/yoso/555_1.png'/>",
        "question2": "Ａさんの本年（2025 年）分の所得税における所得控除の控除額に関する以下の文章の空欄①～③に入る数値の組合せとして、次のうち最も適切なものはどれか。<br><img src='/img/yoso/556_1.png'/>",
        "choice1": "①　48　　　②　38　　　③　58",
        "choice2": "①　48　　　②　48　　　③　48",
        "choice3": "①　38　　　②　38　　　③　63",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1326,
        "shikenId": 21,
        "no": 12,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/yoso/555_1.png'/>",
        "question2": "Ａさんの本年分の所得税の課税等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「総所得金額に算入される一時所得の金額が20万円を超えるため、Ａさんは所得税の確定申告が必要です」",
        "choice2": "「Ａさんは、所得税の確定申告をすると、ふるさと納税で寄附した12万円の全額について、本年分の所得税額から控除されます」",
        "choice3": "「Ａさんが生命保険料控除として総所得金額から控除することができる金額は５万円です」",
        "choice4": "",
        "choice5": "",
        "categoryName": "タックス",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1327,
        "shikenId": 21,
        "no": 13,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 3,
        "question1": "<img src='/img/yoso/558_1.png'/>",
        "question2": "本年中の生前贈与に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「Ａさんが長女Ｃさんに現金を贈与し、長女Ｃさんが暦年課税を選択した場合、その年にＡさんから長女Ｃさんへ贈与した財産の価額が贈与税の基礎控除額を超えるときは、贈与したＡさんが贈与税の申告書を提出しなければなりません」",
        "choice2": "「Ａさんが長女Ｃさんに現金を贈与し、長女Ｃさんが相続時精算課税制度を選択した場合、その選択をした年分以降にＡさんから長女Ｃさんへ贈与する財産について、暦年課税へ変更することはできません」",
        "choice3": "「Ａさんが長女Ｃさんに現金を贈与し、長女Ｃさんが相続時精算課税制度を選択した場合、特別控除額として累計で2,000万円までの贈与について贈与税は課されません」",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1328,
        "shikenId": 21,
        "no": 14,
        "answerType": 2,
        "groupId": 0,
        "answer": 2,
        "score": 4,
        "question1": "<img src='/img/yoso/558_1.png'/>",
        "question2": "Ａさんの相続等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「仮にＡさんに相続が発生し、Ａさんの自宅（実家）を相続により取得した長女Ｃさんまたは長男Ｄさんが、『被相続人の居住用財産（空き家）に係る譲渡所得の特別控除の特例』の適用を受けて、その財産を譲渡した場合、最高1,000万円の特別控除の適用を受けることができます」",
        "choice2": "「契約者（＝保険料負担者）および被保険者をＡさん、死亡保険金受取人を推定相続人とする終身保険に加入することをお勧めします。死亡保険金受取人が受け取る死亡保険金は、『500万円×法定相続人の数』を限度として、死亡保険金の非課税金額の規定の適用を受けることができます」",
        "choice3": "「遺産分割を円滑に行うために遺言書の作成をお勧めします。自筆証書遺言は、その遺言の全文および財産目録をパソコンで作成し、日付および氏名を自書して押印することで作成することができます」",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    },
    {
        "id": 1329,
        "shikenId": 21,
        "no": 15,
        "answerType": 2,
        "groupId": 0,
        "answer": 1,
        "score": 3,
        "question1": "<img src='/img/yoso/558_1.png'/>",
        "question2": "仮に、長男Ｄさんが暦年課税（各種非課税制度の適用はない）により、本年中にＡさんから現金500万円の贈与を受けた場合の贈与税額は、次のうちどれか。<br><img src='/img/yoso/560_1.png'/>",
        "choice1": "48.5 万円",
        "choice2": "68.5 万円",
        "choice3": "70 万円",
        "choice4": "",
        "choice5": "",
        "categoryName": "相続",
        "rontenName": "",
        "important": ""
    }
]